import { NAME_MAX_LENGTH, NAME_MIN_LENGTH } from "../constants/names"
import { SWAP_LIST_MAX_LIMIT } from "../constants/patientSwap"
import { MAX_QUERY_LENGTH, MAX_SLUG_LENGTH, MIN_PASSWORD_LENGTH, MIN_SLUG_LENGTH } from "../constants/validationLimits"
import { MAX_LIMIT, MIN_LIMIT } from "../enums/pages"

export const NL = {
  accepted: "Geaccepteerd",
  accessRights: "Toegangsrechten",
  increment: "Verhogen",
  decrement: "Verlagen",
  actions: "Acties",
  add: "Toevoegen",
  agbCode: "AGB-code",
  agenda: "Agenda",
  answered: "Beantwoord",
  approved: "Goedgekeurd",
  areYouSure: "Weet je het zeker?",
  assignment: "Toewijzing",
  cancel: "Annuleren",
  caregiver: "Zorgverlener",
  closed: "Gesloten",
  completed: "Afgerond",
  copy: "Kopiëren",
  copyAndEdit: "Eigen versie maken",
  count: "Aantal",
  countryOfBirth: "Geboorteland",
  created: "Aangemaakt",
  createdAt: "Aanmaakdatum",
  date: "Datum",
  defaultFollowUp: "Standaard opvolging",
  "delete.confirm": "Ja, verwijderen",
  "delete.confirmTitle": "Deze actie kan niet ongedaan worden",
  delete: "Verwijderen",
  email: "E-mail",
  communication: "Communicatie",
  duplicate_link: "Koppeling",
  description: "Beschrijving",
  followUp: "Opvolging",
  isAdmin: "Is admin",
  label: "Label",
  labels: "Labels",
  less: "Minder",
  "locale.en-GB": "Engels",
  "input.en-GB": "Engelse tekst",
  "locale.nl-NL": "Nederlands",
  "input.nl-NL": "Nederlandse tekst",
  logo: "Logo",
  me: "Ik",
  totpEnabled: "2FA ingeschakeld",
  more: "Meer",
  new: "Nieuw",
  "no.data.found": "Niks gevonden",
  "data.loading": "We halen de gegevens voor je op. Dit kan eventjes duren.",
  "table.showAll": "Toon alle",
  "table.showLess": "Toon minder",
  no: "Nee",
  none: "Geen",
  notApplicable: "n.v.t.",
  notLinked: "Niet gekoppeld",
  ok: "Oké",
  open: "Open",
  "options.open": "Opties openen",
  options: "Opties",
  send: "Versturen",
  resolve: "Oplossen",
  retry: "Opnieuw proberen",
  loading: "Laden...",
  submit: "Opslaan",

  "pageNotFound.description":
    "Er kunnen verschillende redenen zijn. Kijk of je de juiste URL hebt ingevoerd. Misschien is de pagina verwijderd of heb je geen toegang meer.",
  "pageNotFound.title": "Pagina niet gevonden",

  "pageInvitation.send.registration": "Inschrijflink delen",
  "pageInvitation.send.appointment": "Afspraaklink delen",

  "pageInvitation.modal.title.registration": "Eenmalige inschrijflink delen",
  "pageInvitation.modal.title.appointment": "Eenmalige afspraaklink delen",

  "pageInvitation.field.practice": "Praktijk",
  "pageInvitation.field.practice.placeholder": "Kies een praktijk",
  "pageInvitation.field.page": "Pagina",
  "pageInvitation.field.page.placeholder": "Kies een pagina",
  "pageInvitation.field.recipientEmail": "E-mailadres ontvanger",
  "pageInvitation.field.recipientEmail.placeholder": "naam@voorbeeld.nl",
  "pageInvitation.field.recipientPatient": "Patiënt",
  "pageInvitation.field.recipientPatient.email": "De uitnodiging wordt verstuurd naar {email}.",
  "pageInvitation.field.recipientPatient.noEmail":
    "Deze patiënt heeft geen e-mailadres in het dossier. Kies een andere patiënt of vul eerst een e-mailadres aan.",
  "pageInvitation.field.message": "Bericht",
  "pageInvitation.message.default.registration":
    "Met deze persoonlijke link kun je je inschrijven bij onze praktijk. Klik op de link en doorloop de stappen om de inschrijving af te ronden.",
  "pageInvitation.message.default.appointment":
    "Met deze persoonlijke link kun je een afspraak maken bij onze praktijk. Klik op de link en kies een geschikt moment.",
  "pageInvitation.infoBanner.registration":
    "De link werkt ook als de gekozen inschrijf site pagina is gesloten voor inschrijvingen.",
  "pageInvitation.infoBanner.registration.withoutPageChoice":
    "De link werkt ook als de praktijk is gesloten voor inschrijvingen.",
  "pageInvitation.infoBanner.appointment": "Deze link slaat de consultvoorbereidende vragenlijst over.",
  "pageInvitation.conditions.label": "Vink hier de dingen aan die bij deze inschrijving van toepassing zijn:",
  "pageInvitation.conditions.description":
    "We hebben vast de dingen aangevinkt die normaal gezien (bij jullie reguliere inschrijvingen) van toepassing zijn.",
  "pageInvitation.conditions.description.passant":
    "We hebben vast de dingen aangevinkt die normaal gezien (bij een passant) van toepassing zijn.",
  "pageInvitation.conditions.type.label": "Type inschrijving",
  "pageInvitation.conditions.type.regular": "Normaal",
  "pageInvitation.conditions.type.passant": "Passant",
  "pageInvitation.conditions.folded": "Met dezelfde voorwaarden als jullie gewone inschrijvingen.",
  "pageInvitation.conditions.adjust": "Aanpassen",
  "pageInvitation.conditions.enforcePostalCodeArea": "Woont binnen postcodegebied",
  "pageInvitation.conditions.bsnRequired": "BSN verplicht",
  "pageInvitation.conditions.bsnRequired.hint":
    "Alleen uitzetten als de patiënt geen BSN heeft (bijvoorbeeld een toerist of expat). Zonder BSN vragen we niet naar de zorgverzekering.",
  "pageInvitation.conditions.bsnOnly":
    "De volgende acties kunnen alleen worden uitgevoerd als de patiënt een BSN invult:",
  "pageInvitation.conditions.vecozoCov": "COV check (verzekeringsgegevens controleren)",
  "pageInvitation.conditions.vecozoIon": "Aanmelden bij ION (inschrijving op naam)",
  "pageInvitation.conditions.previousGpLetter": "Brief aan vorige huisarts (verzoek tot uitschrijving)",
  "pageInvitation.conditions.pharmacyRequired": "Apotheek verplicht",
  "pageInvitation.warning.noPagesForPractice.registration":
    "Deze praktijk heeft nog geen inschrijfpagina. Maak er eerst een aan via Instellingen → Algemeen → Site pagina's.",
  "pageInvitation.warning.noPagesForPractice.appointment":
    "Deze praktijk heeft nog geen afspraakpagina. Maak er eerst een aan via Instellingen → Algemeen → Site pagina's.",
  "pageInvitation.warning.existingActiveInvitation":
    "Er bestaat al een actieve uitnodiging voor dit e-mailadres. Door nu een nieuwe link te versturen blijft de vorige ook geldig totdat die verloopt.",
  "pageInvitation.shareVia.label": "Delen via",
  "pageInvitation.shareVia.email": "E-mail",
  "pageInvitation.shareVia.link": "Link",
  "pageInvitation.shareVia.qr": "QR-code",
  "pageInvitation.link.description": "Deze link werkt één keer, en is niet gekoppeld aan een e-mailadres of persoon.",
  "pageInvitation.link.requiresPage": "Kies eerst een praktijk met een geschikte pagina om een link aan te maken.",
  "pageInvitation.link.generateFailed": "Het aanmaken van de link is mislukt.",
  "pageInvitation.link.copy": "Kopiëren",
  "pageInvitation.link.copied": "Gekopieerd",
  "pageInvitation.link.copiedToast": "Link en geldigheidsdatum gekopieerd",
  "pageInvitation.link.copyFailed":
    "Kopiëren is niet gelukt. De link is geselecteerd; kopieer deze handmatig (Ctrl+C / Cmd+C).",
  "pageInvitation.qr.description": "Deze QR-code werkt één keer, en is niet gekoppeld aan een e-mailadres of persoon.",
  "pageInvitation.qr.requiresPage": "Kies eerst een praktijk met een geschikte pagina om een QR-code aan te maken.",
  "pageInvitation.qr.generateFailed": "Het aanmaken van de QR-code is mislukt.",
  "pageInvitation.qr.generate": "QR-code aanmaken",
  "pageInvitation.qr.generateAnother": "Nog een QR-code aanmaken",
  "pageInvitation.qr.settingsChanged":
    "De instellingen zijn gewijzigd sinds deze QR-code is aangemaakt. Maak een nieuwe QR-code aan om ze toe te passen.",
  "pageInvitation.qr.expiresOn": "De QR-code is geldig tot {date}.",
  "pageInvitation.link.generate": "Link aanmaken",
  "pageInvitation.link.generateAnother": "Nog een link aanmaken",
  "pageInvitation.link.createdOn": "Aangemaakt op {date}.",
  "pageInvitation.link.settingsChanged":
    "De instellingen zijn gewijzigd sinds deze link is aangemaakt. Maak een nieuwe link aan om ze toe te passen.",
  "pageInvitation.preview.show": "Voorbeeld bekijken",
  "pageInvitation.preview.edit": "Bericht bewerken",
  "pageInvitation.preview.requiresPage":
    "Kies eerst een praktijk met een geschikte pagina om het e-mailvoorbeeld te zien.",
  "pageInvitation.preview.unavailable": "E-mailvoorbeeld is niet beschikbaar voor deze praktijk.",
  "pageInvitation.submit": "Versturen",
  "pageInvitation.cancel": "Annuleren",
  "pageInvitation.share.heading": "De uitnodiging is verstuurd",
  "pageInvitation.share.emailSent": "De link is per e-mail naar {email} gestuurd.",
  "pageInvitation.share.emailFailed":
    "Het versturen van de e-mail is mislukt. Kopieer de link hieronder en deel deze handmatig met {email}.",
  "pageInvitation.share.expiresOn": "De link is geldig tot {date}.",
  "pageInvitation.share.sendAnother": "Nog een uitnodiging versturen",
  "pageInvitation.share.close": "Sluiten",

  "userInvitation.add": "Medewerker uitnodigen",
  "userInvitation.invite.admin": "Uitnodiging",
  "userInvitation.modal.subtitle": "De medewerker ontvangt een eenmalige uitnodigingslink per e-mail.",
  "userInvitation.modal.subtitle.admin":
    "Beheer als admin. De medewerker krijgt in één keer toegang tot de gekozen praktijken.",
  "userInvitation.field.admin": "Beheerder",
  "userInvitation.field.temporaryAccess": "Tijdelijke toegang",
  "userInvitation.field.practices": "Praktijken",
  "userInvitation.field.practices.placeholder": "Kies praktijken",
  "userInvitation.field.email.helper": "De uitnodiging wordt naar dit adres gestuurd.",
  "userInvitation.field.validUntil.helper":
    "De toegang vervalt op deze datum. De uitnodigingslink zelf vervalt na 7 dagen — kan opnieuw verstuurd worden.",
  "userInvitation.submit": "Uitnodiging versturen",
  "userInvitation.error.duplicate":
    "Er bestaat al een actieve uitnodiging voor deze naam en dit e-mailadres. Gebruik 'opnieuw versturen' of trek de bestaande uitnodiging in.",
  "userInvitation.toast.sent": "Uitnodiging verzonden",
  "userInvitation.toast.resent": "Uitnodiging opnieuw verzonden",
  "userInvitation.toast.withdrawn": "Uitnodiging ingetrokken",
  "userInvitation.toast.emailFailed":
    "De uitnodiging is aangemaakt, maar de e-mail kon niet worden verzonden. Probeer opnieuw te versturen.",
  "userInvitation.toast.actionFailed": "Actie mislukt, probeer het opnieuw.",
  "userInvitation.toast.someAlreadyInvited":
    "{count, plural, one {# praktijk had al een uitnodiging en is overgeslagen} other {# praktijken hadden al een uitnodiging en zijn overgeslagen}}.",
  "userInvitation.table.title": "Openstaande uitnodigingen",
  "userInvitation.table.empty": "Geen openstaande uitnodigingen",
  "userInvitation.column.status": "Status",
  "userInvitation.column.practice": "Praktijk",
  // Verloopdatum van de uitnodigingslink zelf, niet de `validUntil` van de toegang
  "userInvitation.column.expires": "Link verloopt",
  "userInvitation.status.sent": "Uitnodiging verzonden",
  "userInvitation.status.expired": "Uitnodiging verlopen",
  "userInvitation.action.resend": "Uitnodiging opnieuw versturen",
  "userInvitation.action.withdraw": "Uitnodiging intrekken",
  "userInvitation.withdraw.confirm": "Weet je zeker dat je deze uitnodiging wilt intrekken?",
  "userInvitation.public.invite": "Uitnodiging",
  "userInvitation.public.accept.welcome": "Welkom, {name}",
  "userInvitation.public.accept.subtitle": "{scope} heeft je uitgenodigd om toegang te krijgen tot de praktijk.",
  "userInvitation.public.accept.subtitle.bare": "Je bent uitgenodigd voor MijnPraktijk.",
  "userInvitation.public.accept.existing.one":
    "Op dit e-mailadres staat al een account. Log in om het te koppelen aan deze uitnodiging.",
  "userInvitation.public.accept.existing.many":
    "Op dit e-mailadres staan meerdere accounts. Kies er één en log in om het te koppelen aan deze uitnodiging.",
  "userInvitation.public.accept.loginWith": "Log in met je account",
  "userInvitation.public.accept.createNew": "Een nieuw account aanmaken",
  "userInvitation.public.accept.createNew.subtitle": "Apart account voor MijnPraktijk",
  "userInvitation.public.accept.or": "of",
  "userInvitation.public.accept.unexpected":
    "Komt deze uitnodiging onverwacht? Negeer deze pagina, of neem contact op met de praktijkmanager.",
  "userInvitation.public.accept.expired.title": "Uitnodiging niet beschikbaar",
  "userInvitation.public.accept.expired.body":
    "Deze uitnodiging is verlopen of al gebruikt. Vraag de afzender om een nieuwe uitnodiging.",
  "userInvitation.public.accept.connecting": "Bezig met koppelen…",
  "userInvitation.public.accept.error":
    "Het koppelen van je account is mislukt. Mogelijk hoort dit account niet bij het uitgenodigde e-mailadres. Je kunt de praktijkbeheerder vragen om een nieuwe link.",
  "userInvitation.public.accept.createTitle": "Je gegevens",
  "userInvitation.public.accept.createSubtitle": "Vul je naam in en kies een gebruikersnaam en wachtwoord.",
  "userInvitation.public.accept.usernameHint": "Alleen letters, cijfers, punten en koppeltekens. Minimaal 5 tekens.",
  "userInvitation.public.accept.passwordHint": "Minimaal {min} tekens, met letter, cijfer en speciaal teken.",
  "userInvitation.public.accept.step.details": "Gegevens",
  "userInvitation.public.accept.step.twoFactor": "Tweestapsverificatie",
  "userInvitation.public.accept.totpTitle": "Stel tweestapsverificatie in",
  "userInvitation.public.accept.totpSubtitle": "Wij vereisen 2FA voor toegang tot patiëntgegevens.",

  "pagination.columnSelect": "Kolommen selecteren",
  "pagination.searchOptions": "Zoekopties",
  "pagination.searchOptions.reset": "Alles inschakelen",
  "pagination.filter.apply": "Toepassen",
  "pagination.filter.clear": "Filters wissen",
  "pagination.filter.remove": "Verwijder filter",
  "pagination.filter": "Filters",
  "pagination.next": "Volgende",
  "pagination.perPage": "{value} per pagina",
  "pagination.previous": "Vorige",
  "pagination.show": "Toon",
  "pagination.total": "{total, plural, one {# resultaat} other {# resultaten}}",

  insurerName: "Naam zorgverzekeraar",
  insuranceNumber: "Polisnummer",
  pharmacy: "Apotheek",
  priority: "Prioriteit",
  "questionnaireName.dropdown": "Selecteer vragenlijst",
  questionnaireName: "Naam vragenlijst",
  readMore: "Lees meer",
  rejected: "Afgewezen",
  reply: "Reactie",
  scrollToBottom: "Scroll naar beneden",
  sentToHis: "Verstuurd naar HIS",
  showMore: "Toon meer",
  showPatient: "Toon patiënt",
  state: "Status",
  status: "Status",
  sentToHisStatus: "Verzendstatus",
  statusChangedTo: "Status gewijzigd naar {status}",
  subject: "Onderwerp",
  task: "Taak",
  time: "Tijd",
  to: "tot",
  today: "Vandaag",
  type: "Type",
  unanswered: "Niet beantwoord",
  undecided: "Te verwerken",
  processing: "Wordt verwerkt",
  unknown: "Onbekend",
  urgency: "Urgentie",
  walkInConsult: "Digitaal inloopspreekuur",
  title: "Titel",
  subTitle: "Subtitel",
  sender: "Verzender",
  receiver: "Ontvanger",
  yes: "Ja",
  "yesOrNo.select": "Selecteer ja of nee",
  "important.text": "Let op",
  expandWithCount: "+ nog {count, plural, one {#} other {#}}",
  approximateDistance: "Afstand ongeveer",
  active: "Actief",
  inactive: "Inactief",
  enabled: "Actief",
  "action.enable": "Activeer",
  disabled: "Uit",
  "action.disable": "Zet uit",

  "error.fallback.title": "Er is iets misgegaan",
  "error.fallback.description":
    "Excuus, er is iets onverwacht gebeurd. Ons team is op de hoogte gebracht. Je kunt de pagina herladen en het opnieuw proberen.",
  "error.fallback.tryAgain": "Opnieuw proberen",

  "limit.reached": "Limiet van {limit} bereikt",

  edit: "Wijzigen",
  "edit.cancel": "Wijziging annuleren",

  validUntil: "Geldig tot",
  "validUntil.inactive": "Gedeactiveerd",
  "validUntil.inactive.reason":
    "Dit account is automatisch gedeactiveerd, omdat er {weeks} weken niet is ingelogd. Laatst actief: {lastActivity}",

  "filter.next7days": "Komende 7 dagen",
  "filter.next30days": "Komende 30 dagen",
  "filter.all": "Alle",
  "filter.past7days": "Afgelopen 7 dagen",
  "filter.past30days": "Afgelopen 30 dagen",
  "filter.past3months": "Afgelopen 3 maanden",
  "filter.past6months": "Afgelopen 6 maanden",
  "filter.pastYear": "Afgelopen jaar",
  "filter.custom": "Aangepast",
  "filter.from": "Van",
  "filter.to": "Tot",

  "sortBy.default.ASC": "Oplopend",
  "sortBy.default.DESC": "Aflopend",
  "sortBy.alphabetical.ASC": "A - Z",
  "sortBy.alphabetical.DESC": "Z - A",
  "sortBy.numeric.ASC": "Laag naar hoog",
  "sortBy.numeric.DESC": "Hoog naar laag",
  "sortBy.age.ASC": "Jong - oud",
  "sortBy.age.DESC": "Oud - jong",
  "sortBy.distance.ASC": "Dichtbij eerst",
  "sortBy.distance.DESC": "Ver weg eerst",
  "sortBy.boolean.ASC": "Ja eerst",
  "sortBy.boolean.DESC": "Ja laatst",
  "sortBy.date.ASC": "Oudste eerst",
  "sortBy.date.DESC": "Recente eerst",
  "sortBy.postalCode.ASC": "1000 - 9999",
  "sortBy.postalCode.DESC": "9999 - 1000",
  "sortBy.clear": "Verwijder sortering",

  "emptyState.noData.title": "Niets gevonden",
  "emptyState.noData.description": "Hier is op het moment nog geen data beschikbaar.",
  "emptyState.filtered.title": "Geen resultaten met deze filters",
  "emptyState.filtered.description": "We kunnen geen data vinden met de gebruikte zoekopdracht of filters.",

  name: "Naam",
  "name.required": "Naam is vereist",
  "name.unique": "Naam moet uniek zijn",

  icpc: "ICPC-code",
  icpcCode: "ICPC-code",
  "icpcCode.placeholder": "Zoek ICPC-code",
  "icpcCode.search": "Typ om ICPC-code te zoeken",
  "icpcCode.required": "ICPC-code is verplicht",

  "notes.add.tooltip": "Notities toevoegen",
  "notes.added.successfully": "Notitie toegevoegd",
  "notes.updated.successfully": "Notitie gewijzigd",
  "notes.removed.successfully": "Notitie verwijderd",

  "copyToClipboard.click": "Klik om te kopiëren",
  "copyToClipboard.copied": "Gekopieerd",

  "practiceSearch.title": "Welkom bij {name}",
  "practiceSearch.national.title": "Vind hier uw nieuwe huisarts",
  "practiceSearch.national.subtext":
    "Bekijk welke huisartsenpraktijken bij u in de buurt nieuwe patiënten aannemen en schrijf u direct online in.",
  "practiceSearch.searchZipCode": "Wat is uw postcode?",
  "practiceSearch.searchZipCode.placeholder": "Vul je postcode in, bijv. 2512 AB",
  "practiceSearch.searchZipCode.submit": "Zoek huisarts",
  "practiceSearch.searchZipCode.reset": "Zoekopdracht wijzigen",
  "practiceSearch.searchZipCode.results": "Zoekresultaten",
  "practiceSearch.searchZipCode.noResults":
    "Helaas, we hebben geen huisartsenpraktijken gevonden die patiënten aannemen in uw postcodegebied",
  "practiceSearch.searchZipCode.noResults.clarification":
    "Dit betekent niet dat ze er niet zijn: misschien zijn ze niet bij ons aangemeld. Bekijk websites van huisartsenpraktijken in uw buurt om erachter te komen of ze patiënten aannemen.",
  "practiceSearch.searchZipCode.register": "Inschrijven",
  "practiceSearch.searchZipCode.registrationClosed": "Deze praktijk neemt nu geen inschrijvingen aan",
  "practiceSearch.searchZipCode.disclaimer":
    "Is er geen geschikte huisartsenpraktijk in uw postcodegebied? Neem dan contact op met uw zorgverzekeraar.",

  "postalCodeWaitingList.title": "Zullen we u laten weten als er plek is?",
  "postalCodeWaitingList.description":
    "Sommige praktijken zijn nu gesloten voor inschrijvingen.{br}Wilt u een e-mail ontvangen wanneer een praktijk in uw postcodegebied ({postalCode}) open gaat? ",
  "postalCodeWaitingList.email.placeholder": "E-mailadres",
  "postalCodeWaitingList.numberOfPeople.prefix": "Ik zoek plek voor",
  "postalCodeWaitingList.numberOfPeople.suffix": "personen",
  "postalCodeWaitingList.submit": "Hou me op de hoogte",
  "postalCodeWaitingList.success.title": "Bevestig uw e-mailadres",
  "postalCodeWaitingList.success.description":
    "We hebben een e-mail gestuurd naar {email}. Klik op de link in de e-mail om uw aanmelding te bevestigen.",
  "postalCodeWaitingList.verify.title": "E-mail geverifieerd",
  "postalCodeWaitingList.verify.description":
    "Uw e-mailadres is succesvol geverifieerd.{br}Wij sturen u een e-mail zodra er een praktijk in uw regio opengaat voor inschrijvingen.",
  "postalCodeWaitingList.error.title": "Er is iets misgegaan",
  "postalCodeWaitingList.error.description":
    "We konden uw e-mailadres niet verifiëren. Probeer het opnieuw door deze pagina opnieuw te laden of probeer het later opnieuw.",
  "postalCodeWaitingList.reload": "Pagina opnieuw laden",
  "postalCodeWaitingList.invalidVerificationCode": "Ongeldige verificatiecode",
  "postalCodeWaitingList.settings.title": "Bevestigd",
  "postalCodeWaitingList.settings.description":
    "U ontvangt een e-mail wanneer een van onderstaande praktijken open gaat voor inschrijvingen.",
  "postalCodeWaitingList.settings.subtitle": "Huisartsen in postcodegebied {postalCode}",
  "postalCodeWaitingList.settings.update.success": "Uw instellingen zijn succesvol opgeslagen.",
  "postalCodeWaitingList.unsubscribe.title": "Geen e-mails meer over nieuwe praktijken in uw buurt",
  "postalCodeWaitingList.unsubscribe.description":
    "Als u niets doet, wordt u automatisch na drie maanden afgemeld.{br}{br}Klik op de knop hieronder om u meteen af te melden. U kunt zich later altijd weer aanmelden.",
  "postalCodeWaitingList.unsubscribe.confirm": "Nu afmelden",
  "postalCodeWaitingList.unsubscribe.success.title": "Afgemeld",
  "postalCodeWaitingList.unsubscribe.success.description":
    "U bent succesvol afgemeld.{br}U ontvangt geen meldingen meer over praktijken in dit postcodegebied.",
  "postalCodeWaitingList.unsubscribe.error.title": "Er is iets misgegaan",
  "postalCodeWaitingList.unsubscribe.error.description":
    "We konden u niet afmelden. Probeer het opnieuw door op de knop te klikken of probeer het later opnieuw.",

  careGroups: "Zorggroepen",
  careGroup: "Zorggroep",
  "careGroup.settings": "Zorggroep instellingen",
  "careGroup.name": "Naam",
  "careGroup.name.placeholder": "Vul naam in",
  "careGroup.slug": "Slug",
  "careGroup.slug.placeholder": "Vul de tekst voor de domeinnaam in",
  "careGroup.slug.fullAddress": "Het webadres is: ",
  "careGroup.logo": "Logo",
  "careGroup.select.placeholder": "Kies zorggroep",
  "careGroup.create.success": "Zorggroep {name} toegevoegd",
  "careGroup.page.general": "Algemeen",
  "careGroup.page.serviceArea": "Postcodegebied",
  "careGroup.serviceArea.description":
    "De zorggroep kan bij de pagina ‘Inzichten huisartsenzorg’ allerlei data zien: van de praktijken die bij de zorggroep zijn aangesloten, maar ook algemene inzichten van de huisartsenzorg, van het gebied waar zij actief zijn.",
  "careGroup.serviceArea.allowed.title": "Binnen welk postcodegebied <u>mag</u> de zorggroep data inzien?",
  "careGroup.serviceArea.allowed.description":
    "Dit wordt ingesteld vanuit MijnPraktijk, en is ruwweg het gebied wat jullie bedienen.",
  "careGroup.serviceArea.filter.title": "Binnen welk postcodegebied <u>wil</u> de zorggroep data inzien?",
  "careGroup.serviceArea.filter.description":
    "Dit wordt ingesteld vanuit de Zorggroep, en is exact het gebied wat jullie bedienen. Het is een filter op bovenstaand gebied.",
  "careGroup.serviceArea.edit": "Bewerken",
  "careGroup.serviceArea.pc4.range": "Van {from} tot {to}",
  "careGroup.serviceArea.pc6.replacedOnSave":
    "Dit gebied is ingesteld als postcode-6 reguliere expressie. Bij het opslaan van postcode-4 gebieden wordt deze vervangen.",
  "careGroup.serviceArea.empty": "Nog niet ingesteld",
  "careGroup.phoneNumber": "Telefoonnummer",
  "careGroup.phoneNumber.placeholder": "Vul telefoonnummer in",
  "careGroup.email": "E-mailadres",
  "careGroup.email.placeholder": "Vul e-mailadres in",
  "careGroup.externalWebsiteUrl": "Contactpagina URL",
  "careGroup.externalWebsiteUrl.placeholder": "Vul URL van contactpagina in",
  "careGroup.externalDomains.title": "Waar de landingspagina te zien is",
  "careGroup.externalDomains.body":
    "Toon de landingspagina van deze zorggroep op een van onze andere webadressen. Bezoekers zien die pagina op dat adres en worden niet doorgestuurd naar mijnpraktijk.nl.",
  "careGroup.externalDomains.placeholder": "regio.{domain1}, regio.{domain2}",
  "careGroup.externalDomains.info":
    "Alleen subdomeinen van {domain1} en {domain2}. Scheid meerdere domeinen met een komma.",
  "careGroup.externalDomains.validationInvalid": "Dit is geen geldige hostnaam",
  "careGroup.page.logo": "Logo",
  "careGroup.page.theme": "Vormgeving",
  "careGroup.page.theme.intro":
    "Pas de openbare zorggroep pagina aan. Wijzigingen worden direct getoond in het voorbeeld onderaan.",
  "careGroup.theme.title": "Paginatitel",
  "careGroup.theme.title.placeholder": "Bijv. Welkom bij uw zorggroep",
  // ICU escaping: `''` is a literal quote, `'{name}'` a literal {name} — renders as '{name}'
  "careGroup.theme.title.info":
    "De titel van de openbare zoekpagina. Gebruik '''{name}''' om de naam van de zorggroep in te vullen.",
  "careGroup.theme.description": "Omschrijving",
  "careGroup.theme.searchMessages": "Berichten bij zoekresultaten",
  "careGroup.theme.searchMessages.intro":
    "Schrijf zelf wat een patiënt te zien krijgt als er geen praktijk gevonden is, of als praktijken geen inschrijvingen aannemen. Je kunt er links in zetten, bijvoorbeeld naar je eigen pagina.",
  "careGroup.theme.noResultsMessage": "Geen zoekresultaten",
  "careGroup.theme.noResultsMessage.info": "Vervangt de standaardtekst als er geen praktijk gevonden is.",
  "careGroup.theme.closedPracticesMessage": "Gesloten praktijken",
  "careGroup.theme.closedPracticesMessage.info":
    "Komt onder de zoekresultaten te staan wanneer er wel praktijken zijn, maar er ten minste één gesloten is.",
  "careGroup.theme.accentColor": "Accentkleur",
  "careGroup.theme.accentColor.info": "Koppen op de openbare pagina.",
  "careGroup.theme.backgroundColor": "Achtergrondkleur",
  "careGroup.theme.backgroundColor.info": "Achtergrond van de pagina.",
  "careGroup.theme.buttonBackgroundColor": "Knopkleur",
  "careGroup.theme.buttonBackgroundColor.info": "Achtergrond van knoppen.",
  "careGroup.theme.buttonTextColor": "Knoptekstkleur",
  "careGroup.theme.buttonTextColor.info": "Tekst op knoppen.",
  "careGroup.theme.illustration": "Illustratie",
  "color.useDefault": "Standaard gebruiken",
  "careGroup.theme.viewPublicPage": "Bekijk de openbare pagina",
  "validation.hexColor.invalid": "Dit is geen geldige kleurcode (bijv. #3E79F7)",
  "careGroup.page.authorizations": "Medewerkers",
  "careGroup.page.privacyStatement": "Privacyverklaring",
  "careGroup.page.privacyStatement.placeholder": "Voeg hier een privacyverklaring toe ...",
  "careGroup.page.privacyStatement.nl": "Privacyverklaring - Nederlands",
  "careGroup.page.privacyStatement.en": "Privacyverklaring - Engels",
  "careGroup.dashboard.tab.region": "Per gebied",
  "careGroup.dashboard.tab.practice": "Per praktijk",
  "careGroup.dashboard.picker.title": "Kies een zorggroep",
  "careGroup.dashboard.picker.description":
    "Je hebt toegang tot meerdere zorggroepen. Klik op de zorggroep waar je in bent geïnteresseerd.",
  "careGroup.dashboard.empty.title": "Nog geen data beschikbaar",
  "careGroup.dashboard.empty.description": "De gegevens voor deze zorggroep zijn nog niet klaar. Kijk later nog eens.",
  "careGroup.dashboard.builtAt": "Gegevens verzameld op {date}",
  "careGroup.dashboard.rebuild.action": "Gegevens vernieuwen",
  "careGroup.dashboard.rebuild.success": "De gegevens van deze zorggroep zijn opnieuw opgebouwd.",
  "careGroup.dashboard.rebuild.alreadyRunning":
    "Er wordt al een dashboard opgebouwd. Probeer het over een paar minuten opnieuw.",
  "careGroup.dashboard.rebuild.error": "Het vernieuwen van de gegevens is niet gelukt.",
  "careGroup.dashboard.practiceCoverage.title": "Postcodegebied van onze praktijken",
  "careGroup.dashboard.practiceCoverage.description": "Beweeg over een gebied voor de praktijknaam en status.",
  "careGroup.dashboard.practiceCoverage.practices.title": "Praktijken",
  "careGroup.dashboard.practiceCoverage.tooltip.open": "Open voor inschrijving",
  "careGroup.dashboard.practiceCoverage.tooltip.closed": "Gesloten voor inschrijving",
  "careGroup.dashboard.practiceCoverage.section.showAll": "Toon alle",
  "careGroup.dashboard.practiceCoverage.section.showLess": "Toon minder",
  "careGroup.dashboard.practiceCoverage.noArea": "Geen postcodegebied ingesteld",
  "careGroup.dashboard.practiceCoverage.noArea.explanation":
    "Deze praktijk heeft geen (werkend) postcodegebied ingesteld en is daarom niet op de kaart te zien.",
  "careGroup.dashboard.practiceCoverage.display.title": "Weergave op kaart",
  "careGroup.dashboard.practiceCoverage.display.practices": "Praktijklocaties",
  "careGroup.dashboard.widget.error": "Deze widget kon niet worden geladen.",
  "careGroup.dashboard.widget.staleData":
    "De gegevens voor dit overzicht zijn nog niet beschikbaar. Ze worden vannacht opnieuw opgebouwd.",
  "careGroup.dashboard.error": "Dit overzicht kon niet worden geladen.",
  "careGroup.dashboard.staleData":
    "De gegevens voor dit overzicht zijn nog niet beschikbaar. Ze worden vannacht opnieuw opgebouwd.",
  "careGroup.dashboard.filter.area.label": "Gebied",
  "careGroup.dashboard.filter.area.empty": "Geen gebieden beschikbaar",
  "careGroup.dashboard.filter.dateRange.label": "Periode",
  "careGroup.dashboard.registrationRates.title": "Inschrijvingen per praktijk, over tijd",
  "careGroup.dashboard.registrationRates.column.practice": "Praktijk",
  "careGroup.dashboard.registrationRates.column.newRegistrations": "Inschrijvingen",
  "careGroup.dashboard.registrationRates.column.accepted": "Geaccepteerd of afgerond",
  "careGroup.dashboard.registrationRates.column.averageLeadTime": "Doorlooptijd (gemiddeld)",
  "careGroup.dashboard.registrationRates.column.averageLeadTime.tooltip":
    "Het gemiddelde aantal dagen tussen het aanmaken van een inschrijving en het accepteren ervan. Inschrijvingen die nog niet zijn geaccepteerd, tellen niet mee.",
  "careGroup.dashboard.registrationRates.column.medianLeadTime": "Doorlooptijd (mediaan)",
  "careGroup.dashboard.registrationRates.column.medianLeadTime.tooltip":
    "De mediaan van het aantal dagen tussen aanmaken en accepteren van een inschrijving. De helft van de inschrijvingen wordt binnen dit aantal dagen geaccepteerd, de andere helft duurt langer. Inschrijvingen die nog niet zijn geaccepteerd, tellen niet mee.",
  "careGroup.dashboard.registrationRates.totals.allPractices": "Alle praktijken",
  "careGroup.dashboard.registrationRates.totals.footnote":
    "Gemiddelde en mediaan zijn berekend over alle inschrijvingen samen - elke inschrijving weegt even zwaar. Het is dus niet het gemiddelde van de praktijkgemiddelden.",
  "careGroup.dashboard.practiceStatus.title": "Praktijkstatus per praktijk",
  "careGroup.dashboard.practiceStatus.column.practice": "Naam",
  "careGroup.dashboard.practiceStatus.column.status": "Status",
  "careGroup.dashboard.practiceStatus.column.closeReason": "Reden gesloten",
  "careGroup.dashboard.practiceStatus.column.remainingCapacity": "Sluit na X aanmeldingen",
  "careGroup.dashboard.practiceStatus.open": "Open",
  "careGroup.dashboard.practiceStatus.closed": "Gesloten",
  "careGroup.dashboard.practiceStatus.capacity.unknown": "Onbekend",
  "careGroup.dashboard.practiceStatus.capacitySum.label": "Som van 'Sluit na X aanmeldingen'",
  "careGroup.dashboard.practiceStatus.capacitySum.basis":
    "Opgeteld over praktijken die een maximum ingesteld hebben ({counted} van {open} open praktijken in dit overzicht)",
  "careGroup.dashboard.practiceStatus.capacitySum.disclaimer":
    "Gebruik dit getal niet zomaar om de opnamecapaciteit van een regio te schatten.",
  "careGroup.dashboard.practiceStatus.capacitySum.disclaimer.notMinimum":
    "<b>Het getal is geen minimum:</b> Praktijken die geen maximum ingesteld hebben zijn onbeperkt open, maar worden in deze som niet meegeteld ({withoutMax} van {open} open praktijken in dit overzicht)",
  "careGroup.dashboard.practiceStatus.capacitySum.disclaimer.notMaximum":
    "<b>Het getal is ook geen maximum:</b> Sommige praktijken vullen een hoog aantal in om te laten zien dat ze open zijn, zonder daadwerkelijk zoveel patiënten te kunnen opnemen.",
  "careGroup.dashboard.practiceStatusHeatmap.title": "Open & gesloten praktijken, over tijd",
  "careGroup.dashboard.practiceStatusHeatmap.column.practice": "Naam",
  "careGroup.dashboard.practiceStatusHeatmap.state.open": "Open",
  "careGroup.dashboard.practiceStatusHeatmap.state.closed": "Gesloten",
  "careGroup.dashboard.practiceStatusHeatmap.state.unknown": "Geen data",
  "careGroup.dashboard.practiceStatusLineGraph.title": "Open & gesloten praktijken over tijd",
  "careGroup.dashboard.practiceStatusLineGraph.series.open": "Open praktijken",
  "careGroup.dashboard.practiceStatusLineGraph.series.closed": "Gesloten praktijken",
  "careGroup.dashboard.practiceStatusLineGraph.tooltip.open": "{count} open praktijken",
  "careGroup.dashboard.practiceStatusLineGraph.tooltip.closed": "{count} gesloten praktijken",
  "careGroup.dashboard.closureReasons.preTitle": "Antwoorden van jullie praktijken op de vraag:",
  "careGroup.dashboard.closureReasons.title": "Wat heb je nodig om weer open te gaan?",
  "careGroup.dashboard.closureReasons.description": "Praktijken konden meerdere redenen opgeven.",
  "careGroup.dashboard.closureReasons.category.housing": "Huisvesting",
  "careGroup.dashboard.closureReasons.category.gp_staff": "Huisartsen",
  "careGroup.dashboard.closureReasons.category.assistant_staff": "Assistenten",
  "careGroup.dashboard.closureReasons.category.other": "Overig",
  "careGroup.dashboard.notificationWaitingListHeatmap.title": "Aantal mensen dat een huisarts zoekt",
  "careGroup.dashboard.notificationWaitingListHeatmap.total.label": "Aantal mensen dat een huisarts zoekt",
  "careGroup.dashboard.notificationWaitingListHeatmap.total.description":
    "Het totaal aantal mensen dat vandaag staat ingeschreven op de notificatieservice (inclusief familieleden).",
  "careGroup.dashboard.notificationWaitingListHeatmap.tooltip":
    "{postalCode}: {count, plural, one {# wachtende} other {# wachtenden}}",
  "careGroup.dashboard.notificationWaitingListHeatmap.legend.count":
    "{count, plural, one {# wachtende} other {# wachtenden}}",
  "careGroup.filter.label": "Selecteer zorggroep",
  "careGroup.filter.placeholder": "Kies zorggroep uit de lijst",
  careGroupIds: "Zorggroep",

  "appointment.reason": "Reden voor afspraak",

  "symptoms.description":
    "Beschrijf kort de klachten die u ervaart, de vraag die u heeft of andere informatie die nuttig kan zijn.",
  "symptoms.description.platoMedical":
    "Beschrijf in het kort overige klachten of vragen die u heeft, die niet in de vragenlijst naar voren zijn gekomen.",
  "symptoms.description.platoAdministrative":
    "Beschrijf in het kort overige details die niet in de vragenlijst naar voren zijn gekomen.",

  "validation.required.error": "Dit veld is verplicht",
  "validation.maxLength.error": "De tekst mag niet langer zijn dan {maxLength} karakters",

  "submit.success": "Succesvol opgeslagen",
  "submit.deleted": "Succesvol verwijderd",
  "submit.error": "Er is een fout opgetreden, probeer het opnieuw...",
  "submit.error.fields": "Vul alle verplichte velden correct in",

  "form.select": "Selecteer",
  "form.select.users.placeholder": "Selecteer medewerkers",

  emailAddress: "E-mailadres",
  "emailAddress.validationRequired": "Vul een e-mailadres in",
  "emailAddress.validationInvalid": "Vul een geldig e-mailadres in",
  "emailAddress.blockedDomain":
    "Dit e-mailadres gebruikt een domein (@zorgmail.nl) dat geen e-mails kan ontvangen van ons systeem. Gebruik een ander e-mailadres.",
  "emailAddress.validationNonAscii":
    "Dit e-mailadres bevat speciale tekens (zoals accenten) die wij niet kunnen versturen. Gebruik een adres zonder accenten.",

  "reloadWarning.confirm": "Er zijn niet-opgeslagen wijzigingen. Weet je zeker dat je deze wijzigingen wilt negeren?",

  "days.monday": "Maandag",
  "days.tuesday": "Dinsdag",
  "days.wednesday": "Woensdag",
  "days.thursday": "Donderdag",
  "days.friday": "Vrijdag",
  "days.saturday": "Zaterdag",
  "days.sunday": "Zondag",
  "days.holiday": "Feestdag",
  "days.short.monday": "ma",
  "days.short.tuesday": "di",
  "days.short.wednesday": "wo",
  "days.short.thursday": "do",
  "days.short.friday": "vr",
  "days.short.saturday": "za",
  "days.short.sunday": "zo",
  "days.short.holiday": "feestdag",

  "calendar.previousMonth": "Vorige maand",
  "calendar.nextMonth": "Volgende maand",
  "calendar.monday": "Ma",
  "calendar.tuesday": "Di",
  "calendar.wednesday": "Wo",
  "calendar.thursday": "Do",
  "calendar.friday": "Vr",
  "calendar.saturday": "Za",
  "calendar.sunday": "Zo",

  "dateDifference.year": "Jaar",
  "dateDifference.years": "Jaren",
  "dateDifference.day": "Dag",
  "dateDifference.days": "Dagen",
  "dateDifference.hour": "Uur",
  "dateDifference.hours": "Uren",
  "dateDifference.minute": "Minuut",
  "dateDifference.minutes": "Minuten",
  "dateDifference.second": "Seconde",
  "dateDifference.seconds": "Seconden",
  "dateDifference.now": "Nu",

  "dateRelative.weeks": "{value} {value, plural, =1 {week} other {weken}} geleden",
  "dateRelative.weeks.future": "Over {value} {value, plural, =1 {week} other {weken}}",
  "dateRelative.days": "{value} {value, plural, =1 {dag} other {dagen}} geleden",
  "dateRelative.days.future": "Over {value} {value, plural, =1 {dag} other {dagen}}",
  "dateRelative.hours": "{value} {value, plural, =1 {uur} other {uur}} geleden",
  "dateRelative.hours.future": "Over {value} {value, plural, =1 {uur} other {uur}}",
  "dateRelative.minutes": "{value} {value, plural, =1 {minuut} other {minuten}} geleden",
  "dateRelative.minutes.future": "Over {value} {value, plural, =1 {minuut} other {minuten}}",

  "timePicker.duration.minutes": "{minutes} min",
  "timePicker.duration.hours": "{hours, number} uur",

  "upload.logo": "Upload logo",
  "upload.logo.info": "Een horizontaal langwerpig logo wordt het mooist weergegeven.",
  "upload.spreadsheetDetails": ".CSV of .XLSX tot 10MB",
  "upload.imageDetails": "PNG, JPG tot 10MB",
  "upload.dropzone": "Selecteer een bestand of sleep het hiernaartoe",
  "upload.required": "Het is verplicht om een bestand toe te voegen.",
  "upload.action.1": "Selecteer een bestand",
  "upload.action.2": "of sleep het hiernaartoe",
  "upload.scanNotSuccessful": "Niet alle bestanden zijn succesvol gescand op virussen.",
  "upload.notAllowed": "Dit bestandsformaat is niet toegestaan vanwege veiligheidsredenen.",
  "upload.tooLarge": "Dit bestand is te groot. De maximale grootte is {maxMb}MB.",
  "upload.threatsFound": "Er is mogelijk een virus gevonden in dit bestand.",
  "upload.noThreatsFound": "Er zijn geen virussen gevonden in dit bestand.",
  "upload.unknown": "Dit bestand kon niet worden gescand op virussen.",
  "upload.texteditor.issuesFound":
    "Er zijn problemen gevonden in de geüploade bestanden. Verwijder ze om dit bericht te kunnen versturen.",
  "upload.texteditor.inlineImageSize":
    "Afbeeldingen invoegen werkt als deze kleiner zijn dan 8MB. Voor grotere bestanden kunt u de blauwe plus knop gebruiken en bestanden invoegen.",

  "labels.placeholder": "Selecteer labels",
  "labels.unavailable": "Geen labels beschikbaar",

  appointments: "Afspraken",
  "appointments.all": "Alle afspraken",
  "appointments.upcoming": "Komende afspraken",
  "appointments.previous": "Historische afspraken",
  "appointments.type": "Afspraaktype",
  "appointments.type.validate": "Type is verplicht",
  "appointments.his": "Plan in HIS",
  "appointments.his.description": "Beperkt tot opengestelde data, maar afspraak wordt automatisch aangemaakt in HIS",
  "appointments.manual": "Handmatig",
  "appointments.manual.description": "Alle data mogelijk, maar worden niet in het HIS gezet.",
  "appointments.appointment.type.validate": "Afspraaktype is verplicht",
  "appointments.note":
    "Beide opties sturen een bericht en een herinnering naar de patiënt. En voor video-afspraken een link voor de afspraak.",
  "appointments.agenda.placeholder": "Selecteer agenda",
  "appointments.agenda.validate": "Agenda is verplicht",
  "appointments.agenda.noneConfigured":
    "Deze praktijk heeft nog geen agenda's ingesteld. Zonder agenda kun je geen afspraak vastleggen. Een beheerder kan agenda's toevoegen via {settings} → {group} → {page}.",
  "appointments.appointmentType.placeholder": "Selecteer type",
  "appointments.patient.validate": "Patiënt is verplicht",
  "appointments.date.placeholder": "Selecteer een datum",
  "appointments.date.validate": "Datum is verplicht",
  "appointments.practice.placeholder": "Selecteer praktijken",
  "appointments.time.placeholder": "Selecteer tijd",
  "appointments.slots.loadFailed":
    "De beschikbare tijden konden niet worden opgehaald. Probeer het later opnieuw of leg de afspraak handmatig vast.",
  "appointments.time.from.label": "Tijd (van)",
  "appointments.time.to.label": "Tijd (tot)",
  "appointments.time.notBefore": "Begintijd moet voor eindtijd liggen",
  "appointments.time.validate": "Tijd is verplicht",
  "appointments.remarks": "Opmerkingen",
  "appointments.remarks.placeholder": "Opmerkingen voor in HIS (niet voor patiënt)",
  "appointments.past": "Afgelopen afspraken",
  "appointment.from": "Afspraak van",
  "appointment.to": "Afspraak tot",
  appointment: "Afspraak",
  appointmentLower: "afspraak",
  "appointment.remove.modal.title": "Afspraak verwijderen",
  "appointment.remove.modal.content": "Afspraak verwijderen met {patientName}?",
  "appointment.remove.modal.deletedInHis": "Deze afspraak wordt ook in het HIS verwijderd.",
  "appointment.remove.modal.confirm": "Verwijderen",
  "appointment.remove.success": "Afspraak is verwijderd",
  "appointment.delete": "Verwijderen",
  "appointment.details": "Afspraakdetails",
  "appointment.details.agenda": "Agenda",
  "appointment.details.type": "Type",
  "appointment.details.symptoms": "Anamnese / symptomen",
  "appointment.details.videoLink": "Video link",
  "appointment.type.video": "Video",
  "appointment.type.faceToFace": "Consult op praktijk",
  "appointment.type.phone": "Telefonisch",
  "appointment.calendar.label": "Zet in mijn agenda",
  "appointment.calendar.name": "{type} afspraak bij {agenda}",
  "appointment.dateTimeLength": "Datum, tijd & duur",
  "appointment.date": "Afspraakdatum",
  "appointment.econsult.open": "Consult openen",
  "appointment.errors.duplicate": "Kan de afspraak niet wijzigen, neem contact op met de praktijk om deze te wijzigen.",

  "econsults.status.label": "E-consult status",
  "econsults.status.select": "Selecteer consult status",
  econsult: "E-consult",
  "econsult.type.video": "Video afspraak",
  "econsult.create": "E-consult toevoegen",
  "econsult.create.success": "Nieuw e-consult aangemaakt",
  "econsult.list.type.header": "Type",
  "econsult.list.type.default": "E-consult",
  "econsult.list.type.appointment": "Afspraak",
  "econsult.list.type.walkIn": "Digitaal inloopspreekuur",
  "econsult.list.type.stayHomeAdvice": "Thuisadvies",
  "econsult.list.type.outOfScope": "Niet van toepassing",
  "econsult.list.type.phoneConsult": "Telefonisch",
  "econsult.list.type.open": "Open",
  "econsult.list.type.closed": "Gesloten",
  "econsult.list.info.header": "Info",
  "econsult.phoneConsult.patientBar.caption": "Vervolg op een telefonische terugbelafspraak",
  "econsult.closed": "Dit e-consult is gesloten op {date} door {closedByName}. Er kan niet meer op worden gereageerd.",
  "econsult.startVideo": "Start video",
  "econsult.stopVideo": "Stop video",
  "econsult.patientAvailable": "Patiënt is aanwezig",
  "econsult.patientNotAvailable": "Patiënt niet aanwezig",
  "econsult.appointmentBelongsTo": "Hoort bij",
  "econsult.attachments": "Bijlagen",
  "econsult.attachFiles": "Bestand toevoegen",
  "econsult.link.appointment": "Nieuwe afspraak link",
  "econsult.link.econsult": "Nieuw e-consult link",
  "econsult.responseTemplates.resetFilter": "Herstel filter",
  "econsult.charge.label": "Declaratie type",
  "econsult.charge.type.untilFiveMinutes": "Minder dan 5 minuten",
  "econsult.charge.type.untilTwentyMinutes": "Minder dan 20 minuten",
  "econsult.charge.type.moreThanTwentyMinutes": "Meer dan 20 minuten",
  "econsult.charge.type.none": "Geen declaratie",
  "econsult.close.open.text": "Met het sluiten is het niet meer mogelijk om te reageren of video te starten.",
  "econsult.close.open.button": "Sluit consult",
  "econsult.journalItem": "Journaalregel",
  "econsult.journalItem.title": "HIS journaalregels",
  "econsult.journalItem.headerNew": "Nieuwe journaalregel",
  "econsult.journalItem.sentToHisBtn": "Verstuur naar HIS",
  "econsult.journalItem.contactType.label": "Contact type",
  "econsult.journalItem.contactType.option.C": "C: consult",
  "econsult.journalItem.contactType.option.EC": "EC: e-consult",
  "econsult.journalItem.contactType.option.VC": "VC: videoconsult",
  "econsult.journalItem.contactType.option.T": "T: telefonisch contact",
  "econsult.journalItem.contactType.placeholder": "Geen types gevonden",
  "econsult.journalItem.copyTooltip": "Voeg toe aan {label} regel",
  "econsult.journalItem.autoMedic.created": "Aangemaakt in AutoMedic, maar nog niet verwerkt",
  "econsult.journalItem.autoMedic.success": "In HIS opgeslagen via AutoMedic",
  "econsult.journalItem.autoMedic.failed": "Fout bij verwerking via AutoMedic",
  "econsult.journalItem.validation.empty": "Vul minimaal één SOEP-veld in.",
  "econsult.searchUsefulLink": "Voeg Thuisarts link toe",
  "econsult.message": "Bericht",
  "econsult.messages": "Berichten",
  "econsult.message.success": "Bericht verstuurd",
  "econsult.message.input": "Vul een reactie in",
  "econsult.reply.validation.empty": "Vul een bericht in of voeg een bijlage toe.",
  "econsult.message.patient": "Selecteer eerst een patiënt",
  "econsult.message.createTemplate": "Sla bericht op als antwoord template",
  "econsult.subjectPlaceHolder": "Onderwerp:",
  "econsult.responseTextarea.placeholder": "Typ een bericht naar de patiënt",
  "econsult.searchResponseSuggestion": "Antwoord suggestie",
  "econsult.responseTemplate": "Antwoord template",
  "econsult.responseTemplate.button": "Antwoord template",
  "econsult.responseTemplate.edit.title": "Antwoord template bewerken",
  "econsult.responseTemplate.add.title": "Antwoord template aanmaken",
  "econsult.responseTemplate.sub.header": "Alle antwoord templates zijn beschikbaar in de",
  "econsult.responseTemplate.settings.link": "praktijk configuratie.",
  "econsult.responseTemplateEmpty": "Ga naar praktijk configuratie om deze in te stellen.",
  "econsult.otherUserTyping": "is een bericht aan het typen",
  "econsult.close": "Sluit consult",
  "econsult.close.messageContent": "Verstuur eerst het bericht naar de patiënt, daarna kan het consult gesloten worden",
  "econsult.close.futureAppointment":
    "Een toekomstige afspraak is hieraan gekoppeld. Dit sluiten zou het voor de patiënt onmogelijk maken om de afspraak te openen. Verwijder de gekoppelde afspraak eerst.",
  "econsult.close.icpcRequired": "ICPC-code is verplicht",
  "econsult.close.success": "E-consult is gesloten",
  "econsult.send.patient": "Verstuur naar patiënt",
  "econsult.send.withoutHis": "Sluit zonder bericht naar HIS",
  "econsult.send.his": "Verstuur naar HIS",
  "econsult.videoFrame.move": "Klik om te verplaatsen",
  "econsult.reopen": "Heropen e-consult",
  "econsult.patientIsOnline": "Patiënt is online",
  "econsult.attachmentPreview": "Voorbeeld van bijlage",
  "econsult.other.stayHomeAdvice": "Thuisadvies",
  "econsult.other.outOfScope": "Niet van toepassing",
  "econsult.other.close": "Sluiten",
  "econsult.other.reopen": "Heropenen",
  "econsult.other.shownToPatient": "Getoond aan patiënt",
  "econsult.other.safetyNet": "Let op:",
  "econsult.triage.header": "{title}:",
  "econsult.triage.outcome": "Uitslag:",
  "econsult.triage.outcome.bodyPart": "Lichaamsdeel:",

  "plato.bodyPart.Abdomen": "Buik",
  "plato.bodyPart.Arms": "Armen",
  "plato.bodyPart.Back": "Rug",
  "plato.bodyPart.Buttocks": "Billen",
  "plato.bodyPart.Chest": "Borst",
  "plato.bodyPart.Feet": "Voeten",
  "plato.bodyPart.Genital": "Geslacht",
  "plato.bodyPart.Hands": "Handen",
  "plato.bodyPart.Head": "Hoofd",
  "plato.bodyPart.Legs": "Benen",
  "plato.bodyPart.Neck": "Nek",
  "plato.bodyPart.Throat": "Keel",
  "plato.bodyPart.Other": "Ik weet het niet",

  "plato.questionnaire.ABCDE": "ABCDE",
  "plato.questionnaire.ADHD": "Concentratieproblemen (ADHD/ADD)",
  "plato.questionnaire.ADHDChild": "Concentratieproblemen (ADHD/ADD) bij kind",
  "plato.questionnaire.AbdominalPainAdult": "Buikpijn volwassene",
  "plato.questionnaire.AbdominalPainChild": "Buikpijn kind",
  "plato.questionnaire.Addiction": "Verslaving",
  "plato.questionnaire.AgeLimit": "Leeftijdslimiet",
  "plato.questionnaire.AllergicReaction": "Hooikoorts",
  "plato.questionnaire.AllergyFood": "Voedselallergie (overgevoeligheid)",
  "plato.questionnaire.AnkleFoot": "Enkelklachten, voetklachten of teenklachten",
  "plato.questionnaire.Anxiety": "Angstklachten",
  "plato.questionnaire.ArmShoulder": "Armklachten (inclusief schouder)",
  "plato.questionnaire.ArmShoulderChild": "Armklachten (inclusief schouder) bij kind",
  "plato.questionnaire.BackPain": "Rugklachten",
  "plato.questionnaire.BedWettingChild": "Bedplassen kind",
  "plato.questionnaire.BirthControl": "Anticonceptie",
  "plato.questionnaire.BloodLossStool": "Bloedverlies in ontlasting",
  "plato.questionnaire.Breast": "Borstklachten",
  "plato.questionnaire.Breastfeeding": "Borstvoeding",
  "plato.questionnaire.BurnWound": "Brandwond",
  "plato.questionnaire.Buttocks": "Billen",
  "plato.questionnaire.CancelAppointment": "Ik wil een afspraak annuleren",
  "plato.questionnaire.CardiacImplant": "ICD (waaronder pacemaker)",
  "plato.questionnaire.ChangePersonalInformation":
    "Ik wil een verandering in mijn adres, e-mail of telefoonnummer doorgeven",
  "plato.questionnaire.ChestPain": "Pijn of druk op de borst",
  "plato.questionnaire.Confusion": "Verwarring",
  "plato.questionnaire.Constipation": "Moeite met poepen",
  "plato.questionnaire.Coughing": "Hoesten",
  "plato.questionnaire.CryingBaby": "Huilende baby",
  "plato.questionnaire.Dental": "Gebitsklachten",
  "plato.questionnaire.Diabetes": "Diabetes",
  "plato.questionnaire.Diarrhea": "Diarree",
  "plato.questionnaire.Dizziness": "Duizeligheid",
  "plato.questionnaire.Drain": "Drain / sonde / katheter",
  "plato.questionnaire.Ear": "Oorklachten",
  "plato.questionnaire.Fainting": "Flauwvallen of wegraking",
  "plato.questionnaire.FeverAdult": "Koorts Volwassene",
  "plato.questionnaire.FeverChild": "Koorts Kind",
  "plato.questionnaire.ForeignObject": "Vreemd object",
  "plato.questionnaire.GeneralComplaint": "Algemene klacht",
  "plato.questionnaire.GeneralComplaintPsychological": "Algemene psychologische klacht",
  "plato.questionnaire.Grief": "Rouw",
  "plato.questionnaire.HandWrist": "Hand en polsklachten",
  "plato.questionnaire.Headache": "Hoofdpijn",
  "plato.questionnaire.HearingLossTinnitus": "Gehoorverlies / Tinnitus",
  "plato.questionnaire.Hypertension": "Hypertensie",
  "plato.questionnaire.InguinalSwelling": "Lieszwelling",
  "plato.questionnaire.InsectSting": "Insectenbeet/ tekenbeet",
  "plato.questionnaire.Insomnia": "Slaapproblemen en slaapmiddelen",
  "plato.questionnaire.Intoxication": "Intoxicatie",
  "plato.questionnaire.LabResult": "Ik heb een vraag over een labuitslag",
  "plato.questionnaire.LegHip": "Beenklachten (inclusief heup)",
  "plato.questionnaire.MalaiseAdult": "Algehele malaise volwassene",
  "plato.questionnaire.MedicationCosts": "Ik heb een vraag over de kosten van een medicijn",
  "plato.questionnaire.MedicationDoesntWork": "Mijn medicatie werkt niet",
  "plato.questionnaire.MedicationExplanation": "Ik wil uitleg over medicatie gebruik",
  "plato.questionnaire.MedicationStatement": "Ik heb een medicijnverklaring nodig vanwege een reis naar het buitenland",
  "plato.questionnaire.Menopause": "Menopauze",
  "plato.questionnaire.MenstrualCycle": "Menstruele cyclus",
  "plato.questionnaire.Mental": "Psychologische klachten",
  "plato.questionnaire.NauseaVomitingStomach": "Misselijkheid, braken en maagklachten",
  "plato.questionnaire.Neck": "Nekklachten",
  "plato.questionnaire.Nose": "Neusklachten",
  "plato.questionnaire.NoseBleeding": "Bloedneus",
  "plato.questionnaire.Obesity": "Overgewicht",
  "plato.questionnaire.OtherComplaint": "Mijn klacht staat er niet tussen",
  "plato.questionnaire.Pain": "Pijn",
  "plato.questionnaire.Palpitations": "Hartkloppingen",
  "plato.questionnaire.Paralysis": "Verlamming",
  "plato.questionnaire.PopulationSurvey": "Ik heb een vraag over het bevolkingsonderzoek",
  "plato.questionnaire.Pregnancy": "Zwangerschap en kraamtijd",
  "plato.questionnaire.PregnancyAbdominalPain": "Zwangerschap (buikpijn)",
  "plato.questionnaire.PregnancyChildBirth": "Zwangerschap (geboorte)",
  "plato.questionnaire.PregnancyConcerns": "Zwangerschap (zorgen)",
  "plato.questionnaire.PregnancyFluidLoss": "Zwangerschap (vochtverlies)",
  "plato.questionnaire.PregnancyOther": "Zwangerschap (overig)",
  "plato.questionnaire.PregnancyUrinaryTract": "Zwangerschap (urinewegklachten)",
  "plato.questionnaire.PregnancyVaginalBloodLoss": "Zwangerschap (vaginaal bloedverlies)",
  "plato.questionnaire.Procedure": "Procedure",
  "plato.questionnaire.Rectal": "Rectale klachten",
  "plato.questionnaire.RedEyePainEye": "Rood of pijnlijk oog",
  "plato.questionnaire.Referral": "Verwijzing",
  "plato.questionnaire.ReproductiveOrganFemale": "Vaginale klachten",
  "plato.questionnaire.ReproductiveOrganMale": "Geslachtsorgaan man",
  "plato.questionnaire.RequestMedicalInformation": "Ik wil informatie uit mijn medisch dossier opvragen",
  "plato.questionnaire.RescheduleAppointment": "Ik wil een afspraak verzetten",
  "plato.questionnaire.Seizure": "Stuiptrekking (insult)",
  "plato.questionnaire.SexualAbuse": "Seksueel misbruik",
  "plato.questionnaire.SexualComplaint": "Seksuele klachten",
  "plato.questionnaire.ShortnessOfBreath": "Kortademigheid",
  "plato.questionnaire.ShortnessOfBreathChild": "Kortademigheid bij kind",
  "plato.questionnaire.Sick": "Ziekte",
  "plato.questionnaire.SideEffect": "Ik wil een bijwerking melden",
  "plato.questionnaire.Skin": "Huidklachten",
  "plato.questionnaire.SkinChild": "Huidklachten (kind)",
  "plato.questionnaire.Smoking": "Stoppen met roken of vapen",
  "plato.questionnaire.SOA": "SOA",
  "plato.questionnaire.STD": "STD",
  "plato.questionnaire.Subfertility": "Vruchtbaarheidsproblemen (moeite met zwanger worden)",
  "plato.questionnaire.Suicidal": "Suïcidaal",
  "plato.questionnaire.Testing": "Test Follow-up Type+Role+Urgency",
  "plato.questionnaire.Throat": "Keelklachten",
  "plato.questionnaire.ThroatChild": "Keelklachten bij kind",
  "plato.questionnaire.TraumaAbdomen": "Buikletsel / ongeval",
  "plato.questionnaire.TraumaArm": "Ongeval arm",
  "plato.questionnaire.TraumaArmLeg": "Ongeval arm/ been",
  "plato.questionnaire.TraumaBack": "Ongeval rug",
  "plato.questionnaire.TraumaChest": "Ongeval borst",
  "plato.questionnaire.TraumaEye": "Ongeval ogen",
  "plato.questionnaire.TraumaFace": "Ongeval gezicht",
  "plato.questionnaire.TraumaHead": "Ongeval hoofd",
  "plato.questionnaire.TraumaLeg": "Ongeval been",
  "plato.questionnaire.TraumaMulti": "Ongeval (meerdere plekken)",
  "plato.questionnaire.TraumaNeck": "Ongeval nek",
  "plato.questionnaire.TraumaNose": "Ongeval neus",
  "plato.questionnaire.TraumaThorax": "Ongeval thorax",
  "plato.questionnaire.Tremor": "Handtrillingen",
  "plato.questionnaire.UnsubscribePractice": "Ik wil me uitschrijven bij de praktijk",
  "plato.questionnaire.UnusualBehavior": "Ongebruikelijk gedrag",
  "plato.questionnaire.UrinaryTract": "Urinewegproblemen",
  "plato.questionnaire.Vaccination": "Ik heb een vraag over inentingen",
  "plato.questionnaire.VaginalBloodLoss": "Vaginaal bloedverlies",
  "plato.questionnaire.Varices": "Varices",
  "plato.questionnaire.WeightLoss": "Ongewild gewichtsverlies",
  "plato.questionnaire.Wound": "Wond",

  "econsult.triage.outcome.urgency.h0": "Niet van toepassing",
  "econsult.triage.outcome.urgency.h1": "Bel de spoedlijn",
  "econsult.triage.outcome.urgency.h2": "Bel de praktijk",
  "econsult.triage.outcome.urgency.h3": "Dezelfde dag",
  "econsult.triage.outcome.urgency.h4": "Binnen 24 uur",
  "econsult.triage.outcome.urgency.h5": "Binnen 2 tot 3 dagen",
  "econsult.triage.outcome.urgency.h6": "Binnen 3 tot 5 dagen",
  "econsult.triage.outcome.urgency.h7": "Binnen 5 tot 14 dagen",
  "econsult.triage.outcome.urgency.h8": "Thuisadvies",

  "econsult.triage.outcome.isCustomized":
    "Deze opvolging wijkt af van de standaard van MijnPraktijk, omdat iemand van {practice} deze heeft aangepast. Dingen die aangepast zouden kunnen zijn, zijn type zorgverlener en type afspraak.",
  "econsult.triage.outcome.explanation": "Wijziging:",
  "econsult.triage.outcome.explanation.customized":
    'De standaard MijnPraktijk uitkomst bij deze antwoorden is "{original}". Maar binnen {practice} is die in dit geval ingesteld op "{changed}".',
  "triage.count.tooltip": "Aantal in afgelopen 30 dagen",

  "triage.followUp.FaceToFace": "Fysieke afspraak",
  "triage.followUp.Video": "Video afspraak/consult",
  "triage.followUp.Phone": "Via telefoon",
  "triage.followUp.Econsult": "E-consult",
  "triage.followUp.WalkInConsult": "Inloopadvies",
  "triage.followUp.CALL_PRACTICE": "Bel praktijk",
  "triage.followUp.CALL_EMERGENCY_LINE": "Bel spoedlijn",
  "triage.followUp.STAY_HOME": "Thuiszorg advies",

  "triage.followUpDuration.Default": "Standaard",
  "triage.followUpDuration.Long": "Lang",

  "triage.customOutcome.followUpType": "Vervolgstap",
  "triage.customOutcome.followUpType.placeholder": "Selecteer vervolgstap",
  "triage.customOutcome.followUpType.dropdown": "Selecteer vervolgstappen",
  "triage.customOutcome.followUpDuration": "Vervolg duur",
  "triage.customOutcome.followUpDuration.placeholder": "Selecteer hoe lang de vervolgstap duurt",
  "triage.customOutcome.role": "Rol",
  "triage.customOutcome.role.placeholder": "Selecteer een nieuwe rol",
  "triage.customOutcome.role.dropdown": "Selecteer rollen",
  "triage.customOutcome.role.required": "Rol is verplicht",
  "triage.customOutcome.lastUpdate": "Laatst gewijzigd",
  "triage.customOutcome.disabled": "Het is alleen mogelijk om de opvolging van H4 t/m H8 te wijzigen.",
  "triage.customOutcome.adviceText.nl-NL": "Thuiszorg advies (Nederlandse tekst)",
  "triage.customOutcome.adviceText.en-GB": "Thuiszorg advies (Engelse tekst)",
  "triage.customOutcome.create.success": "Vervolgstap en rol zijn opgeslagen",
  "triage.customOutcome.customized": "Aangepaste opvolging",
  "triage.customOutcome.reset": "Terugzetten",

  "medication.filter.status": "Selecteer status",
  "medication.undecided": "Te verwerken herhaalmedicatie",
  "medication.approved": "Goedgekeurde herhaalmedicatie",
  "medication.rejected": "Afgewezen herhaalmedicatie",
  "medication.all": "Alle herhaalmedicatie",
  "medication.request": "Medicatie aanvraag",
  "medication.requestInfo": "Gevraagde herhaalmedicatie",
  medication: "Herhaalmedicatie",
  medicationRequest: "Herhaalmedicatie",
  "medication.drug": "Naam medicijn",
  "medication.strength": "Sterkte (bijv. mg/ml)",
  "medication.dosage": "Dosering (bijv. 2 per dag)",
  "medication.amount": "Hoeveel nodig (bijv. 2 weken)",
  "medication.comment": "Opmerking",

  patient: "Patiënt",
  patientAccount: "Patiëntaccount",
  registrationRequest: "Inschrijving",
  "patients.all": "Alle patiënten",
  "patients.new": "Nieuwe inschrijvingen",
  "patients.rejected": "Afgewezen inschrijvingen",
  "patients.accepted": "Geaccepteerde inschrijvingen",
  "patients.completed": "Afgeronde inschrijvingen",
  "patients.swaplist": "Patiënten ruilen",
  "patients.edit": "Patiënt bewerken",
  "patients.registrationDate": "Inschrijfdatum",
  "patients.removedDate": "Uitschrijfdatum",
  "patients.status": "Status",
  "patients.select.status": "Selecteer status",
  "patients.statusActive": "Ingeschreven",
  "patients.statusRejected": "Afgewezen",
  "patients.statusNew": "Nieuw",
  "patients.statusRemoved": "Uitgeschreven",
  "patients.removedOn": "Uitgeschreven op {date}",
  "patients.buttonRemove": "Uitschrijven",
  "patients.remove.modal.title": "Patiënt uitschrijven",
  "patients.remove.modal.content": "Weet u zeker dat u de patiënt {patientName} wilt uitschrijven uit de praktijk?",
  "patients.remove.success": "Patiënt is uitgeschreven",
  "patients.removeFromPractice": "Uitschrijven",
  "patients.buttonReregister": "Opnieuw inschrijven",
  "patients.reregister.modal.title": "Patiënt opnieuw inschrijven",
  "patients.reregister.modal.content":
    "Weet u zeker dat u de patiënt {patientName} opnieuw wilt inschrijven in de praktijk?",
  "patients.reregister.success": "Patiënt is opnieuw ingeschreven",
  "patients.reregisterFromPractice": "Opnieuw inschrijven",
  "patients.patientNumber": "Patiëntnummer",

  "patient.tab.general": "Algemene informatie",
  "patient.tab.history": "Historie",
  "patient.tab.registration": "Inschrijving",
  "patient.tab.accounts": "Accounts",
  "patient.history.fileLink.link": "Gekoppeld als dubbel dossier",
  "patient.history.fileLink.unlink": "Koppeling met dubbel dossier opgeheven",
  "patient.accounts.his": "HIS",
  "patient.accounts.status": "Status",
  "patient.accounts.withDigiD": "DigiD",
  "patient.accounts.withDigiD.linked": "Gekoppeld",
  "patient.accounts.withDigiD.notLinked": "Niet gekoppeld",
  "patient.accounts.patientId": "Patiënt ID",
  "patient.accounts.portalAccountId": "Portaal account ID",
  "patient.accounts.created": "Aangemaakt",
  "patients.hisCheck": "Controleer HIS koppeling",
  "patient.hisCheck.known": "Patiënt is bekend in HIS met patiëntnummer {patientId}",
  "patient.hisCheck.unknown": "Patiënt is niet bekend in HIS",
  "deepLinks.openDossier": "Dossier openen",
  "patient.details": "Patiëntgegevens",

  "patients.upload.title": "Patiënten ruilen",
  "patients.upload.description":
    "Wil je weten welke patiënten niet (meer) in je postcodegebied wonen, en in aanmerking komen voor een ruil? Upload hier je patiëntenbestand, en we helpen je verder.",
  "patients.upload.checklist.1.title": "Selecteer voor welke praktijk je patiënten wilt ruilen",
  "patients.upload.checklist.2.title": "Geef aan uit welke postcodes je patiënten accepteert",
  "patients.upload.checklist.2.1": "Dit kan je doen in {settingsLink}",
  "patients.upload.checklist.2.1.link": "de instellingen",
  "patients.upload.checklist.2.noAccess":
    "Vraag een beheerder in de praktijk om dit te doen in de instellingen, bij 'Inschrijven'",
  "patients.upload.checklist.3.title": "Upload je patiënten bestand",
  "patients.upload.checklist.3.1": "Exporteer je gehele patiënten bestand van je HIS, in CSV of Excel formaat. {link}",
  "patients.upload.checklist.3.1.link": "Lees meer",
  "patients.upload.checklist.3.2": "Upload het hieronder (We voldoen aan AVG wetgeving)",
  "patients.upload.checklist.4.title": "Begin met ruilen",
  "patients.upload.checklist.4.1": "Ontvang een lijst van patiënten die in aanmerking komen",
  "patients.upload.checklist.4.2": "Selecteer de patiënten die je zou willen ruilen",
  "patients.upload.checklist.4.3":
    "Stuur ze via MijnPraktijk een email of brief om ze te wijzen op mogelijke praktijken",
  "patients.upload.checklist.4.4": "Hou de status bij",

  "patients.upload.fileConfiguration.title": "Kolommen in kaart brengen",
  "patients.upload.fileConfiguration.description":
    "Alleen rijen met een geboortedatum, postcode en achternaam worden geïmporteerd. Zorg dat deze in de 'kolom van bestemming' zijn geselecteerd.",
  "patients.upload.fileConfiguration.importedColumns": "Geïmporteerde kolommen",
  "patients.upload.fileConfiguration.exampleData": "Voorbeelden uit de geïmporteerde data",
  "patients.upload.fileConfiguration.destination": "Kolom van bestemming",
  "patients.upload.fileConfiguration.errors.uniqueAssignment":
    "Elke kolom van bestemming kan maar één keer gekozen worden",

  "patients.upload.columnType.unassigned": "Niet toegewezen",
  "patients.upload.columnType.firstName": "Voornaam",
  "patients.upload.columnType.affix": "Tussenvoegsel",
  "patients.upload.columnType.lastName": "Achternaam",
  "patients.upload.columnType.email": "E-mailadres",
  "patients.upload.columnType.phone": "Telefoonnummer",
  "patients.upload.columnType.street": "Straatnaam",
  "patients.upload.columnType.houseNumber": "Huisnummer",
  "patients.upload.columnType.houseNumberAddition": "Toevoeging huisnummer",
  "patients.upload.columnType.postalCode": "Postcode",
  "patients.upload.columnType.city": "Plaatsnaam",
  "patients.upload.columnType.bsn": "BSN",
  "patients.upload.columnType.gender": "Geslacht",
  "patients.upload.columnType.dateOfBirth": "Geboortedatum",

  "patients.upload.resultsoverview.patient": "Patiënt",
  "patients.upload.resultsoverview.place": "Huidige gegevens",
  "patients.upload.resultsoverview.practices": "Mogelijke praktijken",
  "patients.upload.resultsoverview.status": "Status",

  "patients.upload.fileUploaded.title": "Patiëntgegevens geïmporteerd",
  "patients.upload.fileUploaded.created":
    "Er {count, plural, one {is <b>#</b> nieuwe patiënt} other {zijn <b>#</b> nieuwe patiënten}} geïmporteerd",
  "patients.upload.fileUploaded.updated":
    "Bij {count, plural, one {<b>#</b> patiënt zijn} other {<b>#</b> patiënten zijn}} de gegevens bijgewerkt",
  "patients.upload.fileUploaded.existing":
    "{count, plural, one {<b>#</b> patiënt bestond} other {<b>#</b> patiënten bestonden}} al en {count, plural, one {is} other {zijn}} niet opnieuw geïmporteerd",
  "patients.upload.fileUploaded.submit": "Oké",

  "patients.upload.gdpr.title": "Wij voldoen aan de AVG",
  "patients.upload.gdpr.point.0":
    "Zolang de patiënt bij jouw praktijk is ingeschreven mag je hun data zelf bewaren. Je mag het ook bewaren bij een organisatie die werkt conform de Algemene Verordening Gegevensbescherming (AVG), en waarmee je een verwerkingsovereenkomst hebt, zoals MijnPraktijk.",
  "patients.upload.gdpr.point.1": "Je kan op elk moment de data bij ons weer verwijderen.",
  "patients.upload.gdpr.point.2": "We gebruiken de data om het uitruilen van patiënten te faciliteren.",
  "patients.upload.gdpr.ok": "Oké",

  "patients.upload.decisionType.merge": "Updaten",
  "patients.upload.decisionType.nothing": "Niet importeren",
  "patients.upload.decisionType.new-entry": "Als nieuw persoon importeren",
  "patients.upload.columns.new": "Nieuw",
  "patients.upload.columns.existing": "Bestaand",
  "patients.upload.columns.action": "De nieuwe gegevens wil ik...",

  "patients.upload.processedpersonalinformation.missingstreet": "Straat onbekend",
  "patients.upload.processedpersonalinformation.missinghousenumber": "Huisnummer onbekend",
  "patients.upload.processedpersonalinformation.missingpostalcode": "Postcode onbekend",
  "patients.upload.processedpersonalinformation.missingname": "Naam onbekend",

  "patients.upload.duplicates.breadcrumbs.1": "Patiënten",
  "patients.upload.duplicates.breadcrumbs.2": "Patiënten ruilen",
  "patients.upload.duplicates.breadcrumbs.3": "Patiëntenbestand uploaden",
  "patients.upload.duplicates.question": "Is dit dezelfde persoon?",
  "patients.upload.duplicates.description":
    "Onderstaande patiënten lijken al een keer te zijn geïmporteerd, maar hebben nu nieuwe gegevens.",
  "patients.upload.duplicates.multipleMatches":
    "Er staan al meerdere patiënten in het systeem die op deze patiënt lijken. Kies welke u wilt bijwerken.",
  "patients.upload.duplicates.inFile":
    "Deze patiënt staat meer dan één keer in het bestand. De eerdere rij wordt als bestaande patiënt getoond.",

  "patients.upload.row_number": "Rij {n}",

  "patients.upload.invalidPatients.title": "Deze patiënten kunnen niet worden geüpload",
  "patients.upload.invalidPatients.summary":
    "{invalid, plural, one {# van de {total} patiënten kan niet worden geüpload} other {# van de {total} patiënten kunnen niet worden geüpload}} vanwege {errors, plural, one {# fout} other {# fouten}} in het bestand. {valid, plural, one {De overige patiënt wordt wel geüpload.} other {De # overige patiënten worden wel geüpload.}}",
  "patients.upload.invalidPatients.summary.none":
    "Geen van de {total} patiënten kan worden geüpload vanwege {errors, plural, one {# fout} other {# fouten}} in het bestand.",
  "patients.upload.invalidPatients.question": "Wilt u deze patiënten alsnog meenemen?",
  "patients.upload.invalidPatients.back": "Terug",
  "patients.upload.invalidPatients.continue": "Toch doorgaan",

  "patients.upload.errordialog.description_line.1":
    "Controleer of u overal de juiste kolom van bestemming gekozen hebt",
  "patients.upload.errordialog.description_line.2":
    "Zorg dat elke patiënt minstens een achternaam, een postcode en een geboortedatum heeft",
  "patients.upload.errordialog.description_line.3":
    "Herstel ongeldige waardes in het bestand en upload het bestand daarna opnieuw",
  "patients.upload.errordialog.row": "Fout in rij",
  "patients.upload.errordialog.data": "Ongeldige waarde",
  "patients.upload.errordialog.error": "Fout",
  "patients.upload.errordialog.column": "Kolom van bestemming",
  "patients.upload.errordialog.columnTitle.1": "Titel van kolom in het bestand",
  "patients.upload.errordialog.columnTitle.2": "De eerste waarde in deze kolom",
  "patients.upload.errordialog.invalid.empty_required": "Mag niet leeg zijn",
  "patients.upload.errordialog.invalid.invalid_format": "{type} niet geldig",
  "patients.upload.errordialog.invalid.configuration": "{type} is verplicht en moet gekozen worden",
  "patients.upload.errordialog.invalid.generic": "{type} niet geldig",
  "duration.hours": "{count, plural, one {# uur} other {# uren}}",
  "duration.minutes": "{count, plural, one {#m} other {#m}}",
  "duration.seconds": "{count, plural, one {#s} other {#s}}",

  "phone.call.durationTooltip": "Het gesprek duurde {duration}. De beller stond {waitingTime} in de wacht",
  "phone.call.commentsCount": "{count, plural, one {# notitie} other {# notities}}",

  "phone.title": "Telefonie",
  "phone.choosePractice": "Kies een praktijk",
  "phone.chooseDevice": "Kies de telefoon die je gebruikt",
  "phone.chooseDevice.info": "Selecteer het toestel dat je gebruikt om te bellen.",
  "phone.chooseDevice.add": "Toestellen beheren",
  "phone.chooseDevice.device": "Apparaat",
  "phone.offline":
    "Het telefoonsysteem is offline! MijnPraktijk beheerders zijn op de hoogte gebracht en werken aan een oplossing.",
  "phone.disconnected":
    "Het telefoonsysteem is niet verbonden en doet er te lang over om opnieuw te verbinden. Controleer je internetverbinding.",

  "phone.medicationRecordings": "Medicatie",
  "phone.medicationRecordings.none": "Mission complete!",
  "phone.medicationRecordings.none.info": "Er zijn geen openstaande berichten.",
  "phone.medicationRecordings.label.archived": "Medicatie voicemail voltooid",
  "phone.medicationRecordings.label.unarchived": "Medicatie voicemail",
  "phone.medicationRecordings.archived": "Afgerond",
  "phone.medicationRecordings.archived.info": "Afgeronde medicatieverzoeken worden na 30 dagen verwijderd",
  "phone.medicationRecordings.archive": "Afronden",
  "phone.medicationRecordings.archive.success": "Verzoek wordt gemarkeerd als afgerond",
  "phone.medicationRecordings.unarchive": "Opnieuw oppakken",
  "phone.medicationRecordings.unarchive.success": "Verzoek wordt opnieuw opgepakt",

  "phone.metrics": "Statistieken",
  "phone.metrics.dateRange": "Periode",
  "phone.metrics.selectPractice": "Kies een praktijk om statistieken te tonen",
  "phone.metrics.empty": "Geen gegevens in deze periode",
  "phone.metrics.avg": "gem.",
  "phone.metrics.incoming": "Inkomend",
  "phone.metrics.answered": "Beantwoord",
  "phone.metrics.unansweredNoRequest": "Onbeantwoord, geen verzoek",
  "phone.metrics.callbackPlanned": "Terugbelverzoek gepland",
  "phone.metrics.callbacks.scheduled": "Ingeboekte terugbelverzoeken",
  "phone.metrics.normal": "Normaal",
  "phone.metrics.consultation": "Overleg",
  "phone.metrics.callTypes.title": "Gesprekstypes per weekdag en uur",
  "phone.metrics.callbackOffered": "Terugbeloptie",
  "phone.metrics.callbackSlots": "Terugbelplekken",
  "phone.metrics.slotsPerHour": "plekken/uur",
  "phone.metrics.waitingTime": "Wachttijd",
  "phone.metrics.talkTime": "Gesprekstijd",
  "phone.metrics.volume.title": "Aantal gesprekken",
  "phone.metrics.times.title": "Wacht- en gesprekstijd",
  "phone.metrics.consultation.title": "Overleg",
  "phone.metrics.emergency": "Spoed",
  "phone.metrics.medication.title": "Medicatieverzoeken",
  "phone.metrics.completeThrough": "Cijfers t/m {date}",
  "phone.metrics.emptyIncomplete": "Nog geen cijfers voor deze periode — de cijfers lopen t/m {date}",

  "phone.available": "Praktijk beschikbaar",
  "phone.unavailable": "Praktijk afwezig",
  "phone.unavailable.duration": "Afwezig voor: {duration}",
  "phone.unavailable.duration.change": "Klik om tijdsbestek aan te passen",
  "phone.unavailable.apply": "Zet assistente op niet beschikbaar",
  "phone.unavailable.info":
    "Patiënten die bellen horen dat de assistente momenteel niet beschikbaar is, en worden gevraagd het later nog eens te proberen. Voor patiënten die momenteel in de wachtrij staan, wordt de verbinding beëindigd!\n\nTerugbel afspraken kunnen voor het tijdsbestek niet gepland, maar eerder geplande afspraken blijven wel gewoon staan.",
  "phone.callList": "Oproeplijst",
  "phone.callList.info": "Selecteer een oproep om te accepteren",
  "phone.callList.empty": "Wachten op oproepen",
  "phone.callList.empty.info": "Geen inkomende of geplande belletjes.",
  "phone.callList.unknown": "Onbekende beller",
  "phone.callList.archive": "Archief",
  "phone.callList.archive.info": "Alleen gearchiveerde gesprekken van de laatste 30 dagen zijn zichtbaar",

  "phone.incoming": "Inkomend gesprek",
  "phone.incoming.ended": "Beëindigd gesprek",
  "phone.incoming.ended.info": "Het is niet meer mogelijk om de beller te bereiken",
  "phone.incoming.ended.short": "Beëindigd",
  "phone.incoming.endedWithoutAnswer": "Heeft opgehangen voordat er werd opgenomen (wachttijd: {waitingTime})",
  "phone.callback.completed": "Gesprek afgerond",
  "phone.incoming.automaticRinging": "Gesprekken worden al automatisch naar uw apparaat doorgeschakeld",

  "phone.eventLog.showMore": "+ Nog {count} bekijken",
  "phone.eventLog.device": "Iemand via apparaat {deviceName}",
  "phone.eventLog.outgoingCall": "Uitgaand gesprek",
  "phone.eventLog.incomingCall": "Binnenkomend gesprek",
  "phone.eventLog.answered": "Opgenomen: {duration}",
  "phone.eventLog.unanswered": "Niet opgenomen",
  "phone.eventLog.callInProgress": "Gesprek in uitvoering",
  "phone.eventLog.scheduledCallback": "Gepland om {time}",
  "phone.eventLog.addComment": "Typ een notitie...",

  "phone.scheduled": "Gepland",
  "phone.scheduledAt": "Gepland {isTimeOnly, select, true {om} other {op}} {time}",
  "phone.connectedToMe": "Aan de telefoon",
  "phone.connectedToCallGroup": "Naar belgroep",
  "phone.connectedToColleague": "Opgepakt door collega",

  "phone.reasonToCall.regular": "Patiënt",
  "phone.reasonToCall.consultation": "Overleg",
  "phone.reasonToCall.emergency": "Spoed",

  "phone.callFilter.show": "Toon",
  "phone.callFilter.all": "Alle",
  "phone.callFilter.callback": "Terugbel",
  "phone.callFilter.queued": "Wachtrij",

  "phone.timePast": "{time} {type, select, queue {in de wacht} other {te laat}}",
  "phone.timeFuture": "Bel binnen {time}",
  "phone.caller": "Beller",
  "phone.pickup": "Opnemen",
  "phone.call": "Nu bellen",
  "phone.callAgain": "Opnieuw",
  "phone.callAgain.tooltip": "Opnieuw bellen",
  "phone.endCall": "Ophangen",

  "phone.connectingDevices.connecting": "Verbinden met {deviceName}",
  "phone.connectingDevices.connected": "Verbonden met {deviceName}",

  "phone.archive": "Sluit & archiveer",
  "phone.archive.disabled": "Archiveren is niet mogelijk voor een actief gesprek",
  "phone.unarchive": "Archiveren ongedaan maken",

  "phone.econsultLink.send": "Vraag patiënt om foto",
  "phone.econsultLink.send.info":
    "Stuurt de patiënt een SMS met een link waarmee die zonder in te loggen een foto of bericht kan delen. Jij krijgt een portaal link om het bericht in te zien.",
  "phone.econsultLink.sent": "E-consult link via SMS verstuurd",
  "phone.econsultLink.open": "Open e-consult",

  "phone.eventLog.econsultLinkSent": "Link verstuurd",
  "phone.eventLog.econsultPatientAuthor": "Beller",
  "phone.eventLog.econsultAttachment": "[Afbeelding]",
  "phone.eventLog.econsultAttachmentFile": "[Bestand]",
  "phone.call.patientMessagesCount": "{count, plural, one {# bericht van beller} other {# berichten van beller}}",

  "phone.transcription.loading": "Gesprek wordt uitgeschreven",
  "phone.transcription.completed": "Bekijk SOEP bericht",
  "phone.transcription.noMessages": "Geen SOEP bericht beschikbaar",
  "phone.transcription.unavailable": "Bericht is niet uitgeschreven",
  "phone.transcription.sidebar.title": "Rapport opslaan",
  "phone.transcription.sidebar.subTitle": "Bekijk rapportage",
  "phone.transcription.sidebar.messageTitle": "SOEP bericht",

  "phone.archive.search.placeholder": "Zoek telefoonnummer",

  "portalDetail.internalNotes.title": "Notities",
  "portalDetail.internalNotes.placeholder": "Plaats een opmerking...",
  "portalDetail.assignedTo.saved": "Toegewezen aan {assignedTo}",
  "portalDetail.assignedToNone.saved": "Niet toegewezen",
  "portalDetail.assignedTo": "Toegewezen aan",
  "portalDetail.assignedTo.tooltip": "Wijs mensen toe",
  "portalDetail.unassigned": "Niet toegewezen",

  "statusFilter.econsults.open": "Open digitale consulten",
  "statusFilter.econsults.econsult": "E-consults",
  "statusFilter.econsults.appointment": "Video afspraken",
  "statusFilter.econsults.walkInConsult": "Inloopspreekuur",
  "statusFilter.econsults.stayHomeAdvice": "Thuisadviezen",
  "statusFilter.econsults.outOfScope": "Niet van toepassing",
  "statusFilter.econsults.phoneConsult": "Telefonisch",
  "statusFilter.econsults.closed": "Afgesloten digitale consulten",
  "statusFilter.econsults.all": "Alle digitale consulten",
  "statusFilter.inbox.all": "Alle items",
  "assignedFilter.all": "Alle toewijzingen",
  "assignedFilter.me": "Aan mij toegewezen",
  "assignedFilter.unassigned": "Niet toegewezen",

  "practiceFilter.all": "Alle praktijken",

  "sidenav.expand": "Menu uitklappen",
  "sidenav.collapse": "Menu inklappen",
  "sidenav.edit": "Menu bewerken",
  "sidenav.save": "Opslaan",
  "sidenav.practice.settings": "Instellingen",
  "sidenav.practice.appointment.list": "Afspraken",
  "sidenav.practice.econsult.list": "Digitale consulten",
  "sidenav.practice.medication.request.list": "Herhaalmedicatie",
  "sidenav.practice.new.patient.list": "Inschrijvingen",
  "sidenav.practice.patient.list": "Patiënten",
  "sidenav.inbox": "Inbox",
  "sidenav.phone": "Telefonie",
  "sidenav.admin": "Admin",
  "sidenav.admin.users": "Gebruikers",
  "sidenav.admin.patientAccounts": "Patiëntaccounts",
  "sidenav.admin.practices": "Praktijken",
  "sidenav.admin.careGroups": "Zorggroepen",
  "sidenav.admin.authorizationClaims": "Autorisatie claims",
  "sidenav.admin.auditTrails": "Audittrails",
  "sidenav.admin.maintenanceBanners": "Onderhoudsbanners",
  "sidenav.admin.telephonyTenants": "Telefonie-accounts",
  "sidenav.careGroup.overview": "Inzichten huisartsenzorg",
  "sidenav.careGroup.settings": "Zorggroep instellingen",
  "userAccountMenu.open": "Open gebruikersaccount menu",
  "userAccountMenu.as": "Aangemeld als",
  "userAccountMenu.myAccount": "Mijn account",
  "userAccountMenu.signout": "Uitloggen",

  practice: "Praktijk",
  "practice.create.success": "Praktijk aangemaakt",
  "practice.select.title": "Praktijk configuratie",
  "practice.name": "Naam",
  "practice.name.placeholder": "Vul naam in",
  "practice.slug": "Webadres",
  "practice.slug.placeholder": "Vul de tekst voor de domeinnaam in",
  "practice.select.slugNotFound": "Praktijk {slug} niet gevonden, of je hebt geen toegang.",
  "practice.select.noAccess":
    "Er zijn geen praktijken waar je beheerder van bent. Vraag een beheerder om je toegang te geven.",
  "practice.accessExpired.title": "Toegang verlopen",
  "practice.accessExpired.description":
    "Je toegang tot praktijk {practice} is verlopen. Verkrijg opnieuw toegang om verder te gaan met de configuratie.",
  "practice.accessExpired.backToPractices": "Terug naar het praktijkenoverzicht",
  "practice.accessExpired.backToPortal": "Terug naar de inbox",
  "practice.page.general": "Praktijk",
  "practice.page.general.features": "Toepassingen",
  "practice.page.logo": "Logo",
  "practice.page.his": "HIS koppeling",
  "practice.page.pages": "Site pagina's",
  "practice.page.pharmacies": "Apotheken",
  "practice.page.authorizations": "Medewerkers",
  "practice.page.agendas": "Agenda's",
  "practice.page.agendaBlocks": "Agenda blokken",
  "practice.page.walkInConsult": "Digitaal inloopspreekuur",
  "practice.page.phoneSystem": "Telefonie",
  "practice.page.labels": "Labels",
  "practice.page.triageOutcome": "Uitkomst vragenlijst",
  "practice.page.triageOutcomes": "Opvolging vragenlijst",
  "practice.page.responseTemplates": "Antwoord templates",
  "practice.page.communicationTemplates": "Communicatie templates",
  "practice.page.notifications": "Notificaties",
  "practice.page.registrations": "Inschrijvingen",
  "practice.page.digid": "DigiD",
  "practice.group.general": "Algemeen",
  "practice.group.notificationsAndCommunication": "Notificaties & Communicatie",
  "practice.group.registration": "Inschrijven",
  "practice.group.portal": "Portaal",
  "practice.configuration.slug": "Webadres",
  "practice.configuration.slug.fullAddress": "Het nieuwe webadres is dan: ",

  "practice.configuration.emailAndWebsite.title": "Email & Website",
  "practice.configuration.fromEmail": "Afzender e-mailadres",
  "practice.configuration.fromEmail.noAccess":
    "Neem contact op met support@mijnpraktijk.nl om het afzender e-mailadres te wijzigen",
  "practice.configuration.fromEmail.admin":
    "Voor het wijzigen van het afzender e-mailadres zie het stappenplan in de Wiki",
  "practice.configuration.replyToEmail": "Reactie e-mailadres",
  "practice.configuration.replyToEmail.info":
    "Als patiënten een e-mail van MijnPraktijk proberen te beantwoorden, is het handig dat de reactie direct naar een praktijk e-mailadres gaat.",
  "practice.configuration.agbCode": "AGB-code",
  "practice.configuration.nameAndAddress.title": "Naam & adres",
  "practice.configuration.automaticActions.title": "Automatische handelingen",
  "practice.configuration.address.segment.agb": "AGB-adres",
  "practice.configuration.address.segment.custom": "Aangepast adres",
  "practice.configuration.address.agbReadonly": "Adres volgens het AGB-register",
  "practice.configuration.address.noAgb": "Er is geen adres bekend in het AGB-register voor deze praktijk.",
  "practice.configuration.zorgMail": "Zorgmail ID",
  "practice.configuration.phoneNumbers.title": "Telefoonnummers",
  "practice.configuration.phoneNumber": "Praktijk telefoonnummer",
  "practice.configuration.emergencyPhoneNumber": "Spoed telefoonnummer (laat leeg indien hetzelfde als praktijknummer)",
  "practice.configuration.hapPhoneNumber": "Huisartsenpost telefoonnummer",
  "practice.configuration.externalWebsiteUrl": "Externe website URL",
  "practice.configuration.externalWebsiteUrl.validation": "Vul een geldige URL in",
  "practice.configuration.journalClosesConsult":
    "Bij het versturen van een journaalregel wordt het digitale consult automatisch gesloten",
  "practice.configuration.journalClosesConsult.info":
    "Wanneer een journaalregel naar het HIS wordt gestuurd, wordt het digitale consult afgesloten. Dit betekent dat de patiënt niet meer kan reageren op het digitale consult en video wordt beëindigd.",
  "practice.configuration.analyticsPermission": "Anonieme gegevens opslaan voor kwaliteitsverbetering",
  "practice.configuration.analyticsPermission.info":
    "Om de kwaliteit én efficiëntie van zorg te verbeteren. De gegevens zijn anoniem en kunnen niet naar individuele patiënten worden herleid. De statistieken geven ook inzicht in wat jouw praktijk kan leren van andere praktijken. En andersom!",
  "practice.configuration.includeInSearch.header": "nederland.iedereenhuisarts.nl",
  "practice.configuration.includeInSearch": "Laat praktijk zien op nederland.iedereenhuisarts.nl",
  "practice.configuration.includeInSearch.info":
    "Hier verwijzen wij patiënten naartoe die een huisarts zoeken. Als je dit uitzet ben je onzichtbaar op de landelijke overzichtspagina. Je blijft wel vindbaar via je praktijkpagina en het overzicht van je zorggroep.",

  "practice.pharmacies.title": "Apotheken",
  "practice.pharmacies.allowCustom": "Laat patiënten een aangepaste apotheek invoeren",
  "practice.pharmacies.agbCode": "AGB-code",
  "practice.pharmacies.addItem": "Apotheek toevoegen",
  "practice.pharmacies.empty.title": "Geen apotheken",
  "practice.pharmacies.empty.description":
    "Er zijn nog geen apotheken. Gebruik de knop hieronder om er een aan te maken.",

  "practice.walkInConsult.intro":
    "Tijdens de momenten dat het inloopspreekuur open staat, kunnen patiënten een e-consult starten en plaatsnemen in de digitale wachtkamer. Je kan de wachtende patiënten vinden bij het econsulten overzicht.",
  "practice.walkInConsult.addItem": "Tijdslot toevoegen",
  "practice.walkInConsult.empty.title": "Geen tijdsloten",
  "practice.walkInConsult.empty.description":
    "Er zijn nog geen tijdsloten. Gebruik de knop hieronder om er een aan te maken.",

  "practice.phone.init.title": "Telefoonsysteem nog niet geactiveerd",
  "practice.phone.init.info": "Neem contact op met {email} voor meer informatie.",
  "practice.phone.init.switchInfo": "Alleen uitzetten als je geen defaults wilt",
  "practice.phone.init.templates": "Maak standaard bandjes aan",
  "practice.phone.init.schedule": "Initialiseer dagelijkse schemas",
  "practice.phone.init.button": "Initialiseer",

  "practice.phone.menuAudio.default": "Standaard tekstbericht",
  "practice.phone.menuAudio.text": "Schrijf tekstbericht",
  "practice.phone.menuAudio.text.info":
    "Engelse teksten kunnen tussen [en] en [/en] geplaatst worden. Ook kunnen {link} gebruikt worden.",
  "practice.phone.menuAudio.text.info.link": "SSML tags",
  "practice.phone.menuAudio.file": "Upload audio bestand",
  "practice.phone.menuAudio.file.missing": "Geen bestand gekozen",
  "practice.phone.menuAudio.file.loading": "Laden...",
  "practice.phone.menuAudio.play": "Afspelen",
  "practice.phone.menuAudio.stop": "Stoppen",

  "practice.phone.general": "Algemene telefooninstellingen",
  "practice.phone.general.incomingPhoneNumbers": "Inkomende telefoonnummers",
  "practice.phone.general.incomingPhoneNumbers.add": "Telefoonnummer",
  "practice.phone.general.incomingPhoneNumbers.remove": "Telefoonnummer verwijderen",
  "practice.phone.general.incomingPhoneNumbers.admin.info": "Zie {link} hoe telefoonnummers moeten worden ingeregeld",
  "practice.phone.general.incomingPhoneNumbers.admin.link": "documentatie",
  "practice.phone.general.menuOptionEnglish": "Engelse menu-optie",
  "practice.phone.general.allowPrescription": "Herhaalrecepten inspreken",
  "practice.phone.general.prescriptionNlMenuAudio": "Herhaalrecepten menu Nederlands",
  "practice.phone.general.prescriptionEnMenuAudio": "Herhaalrecepten menu Engels",
  "practice.phone.general.tenant": "Telefonie-account (Univerge Blue)",
  "practice.phone.general.tenant.none": "Geen account toegewezen",
  "practice.phone.general.tenant.info":
    "Het Univerge Blue-account waarop de toestellen van deze praktijk worden gekoppeld en waarop terugbelverzoeken worden geplaatst. Bij een wijziging worden alle gekoppelde toestellen ontkoppeld en moeten ze opnieuw worden verbonden.",
  "practice.phone.general.tenant.success": "Telefonie-account opgeslagen",

  "practice.phone.devices": "Toestellen",
  "practice.phone.devices.info":
    "Inkomende telefoongesprekken kunnen naar toestellen worden doorgestuurd. Kies welke toestellen je wilt gebruiken om telefoongesprekken te ontvangen.",
  "practice.phone.devices.addItem": "Toestel toevoegen",
  "practice.phone.devices.empty.title": "Geen toestellen",
  "practice.phone.devices.empty.description":
    "Er zijn nog geen toestellen. Gebruik de knop hieronder om er een aan te maken.",
  "practice.phone.devices.confirmRemove.title": "Toestel verwijderen",
  "practice.phone.devices.confirmRemove.content": "Weet je zeker dat je toestel {name} wilt verwijderen?",
  "practice.phone.devices.name": "Naam",
  "practice.phone.devices.phoneNumber": "Telefoonnummer",
  "practice.phone.devices.phoneNumber.info":
    "Het nummer waarop het toestel wordt gebeld, of het 4-cijferige extensienummer op het Univerge Blue-account van de praktijk.",
  "practice.phone.devices.phoneNumberIncorrect":
    "Vul een telefoonnummer van 10 cijfers, een nummer dat begint met + of een extensienummer van 4 cijfers in",
  "practice.phone.devices.timeout": "Maximaal aantal seconden overgaan",
  "practice.phone.devices.timeout.info":
    "Om te voorkomen dat de oproep naar voicemail gaat, moet deze waarde iets minder zijn dan wanneer voicemail zou antwoorden.",
  "practice.phone.devices.moreThan0.validation": "Vul een getal groter dan 0 in",
  "practice.phone.devices.adminOnly":
    "Neem contact op met support@mijnpraktijk.nl om deze instelling te laten wijzigen.",
  "practice.phone.devices.auth.noTenant":
    "Deze praktijk heeft nog geen telefonie-account. Wijs er eerst een toe onder Telefoon → Algemeen; daarna kunnen toestellen worden verbonden.",
  "practice.phone.devices.auth.label": "Univerge Blue account",
  "practice.phone.devices.auth.status.connected": "Verbonden",
  "practice.phone.devices.auth.status.disconnected": "Niet verbonden",
  "practice.phone.devices.auth.connect": "Verbinden",
  "practice.phone.devices.auth.reconnect": "Opnieuw verbinden",
  "practice.phone.devices.auth.disconnect": "Verbinding verbreken",
  "practice.phone.devices.auth.connect.error": 'Toestel "{deviceName}" kon niet worden gekoppeld',
  "practice.phone.devices.auth.disconnect.success": 'Toestel "{deviceName}" is ontkoppeld',
  "practice.phone.devices.auth.verify": "Account controleren",
  "practice.phone.devices.auth.verify.title": "Gekoppeld Univerge Blue account",
  "practice.phone.devices.auth.verify.question": "Klopt deze informatie?",
  "practice.phone.devices.auth.verify.mijnpraktijk": "Toestel in MijnPraktijk",
  "practice.phone.devices.auth.verify.elevate": "Toestellen van het Univerge Blue account",
  "practice.phone.devices.auth.verify.deviceId": "Toestel-ID",
  "practice.phone.devices.auth.verify.deviceType": "Type toestel",
  "practice.phone.devices.auth.verify.empty": "Geen toestellen gevonden voor dit account.",
  "practice.phone.devices.auth.verify.error":
    "De toestellen van dit Univerge Blue account konden niet worden opgehaald.",
  "practice.phone.devices.auth.verify.confirm": "Ja, dit klopt",
  "practice.phone.devices.auth.verify.reject": "Nee, verbinding verbreken",
  "practice.phone.devices.preventImmediateAnswer": "Automatische voicemail detectie",
  "practice.phone.devices.preventImmediateAnswer.info":
    "Deze instelling moet alleen worden ingeschakeld voor persoonlijke mobiele telefoons met voicemail! Yealink apparaten zullen niet werken zoals verwacht. In plaats daarvan moet je de voicemail op het apparaat uitschakelen. Als je dit aanvinkt en er wordt binnen een seconde opgenomen, zal het systeem aannemen dat er door een voicemail is opgenomen en wordt het gesprek onmiddellijk beëindigd.",
  "practice.phone.devices.useDesktopClient": "Gesprekken beantwoorden in de Univerge Blue desktopclient",
  "practice.phone.devices.useDesktopClient.info":
    "Schakel dit in als de assistent de Univerge Blue Connect desktopclient heeft geïnstalleerd. Het systeem zal dan proberen om inkomende gesprekken automatisch te beantwoorden in de desktopclient.",
  "practice.phone.devices.ringRegularCalls": "Automatisch overgaan voor reguliere gesprekken, na",
  "practice.phone.devices.ringConsultationCalls": "Automatisch overgaan voor intercollegiaal overleg, na",
  "practice.phone.devices.ringEmergencyCalls": "Automatisch overgaan voor spoed, na",
  "practice.phone.devices.ringDelaySeconds": "seconden",

  "practice.phone.templates": "Bandjes",
  "practice.phone.templates.info":
    "In een bandje kan je verschillende telefooninstellingen opslaan. Bijvoorbeeld: Een bandje voor wanneer de assistent pauze heeft, of een bandje voor reguliere ochtenduren. In het telefoonschema kan je configureren wanneer deze bandjes actief zijn.",
  "practice.phone.templates.addItem": "Bandje toevoegen",
  "practice.phone.templates.empty.title": "Geen bandjes",
  "practice.phone.templates.empty.description":
    "Er zijn nog geen bandjes. Gebruik de knop hieronder om er een aan te maken.",
  "practice.phone.templates.confirmRemove.title": "Bandje verwijderen",
  "practice.phone.templates.confirmRemove.content":
    'Weet je zeker dat je bandje "{name}" wilt verwijderen? {isSaved, select, true {Alle schema\'s die dit gebruiken worden ook verwijderd!} other {}}',
  "practice.phone.templates.closed.info":
    "Dit standaard bandje kan niet worden verwijderd en wordt gebruikt wanneer het schema leeg is",
  "practice.phone.templates.assistantUnavailable.info":
    "Dit standaard bandje kan niet worden verwijderd en wordt gebruikt wanneer de assistente is ingesteld op tijdelijk niet beschikbaar",
  "practice.phone.templates.name": "Naam",
  "practice.phone.templates.colour": "Kleur",
  "practice.phone.templates.practiceStatus": "Praktijk is",
  "practice.phone.templates.practiceOpen": "Open",
  "practice.phone.templates.practiceClosed": "Gesloten",
  "practice.phone.templates.allowQueueing": "Wachtrij toestaan",
  "practice.phone.templates.allowCallback": "Terugbelafspraak mogelijkheid",
  "practice.phone.templates.allowConsultation": "Intercollegiaal overleg mogelijkheid",
  "practice.phone.templates.scheduleCallbacksPerHour": "Aantal terugbelafspraken per uur inplannen",
  "practice.phone.templates.scheduleCallbacksPerHour.validation": "Voer een heel getal in tussen 1 en {max}",
  "practice.phone.templates.welcomeMenuAudio": "Welkomstmenu Nederlands",
  "practice.phone.templates.englishMenuAudio": "Welkomstmenu Engels",
  "practice.phone.templates.menuAudioChangeWarning":
    "Je hebt de instellingen van dit bandje aangepast. Zorg ervoor dat je ook het welkomstmenu (hieronder) bijwerkt, of gebruik het standaard tekstbericht.",

  "practice.phone.schedule": "Schema",
  "practice.phone.schedule.add": "Tijdslot",
  "practice.phone.schedule.event.add": "Tijdslot toevoegen",
  "practice.phone.schedule.event.edit": "Tijdslot bewerken",
  "practice.phone.schedule.template": "Bandje",
  "practice.phone.schedule.template.placeholder": "Kies een bandje",
  "practice.phone.schedule.template.new": "Nieuw bandje",
  "practice.phone.schedule.type": "Schema",
  "practice.phone.schedule.type.oneTime": "Eenmalig",
  "practice.phone.schedule.type.oneTime.info":
    "Dit evenement vindt slechts eenmalig plaats, en overschrijft het herhalende schema.",
  "practice.phone.schedule.type.repeating": "Herhaalt wekelijks",
  "practice.phone.schedule.type.repeating.info":
    "Herhaalt op de geselecteerde dag. Eenmalige evenementen zullen altijd dit schema overschrijven.",
  "practice.phone.schedule.days": "Op welke dagen?",
  "practice.phone.schedule.days.hint.single":
    "Kies één of meer dagen. Meerdere dagen blijven daarna aan elkaar gekoppeld.",
  "practice.phone.schedule.days.hint.linked":
    "Deze {count} dagen horen bij elkaar — een wijziging geldt voor alle. Een dag uitzetten haalt dat tijdslot uit het rooster.",
  "practice.phone.schedule.delete": "Verwijder tijdslot",
  "practice.phone.schedule.delete.confirm": "Verwijderen",
  "practice.phone.schedule.delete.confirm.title": "Tijdslot verwijderen?",
  "practice.phone.schedule.delete.confirm.body": "Dit tijdslot wordt uit het rooster verwijderd.",
  "practice.phone.schedule.scope.title": "Dit tijdslot staat elke {weekday} in het rooster",
  "practice.phone.schedule.scope.once": "Alleen deze week",
  "practice.phone.schedule.scope.weekly": "Elke week",
  "practice.phone.schedule.scope.save.title": "Terugkerend tijdslot opslaan:",
  "practice.phone.schedule.scope.save.once": "Dit tijdslot",
  "practice.phone.schedule.scope.save.weekly": "Deze en volgende tijdsloten",
  "practice.phone.schedule.scope.convert.weekly": "Stop met herhalen",
  "practice.phone.schedule.scope.convert.weekly.info":
    "Het wekelijkse tijdslot verdwijnt uit alle weken; alleen dit eenmalige tijdslot blijft over.",
  "practice.phone.schedule.scope.delete.question": "Wat wil je verwijderen?",
  "practice.phone.schedule.scope.delete.once.info":
    "Alleen in de week van {weekStart}. De andere weken blijven zoals ze nu zijn.",
  "practice.phone.schedule.scope.delete.weekly.info": "Het tijdslot verdwijnt uit alle weken.",
  "practice.phone.schedule.override.thisWeek": "Deze week aangepast",
  "practice.phone.schedule.legend.oneTime": "Eenmalig tijdslot — ligt over het wekelijkse rooster",

  "practice.phone.phoneNumberIncorrect": "Telefoonnummer moet 10 cijfers zijn of beginnen met +",
  "practice.labels.intro": "Labels worden voor alle items getoond en kunnen gebruikt worden in de filtering.",
  "practice.labels.tooWhite": "Deze kleur is te licht om goed te zien",
  "practice.labels.addItem": "Label toevoegen",
  "practice.labels.empty.title": "Geen labels",
  "practice.labels.empty.description": "Er zijn nog geen labels. Gebruik de knop hieronder om er een aan te maken.",

  "practice.his.intro": "Door het HIS te koppelen aan MijnPraktijk kunnen we data uitwisselen.",
  "practice.his.his": "Selecteer je HIS",
  "practice.his.disabled": "Uitgeschakeld",
  "practice.his.connectionViaApi.header": "Koppeling via API",
  "practice.his.connectionViaApi.info":
    "Een API koppeling geeft de meest betrouwbare data. Deze staat daarom standaard aan.",
  "practice.his.bricksApiTarget": "Bricks Tetra API target",
  "practice.his.bricksRegistrationAgb": "Bricks Tetra zorgverlener AGB-code voor inschrijvingen",
  "practice.his.sandayOrganizationId": "Sanday organisatie ID",
  "practice.his.healthConnected.info":
    "HealthConnected koppelt op basis van de AGB-code van uw praktijk; hier hoeft niets ingesteld te worden. Na het koppelen kunt u de HealthConnected-agenda's koppelen onder Instellingen › Agenda's.",
  "practice.his.microHisDatabaseId": "MicroHIS database ID",
  "practice.his.microHisPraktijkCode": "MicroHIS praktijkcode (optioneel)",
  "practice.his.microHisPraktijkCode.info":
    "Alleen nodig als Dedalus uw praktijk herkent op praktijkcode in plaats van AGB-code, bijvoorbeeld in een demo-database. Indien ingevuld gebruikt MicroHIS deze in plaats van de AGB-code.",
  "practice.his.omniHisApiTarget": "OmniHis API target",
  "practice.his.appointmentCancelMinMinutes.1": "Afspraken mogen online geannuleerd worden, tot",
  "practice.his.appointmentCancelMinMinutes.2": "voor het begin van de afspraak",
  "practice.his.appointmentCancelMinMinutes.minutes": "Minuten",
  "practice.his.appointmentCancelMinMinutes.hours": "Uren",
  "practice.his.appointmentCancelMinMinutes.days": "Dagen",
  "practice.his.appointmentCancelMinMinutes.weeks": "Weken",
  "practice.his.testConnection.btn": "Test verbinding via API",
  "practice.his.testConnection.success": "Verbinding succesvol",
  "practice.his.testConnection.error": "Verbinding niet geslaagd. Het HIS reageert niet, of de API code klopt niet.",
  "practice.his.connectionViaRpa.header": "Aanvullende koppeling (via RPA)",
  "practice.his.connectionViaRpa.info.disconnected":
    "Via onderstaande knop ga je naar de site van onze partner AutoMedic, waar je de RPA kunt aanzetten.",
  "practice.his.connectionViaRpa.info.connected": "Er is een verbinding gemaakt met onze partner AutoMedic voor RPA.",
  "practice.his.connectionViaRpa.info.lost":
    "AutoMedic heeft de toegang van de RPA ingetrokken, waardoor de verbinding is verbroken. Inschrijvingen en journaalregels worden niet meer automatisch naar het HIS gestuurd totdat je de verbinding opnieuw maakt. Verstuur daarna de mislukte inschrijvingen en journaalregels opnieuw.",
  "practice.his.rpaModal.title": "Aanvullende koppeling (via RPA)",
  "practice.his.rpaModal.text":
    "We bieden een aanvullende koppeling aan via een RPA (Robotic Process Automation). Dat is een soort robot die voor jou klikt. Daarmee kunnen bepaalde gegevens automatisch en snel overgezet worden. Zonder de RPA zou dat handwerk zijn.",
  "practice.his.autoMedic.label": "Connectie status",
  "practice.his.autoMedic.status.disconnected": "Geen verbinding",
  "practice.his.autoMedic.status.lost": "Verbinding verbroken door AutoMedic op {date}",
  "practice.his.autoMedic.status.connected": "Verbonden",
  "practice.his.autoMedic.btn.connect": "Maak verbinding via RPA",
  "practice.his.autoMedic.btn.disconnect": "Verbreek verbinding via RPA",
  "practice.his.autoMedic.connect.success": "Verbinding met AutoMedic is aangemaakt",
  "practice.his.autoMedic.disconnect.success": "Verbinding met AutoMedic is verbroken",
  "practice.his.autoMedic.saveChanges":
    "Sla eerst de wijzigingen op, voordat er verbinding met AutoMedic gemaakt kan worden",
  "practice.his.capabilities.header": "Dit wisselen we automatisch uit met {his}",
  "practice.his.capabilities.info": "Per functie zie je voor wie het is. Andere gegevens zet je zelf over.",
  "practice.his.capabilities.api.disconnected":
    "De koppeling met {his} staat nu uit. Zodra je verbinding maakt, wisselen we onderstaande gegevens automatisch uit.",
  "practice.his.capabilities.rpa.disconnected":
    "Beschikbaar, maar staat nu uit. Met een RPA-verbinding wisselen we dit ook uit:",
  "practice.his.capabilities.group.patients": "Voor je patiënten",
  "practice.his.capabilities.group.practice": "Voor de praktijk",
  "practice.his.capabilities.core": "Online een afspraak maken",
  "practice.his.capabilities.appointmentList": "Gemaakte afspraken zien",
  "practice.his.capabilities.appointmentCancel": "Een afspraak afzeggen",
  "practice.his.capabilities.prescribedMedication": "Voorgeschreven medicijnen zien",
  "practice.his.capabilities.medicationRequest": "Een herhaalrecept aanvragen",
  "practice.his.capabilities.medicalResults": "Uitslagen en brieven inzien",
  "practice.his.capabilities.allergies": "Allergieën inzien",
  "practice.his.capabilities.episodes": "Episodes inzien",
  "practice.his.capabilities.loginDigid": "Inloggen met DigiD",
  "practice.his.capabilities.loginPassword": "Inloggen met e-mail en wachtwoord",
  "practice.his.capabilities.registration": "Een nieuwe patiënt inschrijven",
  "practice.his.capabilities.patientLookup": "Een patiënt opzoeken in het HIS",
  "practice.his.capabilities.agendaBlocks": "Agenda blokken uit het HIS ophalen",
  "practice.his.capabilities.addFileToPatient": "Een bestand of afbeelding aan het dossier toevoegen",
  "practice.his.capabilities.sendJournal": "Journaalregel naar het HIS sturen",
  "practice.his.capabilities.charge": "Een consult declareren",
  "practice.his.capabilities.deepLinks": "Het dossier direct in het HIS openen",
  "practice.his.noConnection.header": "We hebben nog geen koppeling met {his}",
  "practice.his.noConnection.body":
    "Je kunt MijnPraktijk gewoon gebruiken. Maar gegevens worden niet automatisch uitgewisseld met {his}. Je zet ze dus zelf over.",
  "practice.his.noConnection.noted":
    "We hebben genoteerd dat jouw praktijk {his} gebruikt, zodat we je op tijd kunnen helpen zodra er een koppeling is.",

  "practice.pages.addItem": "Pagina toevoegen",
  "practice.pages.empty.title": "Geen site pagina's",
  "practice.pages.empty.description":
    "Er zijn nog geen site pagina's. Gebruik de knop hieronder om er een aan te maken.",
  "practice.pages.intro":
    "Site pagina's worden op volgorde aan patiënten getoond. Nieuwe pagina's kunnen pas worden versleept als ze zijn opgeslagen.",
  "practice.pages.noRecord": "Er zijn op dit moment geen site pagina's",
  "practice.pages.tab.sitePages": "Site pagina's",
  "practice.pages.tab.website": "Website",
  "practice.pages.confirmRemove.title": "Pagina verwijderen",
  "practice.pages.confirmRemove.content": "Weet je zeker dat je pagina {pageSlug} wilt verwijderen?",
  "practice.pages.confirmRemove.success": "Pagina is verwijderd",
  "practice.pages.slug": "Webadres",
  "practice.pages.slug.fullAddress": "Het nieuwe webadres is dan: ",
  "practice.pages.slug.warning":
    "LET OP: wijzigen van het webadres kan er voor zorgen dat patiënten de pagina niet meer kunnen vinden.",
  "practice.pages.slug.validation": "Webadres mag alleen a-z (dus geen hoofdletters) en 0-9 (cijfers) bevatten",
  "practice.pages.slug.validationForbidden": "Dit webadres is niet toegestaan",
  "practice.pages.poster": "Poster met QR-code",
  "practice.pages.poster.download": "Poster downloaden (PDF)",
  "practice.pages.poster.info":
    "Een A4-poster met de QR-code en het webadres van deze pagina. Printen en ophangen in de wachtkamer, of neerleggen bij de balie.",
  "practice.pages.poster.unsaved": "Sla de pagina eerst op, dan staat het juiste webadres in de poster.",
  "practice.pages.module": "Type",
  "practice.pages.module.static": "Statische pagina",
  "practice.pages.module.appointmentCreation": "Afspraak maken",
  "practice.pages.module.appointmentList": "Afspraken lijst",
  "practice.pages.module.econsult": "E-consult",
  "practice.pages.module.walkInConsult": "Digitaal inloopspreekuur",
  "practice.pages.module.medicationRequest": "Herhaalrecept",
  "practice.pages.module.registrationRequest": "Inschrijving",
  "practice.pages.module.myMedicalFile": "Medisch dossier",
  "practice.pages.module.incorrect": "Dit type is niet mogelijk",
  "practice.pages.overview": "Tegel op website tonen",
  "practice.pages.overview.hintForRegistrations":
    "Is de site pagina open voor inschrijvingen? Dan kunnen mensen die het webadres hebben zich inschrijven. Ook als de tegel verborgen is.",
  "practice.pages.overview.nl": "Overzichtspagina NL",
  "practice.pages.overview.en": "Overzichtspagina EN",
  "practice.pages.overviewIcon.label": "Overzichtspagina icoon",
  "practice.pages.overviewIcon.edit": "Wijzigen",
  "practice.pages.overviewIcon.title": "Overzichtspagina icoon van {slug}",
  "practice.pages.labels.registration": "Labels toevoegen aan inschrijvingen via deze site pagina",
  "practice.pages.labels.registration.description":
    "In het overzicht van nieuwe inschrijvingen kan op deze labels worden gefilterd.",
  "practice.pages.introPage": "Introductiepagina tonen",
  "practice.pages.introPage.hintForRegistrations": "Deze pagina wordt nooit getoond als inschrijvingen gesloten zijn.",
  "practice.pages.moduleText": "Blauw informatievlak boven pagina tonen",
  "practice.pages.staticText": "Tekst op pagina",
  "practice.pages.prep": "Consultvoorbereiding",
  "practice.pages.prep.disabled": "Uitgezet",
  "practice.pages.prep.urgentOnly": "Bij spoed praktijk bellen; bied geen alternatieve contactmogelijkheden aan.",
  "practice.pages.prep.displayAdvise":
    "Bij spoed praktijk bellen; bied alternatieve contactmogelijkheden aan. Indien digitaal contact afgeraden wordt, nog wel e-consult optie aanbieden.",
  "practice.pages.prep.forceAdvise":
    "Bij spoed praktijk bellen; bied alternatieve contactmogelijkheden aan. Indien digitaal contact afgeraden wordt, kan alleen consult op praktijk afspraak gemaakt worden.",
  "practice.pages.plato.administrative": "Alleen vragenlijsten",
  "practice.pages.plato.administrative.info":
    "Administratieve vragenlijsten zijn niet-medische verzoeken van patiënten, zoals het vragen om een ​​adreswijziging. Als u deze optie inschakelt, worden de medische vragenlijsten voor deze sitepagina uitgeschakeld en worden in plaats daarvan de administratieve vragenlijsten weergegeven.",
  "practice.pages.agendas": "Agenda's",
  "practice.pages.agendas.info": "Welke agenda's kan de patiënt selecteren? Laat leeg voor {link}.",
  "practice.pages.agendas.prepInfo":
    "Indien na de consultvoorbereiding toch een afspraak wordt gemaakt, welke agenda's kan de patiënt selecteren? Laat leeg voor {link}.",
  "practice.pages.agendas.link": "alle agenda's",
  "practice.pages.agendas.all": "Alle agenda's",
  "practice.pages.agendaBlocks": "Agenda blokken",
  "practice.pages.agendaBlocks.info": "Welke agenda blokken kan de patiënt selecteren? Laat leeg voor {link}.",
  "practice.pages.agendaBlocks.prepInfo":
    "Indien na de consultvoorbereiding toch een afspraak wordt gemaakt, welke agenda blokken kan de patiënt selecteren? Laat leeg voor {link}.",
  "practice.pages.agendaBlocks.link": "alle agenda blokken",
  "practice.pages.agendaBlocks.all": "Alle agenda blokken",
  "practice.pages.prepAlternativeLabels": "Consult voorbereiding alternatieve labels",
  "practice.pages.prepAlternativeLabels.info":
    "Wanneer na de consultvoorbereiding toch een afspraak wordt gemaakt, welke labels moeten dan toegekend worden?",
  "practice.pages.registration.toggle": "Open voor inschrijvingen",
  "practice.pages.registration.closedText": "Tekst bij gesloten inschrijving",
  "practice.pages.registration.limit.before": "Sluit inschrijvingen automatisch na",
  "practice.pages.registration.limit.after": "inschrijvingen",
  "practice.pages.registration.limit.info": "Dit was oorspronkelijk ingesteld op {limit}.",
  "practice.pages.registration.limitReached":
    "<p>Inschrijvingen zijn gesloten omdat de teller op 0 staat.</p><p>De teller verhoogt automatisch als je een inschrijving afwijst of als een patiënt een inschrijving al is gestart, maar niet binnen 24 uur voltooit.</p>",
  "practice.pages.registration.limitDialog.title": "Sluit inschrijvingen automatisch",
  "practice.pages.registration.limitDialog.text":
    "<p>Het maximum aantal nieuwe inschrijvingen is op {date} ingesteld op <b>{limit}</b>.</p><p>Sindsdien hebben zich <b>{registered}</b> patiënten ingeschreven. Er zijn dus nog <b>{remaining}</b> plekken vrij.</p><p>Inschrijvingen worden meegeteld zodra ze binnenkomen. Wordt een binnengekomen inschrijving afgewezen? Dan komt er ook weer een plekje vrij. Uitschrijvingen worden niet meegenomen in deze telling.</p>",
  "practice.pages.registration.settingsLink": "Algemene instellingen voor inschrijvingen",

  "practice.pages.questionnaire.toggle": "Extra vragen toevoegen",
  "practice.pages.questionnaire.addQuestion": "Vraag toevoegen",
  "practice.pages.questionnaire.required": "Verplicht",
  "practice.pages.questionnaire.requiredToggle": "Maak deze vraag verplicht",
  "practice.pages.questionnaire.questionType": "De patiënt geeft antwoord via",
  "practice.pages.questionnaire.questionTitle": "Vraagtitel",
  "practice.pages.questionnaire.questionTitle.locale": "Vraag ({locale})",
  "practice.pages.questionnaire.questionTitle.placeholder.NL": "Bijvoorbeeld: Heeft u nog een vraag voor ons?",
  "practice.pages.questionnaire.questionTitle.placeholder.EN": "Bijvoorbeeld: Do you have a question for us?",
  "practice.pages.questionnaire.description": "Beschrijving",
  "practice.pages.questionnaire.description.locale": "Toelichting ({locale})",
  "practice.pages.questionnaire.description.placeholder.NL":
    "Bijvoorbeeld: Of iets wat u wilt delen? Met betrekking tot de inschrijving.",
  "practice.pages.questionnaire.description.placeholder.EN":
    "Bijvoorbeeld: Or something you would like to share? In context of the registration.",
  "practice.pages.questionnaire.questionLabel.locale": "Label van het tekstveld ({locale})",
  "practice.pages.questionnaire.questionLabel.placeholder.NL": "Bijvoorbeeld: Vraag of mededeling",
  "practice.pages.questionnaire.questionLabel.placeholder.EN": "Bijvoorbeeld: Question or statement",
  "practice.pages.questionnaire.questionPlaceholder.locale": "Voorbeeld tekst ({locale})",
  "practice.pages.questionnaire.questionPlaceholder.placeholder.NL":
    "Bijvoorbeeld: Ik zou me alleen willen inschrijven als mijn man en kinderen hier ook terecht kunnen. Kan dat?",
  "practice.pages.questionnaire.questionPlaceholder.placeholder.EN":
    "Bijvoorbeeld: I only want to register here if my kids and husband can register here as well. Is that possible?",
  "practice.pages.questionnaire.options": "Antwoordopties",
  "practice.pages.questionnaire.addOption": "Optie toevoegen",
  "practice.pages.questionnaire.editDialog.title": "Vraag {index}",
  "practice.pages.questionnaire.untitledQuestion": "Vraag {number}",
  "practice.pages.questionnaire.editQuestion": "Vraag bewerken",
  "practice.pages.questionnaire.deleteQuestion": "Vraag verwijderen",
  "practice.pages.questionnaire.deleteOption": "Optie verwijderen",
  "practice.pages.questionnaire.option.fallback": "Optie {number}",
  "practice.pages.questionnaire.type.open_ended": "Open tekstveld",
  "practice.pages.questionnaire.type.single_select": "Enkele keuze",
  "practice.pages.questionnaire.type.multi_select": "Meerkeuze",
  "practice.pages.questionnaire.validation.required": "Dit veld is verplicht",
  "practice.pages.questionnaire.import.button": "Importeren uit bestand",
  "practice.pages.questionnaire.import.title": "Vragen importeren uit een bestand",
  "practice.pages.questionnaire.import.intro":
    "Heeft u uw vragen al in een document staan? Importeer uw bestand (.docx of .txt) en wij zetten het automatisch om. Daarna loopt u de vragen één voor één na om ze te controleren.\n\nTip: met een verticale streep zet u beide talen in één regel, bijvoorbeeld 'Rookt u? | Do you smoke?'.",
  "practice.pages.questionnaire.import.label": "Sleep een bestand hierheen of klik om te kiezen",
  "practice.pages.questionnaire.import.parsing": "Bezig met verwerken…",
  "practice.pages.questionnaire.import.success":
    "{count, plural, one {# vraag toegevoegd} other {# vragen toegevoegd}}",
  "practice.pages.questionnaire.import.error": "Het document kon niet worden verwerkt.",
  "practice.pages.questionnaire.import.warningsTitle": "Sommige onderdelen konden niet volledig worden verwerkt:",
  "practice.pages.questionnaire.import.warning.unsupportedFileType":
    'Bestandstype "{contentType}" wordt niet ondersteund.',
  "practice.pages.questionnaire.import.warning.orphanOptionsSkipped":
    "Er is een lijst met opties gevonden vóór een vraag; deze is overgeslagen.",
  "practice.pages.questionnaire.import.warning.bareLinesAddedAsOptions":
    'Onder "{title}" {count, plural, one {is # regel} other {zijn # regels}} zonder opsommingsteken als opties toegevoegd — controleer dit.',
  "practice.pages.questionnaire.import.warning.unreadableDocument":
    "Het bestand kon niet worden gelezen; mogelijk is het beschadigd of onvolledig.",
  "practice.pages.questionnaire.import.warning.sectionWithoutTitle": "Een onderdeel zonder vraagtitel is overgeslagen.",
  "practice.pages.questionnaire.import.warning.choiceQuestionWithoutOptions":
    '"{title}" lijkt een keuzevraag, maar er zijn geen opties gevonden — voeg ze toe in de bouwer.',
  "practice.pages.questionnaire.import.warning.optionsIgnoredForOpenQuestion":
    'Opties onder "{title}" zijn genegeerd omdat het een open vraag is.',
  "practice.pages.questionnaire.import.warning.ignoredNonQuestionTable":
    "Een tabel die niet als vragen kon worden gelezen, is overgeslagen.",
  "practice.pages.questionnaire.review.title": "Geïmporteerde vragen controleren",
  "practice.pages.questionnaire.review.progress": "Vraag {current} van {total}",
  "practice.pages.questionnaire.review.documentWarningsTitle":
    "Sommige onderdelen konden niet volledig worden verwerkt:",
  "practice.pages.questionnaire.review.previous": "Vorige",
  "practice.pages.questionnaire.review.stop": "Stoppen",
  "practice.pages.questionnaire.review.next": "Opslaan en verder",
  "practice.pages.questionnaire.review.finish": "Afronden",
  "practice.pages.questionnaire.review.suggestTranslations": "Vertalingen voorstellen",
  "practice.pages.questionnaire.review.suggestTranslations.failed":
    "Vertalen is mislukt. Probeer het opnieuw of vul de tekst handmatig in.",

  "practice.agendas.intro":
    "Agenda's bepalen wanneer patiënten afspraken kunnen maken. Elke agenda is gekoppeld aan een HIS-agenda.",
  "practice.agendas.addItem": "Agenda toevoegen",
  "practice.agendas.empty.title": "Geen agenda's",
  "practice.agendas.empty.description": "Er zijn nog geen agenda's. Gebruik de knop hieronder om er een aan te maken.",
  "practice.agendas.name": "Naam zichtbaar voor patiënt",
  "practice.agendas.hisName": "HIS naam",
  "practice.agendas.hisName.unknown": "Deze HIS naam bestaat niet (meer)",
  "practice.agendas.address": "Adres",
  "practice.agendas.address.info": "Adres voor afspraken op de praktijk.",
  "practice.agendas.roles.title": "Agenda behoort tot rollen",
  "practice.agendas.roles.info": "Toon deze agenda als de uitkomst een van de volgende type zorgverleners is",
  "practice.agendas.roles.tip":
    "Wanneer de patiënt een afspraak wil maken, stellen wij consult voorbereidende vragen. Deze vragen bepalen o.a. welke type zorgverlener het beste kan helpen.",
  "practice.agendas.types": "Types afspraken toegestaan",
  "practice.agendas.emptyRolesError": "Elke agenda moet ten minste één rol van een gezondheidsprofessional bevatten",
  "practice.agendas.faceToFaceAppointmentEnabled": "Consult op praktijk",
  "practice.agendas.phoneAppointmentEnabled": "Telefonisch consult",
  "practice.agendas.videoAppointmentEnabled": "Video-consult",
  "practice.agendas.hidden": "Toon deze agenda alleen als dat op de sitepagina zo is ingesteld.",
  "practice.agendas.confirmRemove.title": "Agenda verwijderen",
  "practice.agendas.confirmRemove.content": "Weet je zeker dat je agenda {agendaName} wilt verwijderen?",
  "practice.agendas.confirmRemove.success": "Agenda is verwijderd",

  "practice.agendaBlocks.addItem": "Agenda blok toevoegen",
  "practice.agendaBlocks.empty.title": "Geen agenda blokken",
  "practice.agendaBlocks.empty.description":
    "Er zijn nog geen agenda blokken. Gebruik de knop hieronder om er een aan te maken.",
  "practice.agendaBlocks.intro":
    "Agenda blokken worden gebruikt in het HIS om bepaalde type afspraken weer te geven. Vaak wordt dit in de agenda van het HIS met een bepaalde kleur weergegeven. Beperk hier welke blokken gebruikt kunnen worden voor patiënten afspraken.",
  "practice.agendaBlocks.hisBlockName": "HIS blok naam",
  "practice.agendaBlocks.hisBlockName.unknown": "Dit HIS blok naam bestaat niet (meer)",
  "practice.agendaBlocks.confirmRemove.title": "Agenda blok verwijderen",
  "practice.agendaBlocks.confirmRemove.content": "Weet je zeker dat je agenda blok {name} wilt verwijderen?",
  "practice.agendaBlocks.confirmRemove.success": "Agenda blok is verwijderd",

  "practice.responseTemplates.addItem": "Antwoord template toevoegen",
  "practice.responseTemplates.empty.title": "Geen antwoord templates",
  "practice.responseTemplates.empty.description":
    "Er zijn nog geen antwoord templates. Gebruik de knop hieronder om er een aan te maken.",
  "practice.responseTemplates.empty.defaultTitle": "Geen standaard templates",
  "practice.responseTemplates.empty.defaultDescription": "Er zijn geen standaard templates beschikbaar.",
  "practice.responseTemplates.intro": "Antwoord templates zijn veelgebruikte reacties op een e-consult. ",
  "practice.responseTemplates.name": "Naam",
  "practice.responseTemplates.text": "Tekst",
  "practice.responseTemplates.suggestedText":
    "<p>Beste {firstName},</p><p>{currentText}</p><p>Met vriendelijke groet,<br />{yourName}</p>",
  "practice.responseTemplates.age": "Leeftijd",
  "practice.responseTemplates.ageFrom": "Vanaf leeftijd",
  "practice.responseTemplates.ageTo": "Tot leeftijd",
  "practice.responseTemplates.gender": "Geslacht",
  "practice.responseTemplates.defaultsPlaceholder": "Toon templates van MijnPraktijk",
  "practice.responseTemplates.locale": "Taal",
  "practice.responseTemplates.treatmentArea": "Behandelgebied",
  "practice.responseTemplates.plan": "Plan voor HIS journaalregel",
  "practice.responseTemplates.triageSymptomLabel": "Uitkomst label(s)",
  "practice.responseTemplates.addTriageSymptomLabel": "Uitkomst labels toevoegen",
  "practice.responseTemplates.suggestions": "Gebruik een template als basis voor je antwoord:",
  "practice.responseTemplates.showAll": "Alle templates",
  "practice.responseTemplates.search": "Zoek antwoord template",
  "practice.responseTemplates.confirmRemove.title": "Antwoord template verwijderen",
  "practice.responseTemplates.confirmRemove.content": "Weet je zeker dat je template {templateName} wilt verwijderen?",
  "practice.responseTemplates.confirmRemove.success": "Antwoord template is verwijderd",

  "practice.communicationTemplates.intro":
    "Geautomatiseerde e-mail- of sms-berichten naar de patiënt bevatten een standaardtekst.",
  "practice.communicationTemplate.list": "Communicatie templates",
  "practice.communicationTemplate.type.email": "E-mail",
  "practice.communicationTemplate.type.sms": "SMS",
  "practice.communicationTemplate.group.general": "Algemeen",
  "practice.communicationTemplate.group.appointments": "Afspraken",
  "practice.communicationTemplate.group.econsults": "E-consulten",
  "practice.communicationTemplate.group.phoneConsult": "Telefonisch consult",
  "practice.communicationTemplate.group.walkInConsults": "Inloopspreekuur",
  "practice.communicationTemplate.group.medicationRequests": "Herhaalrecepten",
  "practice.communicationTemplate.group.registration": "Inschrijving",
  "practice.communicationTemplate.group.portal": "Portaal",
  "practice.communicationTemplate.group.pageInvitation": "Persoonlijke uitnodiging (inschrijving of afspraak)",
  "practice.communicationTemplate.group.support": "Patiëntondersteuning",
  "practice.communicationTemplate.group.system": "Systeemgebruiker",
  "practice.communicationTemplate.group.other": "Overig",
  "practice.communicationTemplate.enabled": "Verzenden ingeschakeld",
  "practice.communicationTemplate.description.smsEconsultReply":
    "De beller krijgt één sms zodra je antwoordt, ook als je meerdere berichten na elkaar stuurt. Heeft de beller de pagina op dat moment open of het antwoord al gelezen, dan sturen we niets — dan weet hij of zij het al.",
  "practice.communicationTemplate.description.econsultAnonymousGreeting":
    "Dit is geen sms. De beller ziet dit bericht bovenaan de pagina die opent via de link.",
  "practice.communicationTemplate.isDefault": "Gebruik standaard tekst van MijnPraktijk",
  "practice.communicationTemplate.nl-NL.subject": "Nederlands onderwerp",
  "practice.communicationTemplate.nl-NL.text": "Nederlandse tekst",
  "practice.communicationTemplate.en-GB.subject": "Engels onderwerp",
  "practice.communicationTemplate.en-GB.text": "Engelse tekst",

  "practice.notifications.intro":
    "Voor verschillende gebeurtenissen kan aangegeven worden welke notificaties verstuurd moeten worden. Dit kan bijvoorbeeld handig zijn bij het informeren van assistentes bij nieuwe herhaalmedicatie of van artsen bij nieuwe e-consults.",
  "practice.notifications.addItem": "Notificatie toevoegen",
  "practice.notifications.empty.title": "Geen notificaties",
  "practice.notifications.empty.description":
    "Er zijn nog geen notificaties. Gebruik de knop hieronder om er een aan te maken.",
  "practice.notifications.modal.title": "Notificatie {number}",
  "practice.notifications.confirmRemove.title": "Verwijder notificatie",
  "practice.notifications.confirmRemove.content": "Weet je zeker dat je deze notificatie wilt verwijderen?",
  "practice.notifications.confirmRemove.success": "Notificatie is verwijderd",
  "practice.notifications.trigger.type.label": "Verstuur een bericht zodra",
  "practice.notifications.trigger.type.placeholder": "Selecteer een reden",
  "practice.notifications.trigger.type.labelsAdded": "Er label(s) zijn toegevoegd",
  "practice.notifications.trigger.type.labelsRemoved": "Er label(s) zijn verwijderd",
  "practice.notifications.trigger.type.assignedUsers": "Er medewerker(s) zijn toegekend",
  "practice.notifications.trigger.type.unassignedUsers": "Toekenning van medewerker(s) zijn verwijderd",
  "practice.notifications.trigger.type.itemEvents": "Er iets nieuws is",
  "practice.notifications.trigger.type.statusChange": "Er een status wijziging is",
  "practice.notifications.trigger.type.phoneStatus": "Telefonie problemen",
  "practice.notifications.trigger.type.registrationStatus": "Inschrijvingen open/dicht gaan",
  "practice.notifications.trigger.labels": "Label(s)",
  "practice.notifications.trigger.users.label": "Medewerker(s)",
  "practice.notifications.trigger.users.all": "Laat leeg voor alle medewerkers",
  "practice.notifications.trigger.itemEvents.label": "Gebeurtenis(sen)",
  "practice.notifications.trigger.itemEvents.placeholder": "Selecteer gebeurtenissen",
  "practice.notifications.trigger.itemEvents.newFaceToFaceAppointment": "Nieuw consult op praktijk",
  "practice.notifications.trigger.itemEvents.newPhoneAppointment": "Nieuwe telefonische afspraak",
  "practice.notifications.trigger.itemEvents.newVideoAppointment": "Nieuwe video afspraak",
  "practice.notifications.trigger.itemEvents.newWalkInConsult": "Nieuw inloopspreekuur afspraak",
  "practice.notifications.trigger.itemEvents.newEconsult": "Nieuw e-consult",
  "practice.notifications.trigger.itemEvents.newPatientMessageEconsult":
    "Nieuwe reactie in e-consult (na 5 minuten ongezien)",
  "practice.notifications.trigger.itemEvents.newMedicationRequest": "Nieuw herhaalmedicatie",
  "practice.notifications.trigger.itemEvents.newRegistrationRequest": "Nieuw inschrijfverzoek",
  "practice.notifications.trigger.itemEvents.newPhoneMedicationRecording": "Nieuw telefonisch herhaalrecept",
  "practice.notifications.trigger.statusChange.label": "Status wijziging(en)",
  "practice.notifications.trigger.statusChange.placeholder": "Selecteer statussen",
  "practice.notifications.trigger.multipleIsOr":
    "Als meerdere zijn geselecteerd, wordt al bij één van deze genotificeerd.",
  "practice.notifications.itemStatus.appointmentCreated": "Afspraak gemaakt",
  "practice.notifications.itemStatus.appointmentRemoved": "Afspraak verwijderd",
  "practice.notifications.itemStatus.econsultOpen": "Digitaal consult open",
  "practice.notifications.itemStatus.econsultClosed": "Digitaal consult gesloten",
  "practice.notifications.itemStatus.econsultUnanswered": "Digitaal consult onbeantwoord",
  "practice.notifications.itemStatus.econsultAnswered": "Digitaal consult beantwoord",
  "practice.notifications.itemStatus.medicationRequestUndecided": "Herhaalmedicatie te verwerken",
  "practice.notifications.itemStatus.medicationRequestApproved": "Herhaalmedicatie goedgekeurd",
  "practice.notifications.itemStatus.medicationRequestRejected": "Herhaalmedicatie afgewezen",
  "practice.notifications.itemStatus.medicationRequestSentToHis": "Herhaalmedicatie naar HIS gestuurd",
  "practice.notifications.itemStatus.registrationRequestUndecided": "Inschrijving te verwerken",
  "practice.notifications.itemStatus.registrationRequestAccepted": "Inschrijving geaccepteerd",
  "practice.notifications.itemStatus.registrationRequestRejected": "Inschrijving afgewezen",
  "practice.notifications.itemStatus.registrationRequestCompleted": "Inschrijving afgerond",
  "practice.notifications.itemStatus.registrationRequestProcessing": "Inschrijving wordt verwerkt",
  "practice.notifications.registrationEvent.label": "Gebeurtenis(sen)",
  "practice.notifications.registrationEvent.openedAutomatic": "Inschrijvingen automatisch geopend",
  "practice.notifications.registrationEvent.closedAutomatic": "Inschrijvingen automatisch gesloten",
  "practice.notifications.registrationEvent.openedManual": "Inschrijvingen handmatig geopend",
  "practice.notifications.registrationEvent.closedManual": "Inschrijvingen handmatig gesloten",
  "practice.notifications.delay.delayedValue.label": "Direct versturen",
  "practice.notifications.delay.delayedFactor.label": "Uitvoeren na",
  "practice.notifications.delay.delayedFactor.minutes": "Minuten",
  "practice.notifications.delay.delayedFactor.hours": "Uren",
  "practice.notifications.delay.delayedFactor.days": "Dagen",
  "practice.notifications.delay.delayedFactor.workdays": "Werkdagen",
  "practice.notifications.delay.delayedFactor.weeks": "Weken",
  "practice.notifications.delay.value.label": "Aantal",
  "practice.notifications.delay.unit.label": "Eenheid",
  "practice.notifications.condition.type.label": "EN als",
  "practice.notifications.condition.type.placeholder": "Selecteer een voorwaarde",
  "practice.notifications.condition.type.labels": "Label(s)",
  "practice.notifications.condition.type.assignedUsers": "Toegekende medewerker(s)",
  "practice.notifications.condition.type.itemTypes": "Type(s)",
  "practice.notifications.condition.type.itemStatus": "Status(en)",
  "practice.notifications.condition.labels.label": "Bevat label(s)",
  "practice.notifications.condition.assigned.label": "Toegekende gebruiker(s)",
  "practice.notifications.condition.itemTypes.label": "Type(s)",
  "practice.notifications.condition.itemTypes.faceToFaceAppointment": "Consult op praktijk",
  "practice.notifications.condition.itemTypes.phoneAppointment": "Telefonische afspraak",
  "practice.notifications.condition.itemTypes.videoAppointment": "Video afspraak",
  "practice.notifications.condition.itemTypes.econsult": "E-consult",
  "practice.notifications.condition.itemTypes.walkInConsult": "Inloopspreekuur",
  "practice.notifications.condition.itemTypes.medicationRequest": "Herhaalrecept",
  "practice.notifications.condition.itemTypes.registrationRequest": "Inschrijving",
  "practice.notifications.condition.itemStatus.label": "Status(en)",
  "practice.notifications.condition.multipleIsOr":
    "Als meerdere zijn geselecteerd, kan één van deze van toepassing zijn (d.w.z. OF). Druk op de plus als alle van toepassing moeten zijn (EN).",
  "practice.notifications.target.type.label": "Verstuur melding naar",
  "practice.notifications.target.type.placeholder": "Selecteer een ontvanger type",
  "practice.notifications.target.type.emailAddress": "E-mailadres",
  "practice.notifications.target.type.teamsUrl": "Teams connector",
  "practice.notifications.target.email.info":
    "Het is mogelijk meerdere e-mailadressen in te vullen, door deze te scheiden met een komma (bijv. a@b.com,c@d.com).",
  "practice.notifications.target.teamsUrl.label": "Teams webhook URL",
  "practice.notifications.target.teamsUrl.info":
    "Bekijk de {linkTeams} of {linkOutlook} hoe notificaties ingesteld moeten worden.",
  "practice.notifications.target.teamsUrl.linkTeams": "Teams documentatie",
  "practice.notifications.target.teamsUrl.linkOutlook": "Outlook groepen documentatie",
  "practice.notifications.validation.selectAtLeastOne": "Selecteer minimaal één optie",
  "practice.notifications.validation.delayBothOrNone": "Vul zowel het aantal als de eenheid van de vertraging in",
  "practice.notifications.validation.error":
    "Niet alle verplichte velden zijn ingevuld. Controleer de geopende notificaties.",

  "practice.registrations.postalCodeRegex.title": "Postcodevereisten voor patiëntregistratie",
  "practice.registrations.postalCodeRegex.label": "Postcode regex",
  "practice.registrations.postalCodeRegex.info": "Dit moet een valide reguliere expressie zijn.",
  "practice.registrations.postalCodeRegex.infoForPractice":
    "Er kan een postcodegebied worden ingesteld waarin de patiënt moet wonen. Neem contact op met support@mijnpraktijk.nl, en vermeld daarbij het hele postcodegebied in cijfers en letters.\nWij voeren het postcodegebied voor je in.",
  "practice.registrations.postalCodeRegex.validation": "Regex is onjuist",
  "practice.registrations.postalCodeRegex.empty":
    "Er is geen postcodegebied ingevuld. Dit betekent dat patiënten van over het hele land kunnen inschrijven en dat is misschien niet de intentie.",
  "practice.registrations.postalCodeRegex.invalidPattern": "Deze regex zou alle postcodes accepteren!",
  "practice.registrations.postalCodeRegex.tooManyMatches":
    "Deze regex zou {count} postcodes accepteren. Dit is waarschijnlijk een fout in de regex!",
  "practice.registrations.postalCodeRegex.showMap": "Toon op kaart",
  "practice.registrations.postalCodeRegex.map.title": "Postcodegebied",
  "practice.registrations.postalCodeRegex.map.infoTitle": "Postcodes gegroepeerd per PC4 gebied",
  "practice.registrations.postalCodeRegex.map.infoText":
    "Gebruik deze visualisatie om fouten in je regexpatroon te vinden, niet om een exacte dekking te verifiëren.",
  "practice.registrations.postalCodeRegex.map.noMatch": "Geen resultaten gevonden",
  "practice.registrations.postalCodeRegex.map.empty": "Geen postcodes komen overeen met deze regex",
  "practice.registrations.postalCodeRegex.map.error":
    "De postcode regex is niet geldig en kan niet op de kaart getoond worden",

  "postalCodeArea.mode.pc4": "postcode-4",
  "postalCodeArea.mode.pc6": "postcode-6",
  "postalCodeArea.regex.label": "Postcode-6 gebieden",
  "postalCodeArea.regex.info": "Dit moet een reguliere expressie zijn",
  "postalCodeArea.regex.validation": "Regex is onjuist",
  "postalCodeArea.regex.tooManyMatches":
    "Deze regex zou {count} postcodes accepteren. Dit is waarschijnlijk een fout in de regex!",
  "postalCodeArea.regex.showMap": "Toon op kaart",
  "postalCodeArea.regex.map.title": "Postcodegebied",
  "postalCodeArea.regex.map.infoTitle": "Postcodes gegroepeerd per PC4 gebied",
  "postalCodeArea.regex.map.infoText":
    "Gebruik deze visualisatie om fouten in je regexpatroon te vinden, niet om een exacte dekking te verifiëren.",
  "postalCodeArea.regex.map.noMatch": "Geen resultaten gevonden",
  "postalCodeArea.regex.map.empty": "Geen postcodes komen overeen met deze regex",
  "postalCodeArea.regex.map.error": "De postcode regex is niet geldig en kan niet op de kaart getoond worden",
  "postalCodeArea.p4.areas.title": "Postcode-4 gebieden",
  "postalCodeArea.p4.add": "Voeg postcode toe",
  "postalCodeArea.p4.remove": "Verwijderen",
  "postalCodeArea.p4.placeholder": "1234",
  "postalCodeArea.p4.to.label": "tot en met",
  "postalCodeArea.p4.validation.fourDigits": "Voer precies vier cijfers in",
  "postalCodeArea.p4.validation.toGreaterThanFrom": "Het einde moet groter dan of gelijk aan het begin zijn",
  "postalCodeArea.p4.map.error": "Het postcodegebied kan niet op de kaart getoond worden",

  "practice.registrations.intro":
    "Bovenstaande instellingen zijn algemene instellingen rondom inschrijven. Hieronder kan je de inschrijfpagina zelf aanpassen. Je kunt hier o.a.:",
  "practice.registrations.intro.openOrClosed": "Inschrijven open of dicht zetten",
  "practice.registrations.intro.customQuestions": "Eigen vragen toevoegen",
  "practice.registrations.conditions": "Voorwaarden voor inschrijving",
  "practice.registrations.idCheck.checkbox": "Digitale ID controle",
  "practice.registrations.idCheckMandatory.checkbox": "Verplicht patiënten de digitale ID controle te proberen",
  "practice.registrations.idCheckMandatory.checkbox.info":
    "Als de digitale ID controle mislukt, kunnen mensen de registratie nog steeds afmaken",
  "practice.registrations.allowLandlinePhoneNumbers.checkbox": "Vaste Nederlandse telefoonnummers accepteren",
  "practice.registrations.allowForeignPhoneNumbers.checkbox": "Buitenlandse telefoonnummers accepteren",
  "practice.registrations.previousGpLetter.checkbox":
    "Stuur namens de patiënt een brief aan de vorige huisarts met een verzoek tot uitschrijving. Als de patiënt toestemming geeft voor dossieroverdracht, staat dat ook in de brief.",
  "practice.registrations.previousGpLetter.subText":
    "De brief wordt automatisch naar de vorige huisarts verstuurd nadat je de patiënt accepteert in je praktijk.",
  "practice.registrations.showLspConsent.checkbox": "LSP toestemmingsvraag tonen aan patiënten",
  "practice.registrations.showLspConsent.link.href": "https://www.mijnmitz.nl",
  "practice.registrations.showLspConsent.link.title": "mijnmitz.nl",
  "practice.registrations.showLspConsent.info":
    "Schakel dit uit als je praktijk is aangesloten bij Mitz. Patiënten zien dan een verwijzing naar {link} om hun toestemmingen zelf te regelen.",
  "practice.registrations.afterAcceptance.label": "Acties nadat de patiënt is geaccepteerd",
  "practice.registrations.vecozoCov.checkbox": "Controle van de verzekeringsgegevens (COV check)",
  "practice.registrations.vecozoIon.checkbox": "Inschrijving van de patiënt via ION (inschrijving op naam)",
  "practice.registrations.vecozoIon.checkbox.subText":
    "Alleen als deze optie is aangevinkt halen we de vorige huisarts van een patiënt op.",
  "practice.registrations.vecozo.info":
    "Hiervoor moet eerst bij Vecozo een toestemmingsverklaring ingevuld zijn. {link1} op 'Toestemmingsverklaring aan derden' en volg de link om in te loggen. {link2} laat zien hoe je vanuit hier verder kunt met instellen.",
  "practice.registrations.vecozo.info.link1": "Klik hier",
  "practice.registrations.vecozo.info.link2": "Dit filmpje",
  "practice.registrations.sbvz.checkbox": "Controleer identiteitsbewijs & adres bij SBV-Z",
  "practice.registrations.sbvz.infoLink": "Wat wordt er gecontroleerd?",
  "practice.registrations.sbvz.info.intro":
    "Bij SBV-Z (de Sectorale Berichten Voorziening in de Zorg) vragen we de gegevens op die bij de municipality over de patiënt bekend zijn. We vergelijken die met wat de patiënt zelf heeft ingevuld:",
  "practice.registrations.sbvz.info.point1": "Naam, geboortedatum en burgerservicenummer",
  "practice.registrations.sbvz.info.point2": "Het adres zoals dat bij de municipality geregistreerd staat",
  "practice.registrations.sbvz.info.point3":
    "Of het opgegeven identiteitsbewijs geldig is en niet als vermist of gestolen bekend staat",
  "practice.registrations.sbvz.info.note":
    "Je ziet het resultaat van de controle bij de inschrijving. Komt iets niet overeen? Dan kun je de patiënt alsnog accepteren, maar controleer de gegevens dan zelf aan de balie.",
  "practice.registrations.registrationAgb.label": "AGB-code",
  "practice.registrations.registrationAgb.intro": "Kies uit meerdere praktijken na inschrijving",
  "practice.registrations.registrationAgb.default": "Als dit uit staat, wordt altijd de AGB-code {agbCode} gebruikt.",
  "practice.registrations.registrationAgb.agbCode": "AGB-code",
  "practice.registrations.registrationAgb.name": "Naam",
  "practice.registrations.registrationAgb.defaultValue": "Standaard praktijk",
  "practice.registrations.registrationAgb.validation": "AGB-code mag alleen cijfers bevatten",
  "practice.registrations.registrationAgb.invalidLength": "AGB-code moet uit 8 cijfers bestaan",
  "practice.registrations.registrationAgb.agbCode.required": "AGB-code is verplicht",
  "practice.registrations.communicationTemplates.title": "E-mails aan patiënten aanpassen",
  "practice.registrations.communicationTemplates.description":
    "Ga naar {link} om de teksten van de automatische berichten (zoals e-mails en sms) aan te passen.",
  "practice.registrations.communicationTemplates.link": "communicatie templates",
  "practice.registrations.pages.title": "De inschrijfpagina zelf",
  "practice.registrations.pages.empty":
    "Maak een site pagina met type 'Inschrijving' aan om te zorgen dat patiënten zich in kunnen schrijven",
  "practice.registrations.pages.add": "Registratie pagina toevoegen",
  "practice.registrations.pages.edit": "Aanpassen",
  "practice.registrations.pages.note":
    '(De website zal alleen een registratieknop tonen als er een inschrijf site-pagina is en "Open voor inschrijvingen" en "Tegel op website tonen" zijn ingeschakeld)',

  "practice.feedback.dialog.title": "Wat heb je nodig om weer open te gaan?",
  "practice.feedback.dialog.altTitle":
    "De praktijk sluit automatisch na {limit} inschrijvingen. Wat heb je nodig om weer open te gaan?",
  "practice.feedback.dialog.description": "Namens de zorggroep brengen wij in kaart waar de knelpunten zitten.",

  "practice.feedback.dialog.skip": "Overslaan",
  "practice.feedback.dialog.submit": "Versturen",
  "practice.feedback.category.housing": "Huisvesting",
  "practice.feedback.category.staff": "Personeel (huisartsen)",
  "practice.feedback.category.assistants": "Personeel (assistenten/ POH/ e.a.)",
  "practice.feedback.category.other": "Anders, namelijk:",
  "practice.feedback.description.placeholder": "Vul in wat je nodig hebt",

  "practice.uzi.title": "UZI-certificaat",
  "practice.uzi.intro": "Eén certificaat per praktijk. Wordt gebruikt voor DigiD-inlog en de SBV-Z check.",
  "practice.uzi.publicCert": "Publiek bestand (public key)",
  "practice.uzi.publicCertInfo": "Bijv.: praktijk_public.crt.pem",
  "practice.uzi.privateKey": "Geheim bestand (private key)",
  "practice.uzi.privateKeyInfo": "Bijv.: praktijk_private.key.pem",
  "practice.uzi.howToRequest": "Hoe vraag ik een UZI-certificaat aan?",
  "practice.uzi.certPresent": "UZI-Certificaat aanwezig",
  "practice.uzi.certPresentMeta": "Geüpload op {uploadedAt} · geldig tot {validUntil}",
  "practice.uzi.certPresentMetaSbvz":
    "Geüpload op {uploadedAt} · geldig tot {validUntil} · wordt ook gebruikt voor de SBV-Z check",
  "practice.uzi.replace": "Certificaat vervangen",
  "practice.uzi.upload": "Certificaat uploaden",
  "practice.uzi.expiresSoon": "Certificaat verloopt over {days, plural, one {# dag} other {# dagen}}",
  "practice.uzi.expired": "Certificaat is verlopen — upload een nieuw certificaat",
  "practice.uzi.replaceConfirm.title": "Certificaat vervangen?",
  "practice.uzi.replaceConfirm.intro": "Dit UZI-certificaat wordt op dit moment gebruikt door:",
  "practice.uzi.replaceConfirm.usage.digid": "DigiD-inlog voor patiënten",
  "practice.uzi.replaceConfirm.usage.sbvz": "SBV-Z check bij inschrijvingen",
  "practice.uzi.replaceConfirm.note":
    "Na het vervangen gebruiken deze diensten direct het nieuwe certificaat. Het oude certificaat blijft werken totdat het nieuwe is gecontroleerd.",
  "practice.uzi.replaceConfirm.warning":
    "Upload je een verkeerd certificaat? Dan werken deze diensten mogelijk niet meer.",
  "practice.uzi.replaceConfirm.confirm": "Ja, vervangen",
  "practice.uzi.howTo.intro":
    "Waarschijnlijk heeft je praktijk al een UZI-servercertificaat — bijvoorbeeld voor het LSP. Je hebt twee bestanden nodig: het publieke bestand en het geheime bestand.",
  "practice.uzi.howTo.existing.title": "Je praktijk heeft al een certificaat",
  "practice.uzi.howTo.existing.body":
    "De bestanden staan meestal niet in je HIS zelf: ze zijn bij de installatie op de server gezet. Vraag de partij die je HIS levert en beheert — bijvoorbeeld Medicom, Promedico, CGM of Tetra, of je eigen ICT-beheerder — om een kopie van het publieke bestand (.crt of .pem) en het geheime bestand (.key). Geef aan dat je ze nodig hebt voor MijnPraktijk.",
  "practice.uzi.howTo.existing.note":
    "Weet je niet zeker of je praktijk een certificaat heeft? Je HIS-leverancier kan dat controleren op het abonneenummer (URA) van je praktijk bij het UZI-register.",
  "practice.uzi.howTo.new.title": "Nog geen certificaat? Zo vraag je het aan",
  "practice.uzi.howTo.new.leadTime": "Reken op een doorlooptijd van enkele weken.",
  "practice.uzi.howTo.new.step1":
    "Meld je praktijk aan als abonnee bij het UZI-register. Je krijgt dan een abonneenummer (URA).",
  "practice.uzi.howTo.new.step2":
    "Vraag de partij die je HIS levert om het technische aanvraagbestand te maken. Je kunt hen ook machtigen om de hele aanvraag voor je te doen.",
  "practice.uzi.howTo.new.step3":
    "Vul het aanvraagformulier in op uziregister.nl. Let op dat je de juiste domeinnaam invult.",
  "practice.uzi.howTo.new.step4":
    "Na de identiteitscontrole krijg je het certificaat per e-mail. Upload hier het publieke en het geheime bestand.",
  "practice.uzi.howTo.validity":
    "Een certificaat is meestal drie jaar geldig. Vraag een nieuw certificaat op tijd aan, zodat DigiD-inlog en de SBV-Z check blijven werken.",
  "practice.uzi.howTo.more": "Meer informatie: {link}",
  "practice.uzi.howTo.more.link": "uziregister.nl/servercertificaat",

  "practice.digid.coupling": "DigiD-koppeling",
  "practice.digid.adminOnly": "alleen beheer",
  "practice.digid.entityId": "Entiteit ID",
  "practice.digid.entityIdPlaceholder": "Vul hier de entiteit ID in",
  "practice.digid.entityIdInfo": "Bijv.: urn:nl-eid-gdi:1.0:DV:00000009000213560000:entities:9652",
  "practice.digid.serviceId": "Service ID",
  "practice.digid.serviceIdPlaceholder": "Vul hier het service ID in",
  "practice.digid.serviceIdInfo": "Bijv.: 44f9c16d-99cd-47c2-abf1-f8b1857a4a7f",
  "practice.digid.status.hasPublicKey.success": "Public key geüpload",
  "practice.digid.status.hasPublicKey.error": "Public key nog niet geüpload",
  "practice.digid.status.hasPrivateKey.success": "Secret key geüpload",
  "practice.digid.status.hasPrivateKey.error": "Secret key nog niet geüpload",
  "practice.digid.status.isRequested.success": "DigiD aanvraag is ingediend",
  "practice.digid.status.isRequested.error": "Aanvraag voor DigiD nog niet ingediend door MijnPraktijk.nl",
  "practice.digid.status.isProcessed.success": "Aanvraag is verwerkt door DigiD",
  "practice.digid.status.isProcessed.error":
    "Aanvraag is nog niet verwerkt door DigiD. Het kan enkele dagen duren voordat het geactiveerd is",
  "practice.digid.status.operational.success": "DigiD is actief",
  "practice.digid.status.operational.error": "DigiD is uitgeschakeld",
  "practice.digid.disable": "DigiD uitzetten",
  "practice.digid.disable.description":
    "Weet je zeker dat je DigiD wilt uitschakelen? Hierna moet het UZI-certificaat opnieuw geüpload worden en wachten op activatie.",
  "practice.digid.disable.confirm": "Ja, DigiD uitzetten",

  "practiceAuthorization.remove": "Toegangsrechten verwijderen",
  "practiceAuthorization.remove.confirmation":
    "Het account van de gebruiker blijft bestaan, maar heeft geen toegang meer tot deze praktijk.\n\nVia de ‘+ {addButtonLabel}’ knop kunt u de medewerker later altijd opnieuw toevoegen.",
  "practiceAuthorization.reactivate": "Heractiveren",
  "practiceAuthorization.confirmation.title": "Hebben de juiste mensen nog toegang tot {practiceName}?",
  "practiceAuthorization.confirmation.title.noConfigurationRights":
    "Gebruikersrechten moeten binnen {days} {days, plural, =1 {dag} other {dagen}} gecontroleerd worden voor {practiceName}",
  "practiceAuthorization.confirmation.title.required.noConfigurationRights":
    "Een beheerder moet de gebruikersrechten controleren voor {practiceName}",
  "practiceAuthorization.confirmation.explanation":
    "Deze mensen kunnen bij informatie over patiënten in MijnPraktijk. We herinneren u er elke {months} maanden aan om dit te controleren.",
  "practiceAuthorization.confirmation.explanation.noConfigurationRights":
    "Vraag een beheerder van {practiceName} om in te loggen. Dan kan die persoon controleren of de juiste mensen toegang hebben.",
  "practiceAuthorization.confirmation.explanation.noConfigurationRights.warning":
    "Als dit niet op tijd gebeurt, kunt u niet meer inloggen in MijnPraktijk.",
  "practiceAuthorization.confirmation.required": "U kunt helaas niet verder totdat dit gecontroleerd is.",
  "practiceAuthorization.confirmation.confirm": "Ja, deze toegangsrechten kloppen",
  "practiceAuthorization.confirmation.close": "Sluiten",
  "practiceAuthorization.confirmation.signout": "Uitloggen",
  "practiceAuthorization.confirmation.postpone": "Uitstellen",
  "practiceAuthorization.confirmation.postpone.title": "U heeft nog {days} {days, plural, =1 {dag} other {dagen}}",
  "practiceAuthorization.confirmation.postpone.part1":
    "Deze gegevens moeten elke {months} maanden gecontroleerd worden. Als u dit niet doet, wordt de toegang voor alle medewerkers geblokkeerd totdat u de toegangsrechten heeft gecontroleerd.",
  "practiceAuthorization.confirmation.postpone.part2":
    "Wij zullen u bij de volgende keer inloggen opnieuw helpen herinneren.",
  "practiceAuthorization.confirmation.postpone.postpone": "Toch uitstellen",
  "practiceAuthorization.confirmation.postpone.back": "Terug naar controleren",

  "practice.communicationTemplate.template.contact": "Contact of noodgeval",
  "practice.communicationTemplate.template.walkInConsultNotAvailable": "Inloopspreekuur - niet beschikbaar",
  "practice.communicationTemplate.template.walkInConsultQueueFull": "Inloopspreekuur - wachtrij vol",
  "practice.communicationTemplate.template.privacyStatement": "Privacyverklaring",
  "practice.communicationTemplate.template.emailAppointmentF2f": "Afspraken - consult",
  "practice.communicationTemplate.template.emailAppointmentPhone": "Afspraken - telefonisch",
  "practice.communicationTemplate.template.emailAppointmentVideo": "Afspraken - video",
  "practice.communicationTemplate.template.emailAppointmentDeleted": "Afspraken - verwijderd",
  "practice.communicationTemplate.template.emailAppointmentReminderVideo": "Afspraken - video herinnering",
  "practice.communicationTemplate.template.emailAppointmentReminderOther": "Afspraken - overig herinnering",
  "practice.communicationTemplate.template.emailEconsultConfirmation": "E-consult - bevestiging",
  "practice.communicationTemplate.template.emailEconsultReply": "E-consult - reactie",
  "practice.communicationTemplate.template.emailEconsultNew": "E-consult - nieuw bericht",
  "practice.communicationTemplate.template.emailWalkInConsultConfirmation": "Inloopspreekuur - bevestiging",
  "practice.communicationTemplate.template.emailMedicationConfirmation": "Medicatie - bevestiging",
  "practice.communicationTemplate.template.emailMedicationApproved": "Medicatie - goedgekeurd",
  "practice.communicationTemplate.template.emailMedicationRejected": "Medicatie - afgekeurd",
  "practice.communicationTemplate.template.emailRegistrationVerify": "Registratie - verificatie",
  "practice.communicationTemplate.template.emailRegistrationPreviousGpLetterReminder":
    "Registratie - herinnering ondertekening brief vorige huisarts",
  "practice.communicationTemplate.template.emailRegistrationPreviousGpLetterChanged":
    "Registratie - vorige huisarts gewijzigd, onderteken brief (opnieuw)",
  "practice.communicationTemplate.template.emailRegistrationConfirmation": "Registratie - bevestiging",
  "practice.communicationTemplate.template.emailRegistrationAccepted": "Registratie - geaccepteerd",
  "practice.communicationTemplate.template.emailRegistrationRejected": "Registratie - afgekeurd",
  "practice.communicationTemplate.template.emailRegistrationCompleted": "Registratie - afgerond",
  "practice.communicationTemplate.template.emailPatientWelcome": "Patient eerste keer gebruik systeem",
  "practice.communicationTemplate.template.emailPageInvitation": "Pagina uitnodiging",
  "practice.communicationTemplate.template.smsVideoAppointmentReminder": "SMS video afspraak herinnering",
  "practice.communicationTemplate.template.smsWalkInConsultAboutToStart": "SMS inloopspreekuur start bijna",
  "practice.communicationTemplate.template.smsAnonymousEconsult": "SMS met link om details en foto's te delen",
  "practice.communicationTemplate.template.smsEconsultReply": "SMS bij antwoord van de praktijk",
  "practice.communicationTemplate.template.econsultAnonymousGreeting": "Welkomstbericht",
  "practice.communicationTemplate.template.authNewAccount": "Systeemgebruiker - nieuw account",
  "practice.communicationTemplate.template.authPasswordReset": "Systeemgebruiker - wachtwoord reset aanvraag",
  "practice.communicationTemplate.template.authPasswordResetSharedEmail":
    "Systeemgebruiker - wachtwoord reset aanvraag (gedeeld e-mailadres)",
  "practice.communicationTemplate.template.authForgotUsername": "Systeemgebruiker - gebruikersnaam vergeten",
  "practice.communicationTemplate.template.authPasswordChanged": "Systeemgebruiker - wachtwoord gewijzigd",
  "practice.communicationTemplate.template.authEmailChanged": "Systeemgebruiker - e-mailadres gewijzigd",
  "practice.communicationTemplate.template.authDeactivation": "Systeemgebruiker - account gedeactiveerd",
  "practice.communicationTemplate.template.authDeactivationHeadsUp": "Systeemgebruiker - waarschuwing deactivatie",
  "practice.communicationTemplate.template.authReactivation": "Systeemgebruiker - account gereactiveerd",
  "practice.communicationTemplate.template.authTotpReset": "Systeemgebruiker - 2FA reset",
  "practice.communicationTemplate.template.authMfa": "Systeemgebruiker - 2FA code",
  "practice.communicationTemplate.template.authAccessRightsConfirmHeadsUp":
    "Systeemgebruiker - herinnering toegangsrechten controle",
  "practice.communicationTemplate.template.authAccessRightsConfirmBlocked":
    "Systeemgebruiker - toegang geblokkeerd (toegangsrechten)",
  "practice.communicationTemplate.template.authAccessRightsConfirmed":
    "Systeemgebruiker - toegangsrechten gecontroleerd",
  "practice.communicationTemplate.template.postalCodeWaitingListEmailVerification": "Wachtlijst - e-mail verificatie",
  "practice.communicationTemplate.template.postalCodeWaitingListConfirmation": "Wachtlijst - bevestiging interesse",
  "practice.communicationTemplate.template.practiceOpenNotification": "Wachtlijst - praktijk open voor registratie",
  "practice.communicationTemplate.template.notificationTarget": "Notificatie doel",
  "practice.communicationTemplate.template.emailError": "E-mail foutmelding",
  "practice.communicationTemplate.template.digidRequested": "DigiD - aangevraagd",
  "practice.communicationTemplate.template.digidUpdated": "DigiD - bijgewerkt",
  "practice.communicationTemplate.template.digidRemoved": "DigiD - verwijderd",
  "practice.communicationTemplate.template.openClosedPracticeReminder": "Herinnering gesloten praktijk openen",
  "practice.communicationTemplate.template.userInvitationInviteNew":
    "Systeemgebruiker - uitnodiging (nieuwe gebruiker)",
  "practice.communicationTemplate.template.userInvitationInviteExisting":
    "Systeemgebruiker - uitnodiging (bestaande gebruiker)",
  "practice.communicationTemplate.template.userInvitationInviteBare":
    "Systeemgebruiker - uitnodiging (zonder praktijk)",
  "practice.communicationTemplate.template.userInvitationWelcome": "Systeemgebruiker - welkom",
  "practice.communicationTemplate.template.patientSwapInvitation": "Patiënten ruilen - uitnodiging overstap",
  "practice.communicationTemplate.template.verify": "Patiënt account - e-mail verificatie",
  "practice.communicationTemplate.template.mfa": "Patiënt account - 2FA code",
  "practice.communicationTemplate.template.mfaResetSupportRequest": "Login Support - MFA code",
  "practice.communicationTemplate.template.passwordResetRequest": "Patiënt account - wachtwoord reset aanvraag",
  "practice.communicationTemplate.template.passwordResetCompleted": "Patiënt account - wachtwoord gewijzigd",
  "responseTemplates.type.practice": "Antwoorden binnen praktijk",
  "responseTemplates.type.default": "Standaard antwoorden",

  "configuration.configurationAccess": "Beheerder",
  "configuration.slug.warning":
    "LET OP: Wijzigen van de slug kan zorgen dat patiënten de website niet meer kunnen vinden!",
  "configuration.slug.validation": "Slug mag alleen letters, cijfers en streepjes bevatten",
  "configuration.slug.validationForbidden": "Deze slug is niet toegestaan",

  "account.nav.myProfile": "Mijn profiel",
  "account.nav.changePassword": "Wachtwoord wijzigen",
  "account.nav.2fa": "Twee factor authenticatie",
  "account.changePassword.title": "Wachtwoord wijzigen",
  "account.changePassword.current": "Huidig wachtwoord",
  "account.changePassword.new": "Nieuw wachtwoord",
  "account.changePassword.new.placeholder": "Typ een nieuw wachtwoord",
  "account.changePassword.confirm": "Bevestig wachtwoord",
  "account.changePassword.btn": "Wachtwoord wijzigen",
  "account.changePassword.confirm.validation.error": "Bevestig het wachtwoord ter controle",
  "account.changePassword.notMatch.validation.error": "Wachtwoorden komen niet overeen",
  "account.changePassword.success": "Wachtwoord is gewijzigd",
  "account.changePassword.passwordPolicy.minCharacters": `Wachtwoord moet minimaal ${MIN_PASSWORD_LENGTH} karakters zijn`,
  "account.changePassword.passwordPolicy.letter": "Wachtwoord moet minimaal één letter (a-z) bevatten",
  "account.changePassword.passwordPolicy.digit": "Wachtwoord moet minimaal één cijfer (0-9) bevatten",
  "account.changePassword.passwordPolicy.specialCharacter":
    "Wachtwoord moet minimaal één bijzonder karakter (bijv. !@#$%^&*) bevatten",

  "account.totp.title": "Twee factor authenticatie (2FA)",
  "account.totp.btn": "2FA aanzetten",
  "account.totp.intro1": "1. Open een authenticator app",
  "account.totp.intro1.info": "Zoals Microsoft Authenticator of Google Authenticator.",
  "account.totp.intro2": "2. Scan de QR-code",
  "account.totp.intro2.info": "Met je authenticator app",
  "account.totp.qrcode.alt": "QR Code voor 2FA",
  "account.totp.secret": "Vul dan deze code in je authenticator app:",
  "account.totp.secret.btn": "Lukt het scannen niet?",
  "account.totp.secret.tip":
    "Lukt het scannen zelf wel, maar zegt de app dat je account al bestaat? Verwijder dan eerst je inactieve account uit je Authenticator app.",
  "account.totp.success":
    "Twee factor authenticatie is ingeschakeld en moet bij de volgende keer inloggen gebruikt worden.",
  "account.totp.alreadyEnabled1": "Twee factor authenticatie is ingeschakeld.",
  "account.totp.alreadyEnabled2":
    "Het is niet direct mogelijk om dit uit te zetten of te wijzigen naar een andere app. Neem hiervoor contact op met support@mijnpraktijk.nl",

  "admin.users.tab.accounts": "Accounts",
  "admin.users.tab.invitations": "Uitnodigingen",
  "admin.users.edit": "Wijzig gebruiker",
  "admin.users.practices": "Praktijken",
  "admin.users.careGroups": "Zorggroepen",
  "admin.users.isAdmin": "Is admin",
  "admin.users.blocked": "Geblokkeerd",
  "admin.users.blocked.reason": "Dit account is geblokkeerd. U kunt via 'wijzig gebruiker' aanpassen",
  "admin.users.reactivate": "Account heractiveren",
  "admin.users.mfa": "MFA",
  "admin.users.mfa.reset": "MFA resetten",
  "admin.users.mfa.reset.title": "Is de identiteit van de persoon gecontroleerd?",
  "admin.users.mfa.reset.confirm":
    "Bel de praktijk met het telefoonnummer dat wij kennen. <b>Niet</b> met een nummer dat door de aanvrager is gedeeld. Ga alleen verder als de praktijk bevestigt dat ze om een reset vragen.",

  "admin.patientAccounts.email": "E-mail",
  "admin.patientAccounts.status": "Status",
  "admin.patientAccounts.practice": "Praktijk",
  "admin.patientAccounts.withDigiD": "DigiD",
  "admin.patientAccounts.portalAccountId": "Portaal account ID",
  "hisPatientLinkStatus.pending": "In behandeling",
  "hisPatientLinkStatus.accepted": "Geaccepteerd",
  "hisPatientLinkStatus.rejected": "Afgewezen",
  "hisPatientLinkStatus.inactive": "Inactief",
  "hisPatientLinkStatus.notFound": "Niet gevonden",
  "hisPatientLinkStatus.duplicate": "Duplicaat",
  "hisPatientLinkStatus.misconfigured": "Verkeerd geconfigureerd",

  "admin.practices.slug": "Slug",
  "admin.practices.his": "HIS",
  "admin.practices.searchFacet.careGroupName": "Zorggroepnaam",
  "admin.practices.searchFacet.fromEmail": "Afzender e-mail",
  "admin.practices.searchFacet.agbCode": "AGB-code",
  "admin.practices.claimAccess": "Verkrijg toegang",
  "admin.practices.claimAccessTitle": "Verkrijg toegang voor praktijk {practice}",
  "admin.practices.adminClaimReason": "Reden",
  "admin.practices.claimAccess.verify.title": "Bevestig dat jij het bent",
  "admin.practices.claimAccess.verify.description": "Vul de 6-cijferige code in van je authenticator app",
  "admin.practices.claimAccess.verify.label": "Verificatiecode",
  "admin.practices.claimAccess.verify.continue": "Doorgaan",
  "admin.practices.revokeAccess": "Toegang intrekken",
  "admin.practices.delete.title": "Praktijk {practice} verwijderen",
  "admin.practices.delete.confirmation":
    "Dit zal de praktijk en alle bijbehorende patiënten verwijderen. De gegevens kunnen niet worden hersteld! Weet u zeker dat u de praktijk volledig wilt verwijderen?",
  "admin.practices.delete.success": "Praktijk verwijderd",

  "admin.authorizationClaims": "Autorisatie claims",
  "admin.authorizationClaims.untilDate": "Geldig tot",
  "admin.authorizationClaims.user": "Gebruiker",
  "admin.authorizationClaims.reason": "Reden",
  "admin.authorizationClaims.active": "Actief",
  "admin.authorizationClaims.inactive": "Inactief",
  "admin.auditTrails.date": "Datum",
  "admin.auditTrails.action": "Actie",
  "admin.auditTrails.eventType": "Type",
  "admin.auditTrails.message": "Bericht",
  "admin.auditTrails.notSuccessful": "Niet succesvol",
  "admin.auditTrails.entity": "Entiteit",
  "admin.auditTrails.user": "Gebruiker",
  "admin.auditTrails.person": "Persoon",
  "admin.auditTrails.practice": "Praktijk",
  "admin.auditTrails.searchPerson": "Zoek persoon",
  "admin.auditTrails.searchUser": "Zoek gebruiker",
  "admin.auditTrails.action.C": "Create",
  "admin.auditTrails.action.R": "Read",
  "admin.auditTrails.action.U": "Update",
  "admin.auditTrails.action.D": "Delete",
  "admin.auditTrails.action.E": "Execute",
  "admin.auditTrails.entity.registrationRequest": "Inschrijving",
  "admin.auditTrails.userPracticeAccess.none": "Geen rechten",
  "admin.auditTrails.userPracticeAccess.regularAccess": "Reguliere rechten",
  "admin.auditTrails.userPracticeAccess.configurationAccess": "Beheerder",

  "admin.text.edit": "Wijzigen",
  "admin.editModeEnabled": "Wijzigen ingeschakeld",
  "admin.editModeDisabled": "Wijzigen uitgeschakeld",
  "admin.editModeHelperText":
    "Alleen admins kunnen dit. Aanpassingen zijn alleen mogelijk wanneer dit is ingeschakeld.",

  "general.policy": "Privacy & Policy",
  "general.terms": "Terms & Conditions",

  "fileModal.close.btn": "Sluiten",
  "fileModal.save.btn": "Opslaan",
  "fileModal.save.success": "Het bestand is opgeslagen; zie uw downloads map.",

  "print.sensitiveData":
    "Dit geprinte document van MijnPraktijk bevat mogelijk persoonlijke gezondheidsinformatie van patiënten. Ga hier zorgvuldig mee om en deel informatie alleen met betrokken zorgverleners.",

  "helpWidget.help": "Help",
  "helpWidget.title": "Waar heeft u een vraag over?",
  "helpWidget.technical": "Iets op deze site werkt niet",
  "helpWidget.medical": "Medische vraag",
  "helpWidget.other": "Overige vragen of problemen",
  "helpWidget.manuals": "Handleidingen bekijken",

  "portal.changeNotInHis": "Deze wijziging wordt niet in het HIS gedaan.",
  "portal.entity.notFound.title": "Niet gevonden",
  "portal.entity.notFound.description":
    "Deze pagina is niet toegankelijk. Mogelijk is er iets verwijderd of heb je geen toegang meer.",
  "button.previous": "Vorige",
  "button.next": "Volgende",
  "button.send": "Verzenden",
  "button.sending": "Verzenden...",
  "button.call": "Bel mij nu",
  "button.save": "Opslaan",
  "button.cancel": "Annuleren",
  "button.download": "Downloaden",
  "button.continue": "Doorgaan",
  "button.continueAnyway": "Toch verder",
  "button.back": "Terug",
  "button.close": "Sluiten",
  "button.clear": "Wissen",
  "button.confirm": "Bevestigen",

  "filePreview.invalid": "Dit bestand lijkt ongeldig of corrupt en kan niet worden weergegeven.",
  "filePreview.pdfError": "PDF fout: {error}",
  "filePreview.page": "Pagina",

  livePreview: "Live voorbeeld",

  "search.placeholder": "Zoeken",
  "search.searching": "Zoeken...",
  "search.noResults": "Geen resultaten",
  "search.agb.noResults": "Geen resultaten. Probeer bijvoorbeeld adres of plaatsnaam",
  "search.placeholderHint": "Begin met typen om te zoeken",
  "search.remainingResults": "En nog {remaining} resultaten",

  "login.loggedOut": "Je bent uitgelogd. Vul je gegevens in om opnieuw in te loggen.",
  "login.title": "Meer weten over MijnPraktijk.nl?",
  "login.privacyPolicy": "Onze privacyverklaring",
  "login.text.1": "Over MijnPraktijk.nl",
  "login.text.2": " of ga naar {link}",
  "login.asProfessional": "Inloggen als zorgverlener",
  "login.submit": "Inloggen",
  "login.email": "E-mail",
  "login.email.placeholder": "Voer uw e-mail in",
  "login.username": "Gebruikersnaam",
  "login.username.placeholder": "Voer uw gebruikersnaam of e-mailadres in",
  "login.password": "Wachtwoord",
  "login.password.placeholder": "Voer uw wachtwoord in",
  "login.storeCredentials": "Blijf aangemeld voor maximaal 7 dagen",
  "login.storeCredentials.info":
    "Zonder deze optie eindigt je sessie wanneer je de browser sluit. Gebruik dit niet op gedeelde of openbare computers.",
  "login.forgotpassword": "Wachtwoord vergeten?",
  "login.canNotLogin": "Ik kan niet inloggen",
  "login.forgot": "Vergeten?",

  // Login support flow
  "loginSupport.deactivated.title": "Account gedeactiveerd?",
  "loginSupport.deactivated.description": "Dit gebeurt als je al lang niet hebt ingelogd.",
  "loginSupport.deactivated.action": "Opnieuw activeren",
  "loginSupport.deactivated.detail":
    "<strong>Vraag een beheerder</strong> (zoals je praktijkmanager) om je account te heractiveren. Ben je zelf de enige beheerder? Neem dan contact op met onze support.",
  "loginSupport.forgotPassword.title": "Wachtwoord vergeten?",
  "loginSupport.forgotPassword.description":
    "Vul je gebruikersnaam of e-mailadres in. We sturen instructies naar je e-mailadres om het wachtwoord opnieuw in te stellen.",
  "loginSupport.forgotPassword.conditions":
    "<ul><li><strong>Als</strong> het e-mailadres bij ons bekend is</li><li><strong>Als</strong> het account nog actief is</li></ul>",
  "loginSupport.forgotPassword.action": "Opnieuw instellen",
  "loginSupport.forgotPassword.success":
    "Als het account bestaat, is er een e-mail verzonden met een link om je wachtwoord te resetten.",
  "loginSupport.forgotPassword.submit": "Versturen",
  "loginSupport.forgotUsername.title": "Gebruikersnaam vergeten?",
  "loginSupport.forgotUsername.description":
    "Vul je e-mailadres in. Als dit adres bij ons bekend is, sturen we je gebruikersnaam per e-mail.",
  "loginSupport.forgotUsername.conditions":
    "<ul><li><strong>Als</strong> het e-mailadres bij ons bekend is</li><li><strong>Als</strong> het account nog actief is</li></ul>",
  "loginSupport.forgotUsername.action": "Gebruikersnaam opvragen",
  "loginSupport.forgotUsername.email": "E-mailadres",
  "loginSupport.forgotUsername.success":
    "Als het account bestaat, is er een e-mail verzonden met daarin je gebruikersnaam of gebruikersnamen.",
  "loginSupport.forgotUsername.submit": "Opvragen",
  "loginSupport.mfaReset.title": "Tweestapsverificatie opnieuw instellen",
  "loginSupport.mfaReset.description":
    "Bijvoorbeeld omdat je vanuit een nieuw apparaat inlogt, of een nieuwe authenticator app gebruikt",
  "loginSupport.mfaReset.explanation":
    "<ol><li><strong>Support zal je bellen</strong><p>Op het nummer van de praktijk waar je toegang toe hebt, of het nummer wat bij ons bekend is. Dit is omdat we zorgvuldig met patiëntgegevens omgaan, en zeker willen zijn dat jij het bent.</p></li><li><strong>Gelukt?</strong><p>Dan reset support je account, en kan jij de tweestapsverificatie opnieuw instellen.</p></li></ol>",
  "loginSupport.mfaReset.action": "Opnieuw instellen",
  "loginSupport.mfaReset.email": "E-mailadres (van het account waar het om gaat)",
  "loginSupport.mfaReset.practice": "Bij welke huisartsenpraktijk probeer je in te loggen?",
  "loginSupport.mfaReset.additionalInfo": "Wil je nog iets kwijt?",
  "loginSupport.mfaReset.success": "Je verzoek is ingediend. We nemen zo snel mogelijk contact met je op.",
  "loginSupport.mfaReset.submit": "Contact support om deze opnieuw in te stellen",
  "loginSupport.other.title": "Iets anders?",
  "loginSupport.other.description": "Neem dan contact op.",
  "forgotPassword.email.placeholder": "E-mailadres",
  "loginSupport.other.link": "Contact support",
  "login.validation.passwordInvalid": "Vul het wachtwoord in",
  "login.totp.message": "Vul de 6-cijferige code in uit uw authenticator-app",
  "login.totp.message.entry": "Vul de 6-cijferige code in uit de regel <b>{entryName}</b> in uw authenticator-app",
  "login.totp.label": "6-cijferige code uit uw authenticator-app",
  "login.mfa.message": "Vul de 6-cijferige code in die naar uw e-mailadres is verstuurd",
  "login.mfa.label": "6-cijferige code uit uw e-mail",
  "login.error.credentials": "Inloggen niet gelukt. Controleer uw gebruikersnaam en wachtwoord.",
  "login.error.credentials.usernameNotEmail":
    "Inloggen niet gelukt. Controleer uw wachtwoord en uw <b>gebruikersnaam</b>. Die kan anders zijn dan uw e-mailadres.",
  "login.error.totp": "Onjuiste code",
  "login.error.totp.entry": "Onjuiste code. Gebruik de code uit de regel <b>{entryName}</b>.",
  "login.error.mfa": "Onjuiste e-mailcode",
  "login.error.mfaMaxAttempts":
    "Te veel onjuiste codes. Voer uw wachtwoord opnieuw in om een nieuwe code per e-mail te ontvangen.",
  "login.error.invalidCredentials": "Onjuiste inloggegevens",
  "login.error.tooManyAttempts":
    "Inloggen tijdelijk niet mogelijk. Er waren te veel mislukte inlogpogingen. Wacht 5 minuten en probeer het opnieuw.",
  "login.error.tokenExpired": "De code is verlopen. Log opnieuw in om een nieuwe code te ontvangen.",
  "login.error.duplicateEmail":
    "Er zijn meerdere accounts gekoppeld aan dit e-mailadres door een technisch probleem. Neem contact op met support@mijnpraktijk.nl om dit op te lossen. Mochten jij en andere familieleden een e-mailadres delen, laat het ons dan weten.",
  "login.error.inactive":
    "Uw account is gedeactiveerd omdat u te lang niet ingelogd heeft. Vraag een beheerder in uw praktijk om uw account weer te activeren.",
  "login.sensitiveDataNotification":
    "MijnPraktijk bevat persoonlijke gezondheidsinformatie van patiënten. Ga hier zorgvuldig mee om en deel informatie alleen met betrokken zorgverleners.",
  "login.mijnpraktijk": "Inloggen met MijnPraktijk",
  "login.digid": "Inloggen met DigiD",
  "login.digid.cancelled": "Het inloggen met DigiD is geannuleerd.",
  "login.digid.minimumAuthenticationLevelNotReached":
    "Inloggen bij deze organisatie is niet gelukt. Het beveiligingsniveau van uw DigiD is niet hoog genoeg. Via Mijn DigiD kunt u uw telefoonnummer koppelen om dit te verbeteren.",
  "login.digid.unknownError":
    "Inloggen bij deze organisatie is niet gelukt. Probeert u het later nog een keer. Lukt het nog steeds niet? Log in bij Mijn DigiD. Zo controleert u of uw DigiD goed werkt. Mogelijk is er een storing bij de organisatie waar u inlogt.",
  "login.digid.patientNotFound": "Het inloggen met DigiD is gelukt, maar uw BSN is nog niet bij ons bekend.",
  "login.digid.patientNotFound.otherMethod": "Log in via 'Inloggen met MijnPraktijk' en vul uw BSN in.",
  "login.digid.patientNotFound.register": "Nog niet ingeschreven? Schrijf u {link} in bij de praktijk.",
  "login.digid.patientNotFound.register.link": "hier",
  "login.digid.patientNotFound.contact": "Lukt dat niet? Neem dan contact op met uw praktijk.",

  "forgotPassword.email.label": "Jouw e-mailadres",
  "forgotPassword.identifier": "Gebruikersnaam of e-mailadres",
  "forgotPassword.identifier.placeholder": "Vul uw gebruikersnaam of e-mailadres in",
  "forgotPassword.message.success":
    "De link voor het opnieuw instellen van het wachtwoord is naar het e-mailadres {email} verzonden.",
  "forgotPassword.message.checkEmail": "Open je e-mail om door te kunnen gaan.",
  "forgotPassword.title": "Wachtwoord vergeten?",
  "forgotPassword.text":
    "Vul je gebruikersnaam of e-mailadres in. We sturen instructies naar je e-mailadres om het wachtwoord opnieuw in te stellen.",
  "forgotPassword.rememberPassword": "Wachtwoord toch onthouden?",
  "forgotPassword.backToLogin": "Terug naar inloggen",
  "forgotPassword.success.title": "Check je email inbox",
  "forgotPassword.success.text":
    "Als er een account overeenkomt, hebben we instructies gestuurd om je wachtwoord opnieuw in te stellen. Een link is slechts 30 minuten geldig, dus wacht niet te lang.",
  "resetPassword.reset": "Resetten",
  "resetPassword.message.success": "Het wachtwoord is gewijzigd",
  "resetPassword.message.successLogin": "Log in met je nieuwe wachtwoord.",
  "resetPassword.title": "Wachtwoord wijzigen",
  "resetPassword.requestNew": "Vraag een nieuwe wachtwoord reset aan.",
  "resetPassword.error.duplicatePassword": "Je hebt dit wachtwoord al eerder gebruikt. Kies een ander wachtwoord.",

  "confirmAccess.success.title": "Bedankt voor het bevestigen van je toegang tot MijnPraktijk!",
  "confirmAccess.success.description": "Je kunt deze pagina sluiten",
  "confirmAccess.error.title": "Er is iets misgegaan",
  "confirmAccess.error.description": "We konden je toegang niet bevestigen. Log alsjeblieft opnieuw in.",

  "person.contactInfo": "Contact informatie",
  "person.gender": "Geslacht",
  "person.gender.info": "Zoals deze in uw paspoort staat",
  "person.gender.male": "Man",
  "person.gender.female": "Vrouw",
  "person.gender.unknown": "n.v.t.",
  "person.firstName": "Voornaam",
  "person.affix": "Tussenvoegsel",
  "person.lastName": "Achternaam",
  "person.dateOfBirth": "Geboortedatum",
  "person.dateOfBirth.placeholder": "Bijv. 14-04-1990",
  "person.dateOfBirth.validation": "Vul een geldige geboortedatum in",
  "person.placeOfBirth": "Geboorteplaats",
  "person.language": "Taal inschrijving",
  "person.bsn": "Burgerservicenummer (BSN)",
  "person.bsn.validation": "BSN-nummer is onjuist",
  "person.bsn.required": "Burgerservicenummer (BSN) is verplicht",
  "person.phone": "Telefoonnummer",
  "person.mobilePhone": "Mobiel telefoonnummer",
  "person.mobilePhone.validation": "Vul een geldig mobiel telefoonnummer in",
  "person.mobilePhone.validationNL":
    "Nederlands mobiel telefoonnummer moet {requiresPrefix, select, true {beginnen met een 6 en } other {}}9 cijfers hebben",
  "person.mobilePhone.validationServiceNumber.disabled": "Service nummers zijn niet toegestaan",
  "person.mobilePhone.validationServiceNumber.invalid": "Vul een geldig service nummer in",
  "person.mobilePhone.disabledForeignPhoneNumbers":
    "Wanneer we u willen bereiken gebruiken we dit nummer. We accepteren alleen Nederlandse nummers.",
  "person.address": "Adres",
  "person.street": "Straat",
  "person.houseNumber": "Huisnummer",
  "person.houseNumber.withoutAddition": "(zonder toevoeging)",
  "person.houseNumber.placeholder": "Bijvoorbeeld: 42",
  "person.houseNumber.validation": "Vul een geldig huisnummer in",
  "person.houseNumberAddition": "Huisnummer toevoeging",
  "person.houseNumberAddition.info":
    "Bijvoorbeeld A, II, bis, etc. Kan leeg gelaten worden indien niet van toepassing.",
  "person.houseNumberAddition.placeholder": "Toevoeging",
  "person.houseNumberFull": "Huisnummer (met toevoeging)",
  "person.houseNumberFull.placeholder": "Bijvoorbeeld: 123A",
  "person.houseNumberFull.validation": "Vul een geldig huisnummer in",
  "person.houseNumberFull.required": "Huisnummer (met toevoeging) is verplicht",
  "person.postalCode": "Postcode",
  "person.postalCode.placeholder": "Bijvoorbeeld: 1234 AB",
  "person.postalCode.validation": "Vul een geldige postcode in",
  "person.postalCode.partialValidation": "Vul een volledige postcode met cijfers en letters in",
  "person.postalCode.postalCodeRegex":
    "De praktijk accepteert alleen inschrijvingen uit een bepaald postcodegebied. De ingevulde postcode valt daarbuiten. Het is daarom niet mogelijk om in te schrijven voor deze praktijk. Neem contact op met de praktijk als u denkt dat een uitzondering mogelijk is.",
  "person.city": "Woonplaats",
  "person.autoFillAfterPostalCode": "Automatisch ingevuld na invoeren postcode en huisnummer",
  "person.postalCodeHouseNumberNotFound": "Combinatie postcode/huisnummer niet gevonden",
  "person.email": "E-mailadres",

  "plato.model.search": "Wat is uw klacht of vraag?",
  "plato.model.search.placeholder": "Zoals: 'plasklachten' of 'vaccinatie'",
  "plato.model.search.results": "Klachten",
  "plato.model.search.active": "Zoekresultaten",
  "plato.model.noResults.tip1": "Ander zoekwoord",
  "plato.model.noResults.tip1.info": "Bijvoorbeeld 'hoofdpijn' in plaats van 'migraine'.",
  "plato.model.noResults.tip2": "Korter woord",
  "plato.model.noResults.tip2.info": "Bijvoorbeeld 'urine' in plaats van 'urinewegprobleem'.",
  "plato.model.noResults.tip3": "Juiste spelling",
  "plato.model.cannotFind": "Ik kan mijn klacht niet vinden",
  "plato.model.cannotFind.title": "Geen zoekresultaten",
  "plato.model.cannotFind.altTitle": "Niet gevonden wat u zocht?",
  "plato.model.cannotFind.info": "Misschien helpt dit:",
  "plato.model.cannotFind.alternative": "Nog steeds geen succes?",
  "plato.model.cannotFind.alternative.link": "Ga naar de algemene vragenlijst",
  "plato.model.cannotFind.alternative.title":
    "Let op! Wij kunnen u beter helpen als u op deze pagina wel uw klacht vindt",
  "plato.model.cannotFind.alternative.notice": "Dan kunnen we gerichter vragen stellen.",
  "plato.model.emergency": "Is het levensbedreigend? Bel dan 112",
  "plato.model.emergency.practice": "Is het levensbedreigend? Bel dan 112 of ons spoednummer: {phoneNumber}.",
  "plato.model.complaints.mostChosen": "Meest gekozen klachten",
  "plato.administrative.title": "Vragen",
  "plato.administrative.placeholder": "Zoals: 'afspraak wijzigen' of 'vaccinatie'",
  "plato.administrative.unavailable": "Geen opties gevonden",
  "plato.administrative.all": "Alle acties",
  "plato.localeChange.close": "Annuleren",
  "readAloud.label": "Lees voor",
  "readAloud.pause": "Pauze",
  "readAloud.previous": "Vorige",
  "readAloud.next": "Volgende",

  "plato.localeChange.confirm": "Begin opnieuw",
  "plato.localeChange.info":
    'De vragenlijst is al gestart in het {oldLanguage}. Klik op de "Begin opnieuw" knop om opnieuw op te starten in {newLanguage}.',
  "plato.advice": "Onze aanbeveling",
  "plato.advice.contact": "Telefoonnummer: {phoneNumber}",
  "plato.advice.contact.immediate": "Bel meteen",
  "plato.advice.contact.immediate.desc":
    "Op basis van uw antwoorden raden we u aan om niet te wachten. Bel meteen de praktijk.",
  "plato.advice.contact.soon": "Bel onze praktijk",
  "plato.advice.contact.soon.desc": "Op basis van uw antwoorden raden we u aan om ons te bellen.",
  "plato.advice.contact.button": "Bellen",
  "plato.advice.contact.page": "<contactLink>Neem contact op</contactLink> met de praktijk",
  "plato.advice.contact.page.button": "Neem contact op",
  "plato.advice.hap.contact": "Neem contact op met uw huisartsenpost.",
  "plato.advice.hap.immediate": "Bel meteen de huisartsenpost",
  "plato.advice.hap.immediate.desc":
    "Op basis van uw antwoorden raden we u aan om niet te wachten. Bel meteen de huisartsenpost.",
  "plato.advice.hap.soon": "Bel de huisartsenpost",
  "plato.advice.hap.soon.desc":
    "Op basis van uw antwoorden zou het kunnen dat uw klacht vandaag beoordeeld moet worden. De huisartsenpost stelt u vragen om te bepalen wat er met uw klacht moet gebeuren.",
  "plato.advice.hap.within.24h": "Bel de huisartsenpost",
  "plato.advice.hap.within.24h.desc":
    "Op basis van uw antwoorden zou het kunnen dat uw klacht binnen 24 uur beoordeeld moet worden. De huisartsenpost stelt u vragen om te bepalen wat er met uw klacht moet gebeuren.",
  "plato.advice.homeAdvice.expand": "Lees nu het thuisadvies",
  "plato.advice.appointment.expand": "Maak {start, select, true {nu een} other {een}} afspraak",
  "plato.advice.faceToFace":
    "Kom {sameDay, select, true {vandaag nog naar} other {binnen {within} langs bij}} de praktijk",
  "plato.advice.within.24h": "24 uur",
  "plato.advice.within.3d": "3 dagen",
  "plato.advice.within.5d": "5 dagen",
  "plato.advice.within.2w": "2 weken",
  "plato.advice.faceToFace.expand": "Plan een afspraak bij de praktijk",
  "plato.advice.econsult": "Stuur een bericht",
  "plato.advice.econsult.desc":
    "We sturen uw antwoorden mee in het bericht. U ontvangt een e-mail als wij hebben gereageerd.",
  "plato.advice.econsult.expand": "{start, select, true {Stuur bericht} other {Ga verder}}",
  "plato.advice.homeAdvice": "Instructies",
  "plato.advice.homeAdvice.desc": "Lees wat u zelf kunt doen en waar u op moet letten.",
  "plato.advice.other.desc":
    "Maak hiervoor een afspraak {sameDay, select, true {vandaag} other {binnen de komende {within}}}.",
  "plato.advice.other.adviceType.homeAdvice": "Thuisadvies",
  "plato.advice.other.adviceType.video": "Videoafspraak",
  "plato.advice.other.adviceType.phone": "Telefonische afspraak",
  "plato.advice.other.adviceType.econsult": "Online gesprek",
  "plato.advice.other.adviceType.faceToFace": "Afspraak",
  "plato.advice.other.adviceType.walkInConsult": "Gesprek tijdens ons inloopspreekuur",
  "plato.advice.otherOptions": "Andere opties",
  "plato.advice.otherOptions.desc": "Wilt u liever op een andere manier contact? Kies dan uit:",
  "plato.advice.otherOptions.followUp.faceToFace": "Plan een afspraak bij de praktijk",
  "plato.advice.otherOptions.followUp.video": "Plan een videoafspraak",
  "plato.advice.otherOptions.followUp.phone": "Plan een telefonische afspraak",
  "plato.advice.otherOptions.followUp.econsult": "Start een online gesprek",
  "plato.advice.otherOptions.followUp.walkInConsult": "Kom langs op het inloopspreekuur",
  "plato.advice.emergencyDisclaimer.title": "Levensbedreigend?",
  "plato.advice.emergencyDisclaimer.prose": "<ul><li>Bel dan 112</li><li>Of ons spoednummer: {phoneNumber}</li></ul>",

  "plato.advice.changeDisclaimer.title": "Worden de klachten erger, anders of twijfelt u?",
  "plato.advice.changeDisclaimer.prose": "<ul><li>Neem dan opnieuw contact op.</li></ul>",

  "plato.advice.moreInfo": "Meer informatie",
  "plato.advice.closingSoon.title": "De praktijk sluit bijna",
  "plato.advice.closingSoon.text1":
    "Buiten werktijden (avond, nacht, weekend) behandelen we geen berichten van patiënten.",
  "plato.advice.closingSoon.text2": "Zeker weten dat uw vraag op tijd behandeld wordt? Bel dan de praktijk.",

  "plato.urgency.placeholder": "Selecteer urgentie",

  "plato.scale.1":
    "<p><b>1. Lichte pijn</b></p><p>De pijn is amper merkbaar en ik kan nog alles doen wat ik normaal doe.</p>",
  "plato.scale.2":
    "<p><b>2. Lichte pijn</b></p><p>De pijn is merkbaar, maar ik kan nog alles doen wat ik normaal doe.</p>",
  "plato.scale.3":
    "<p><b>3. Lichte pijn</b></p><p>De pijn is erg merkbaar, maar ik kan nog alles doen wat ik normaal doe.</p>",
  "plato.scale.4": "<p><b>4. Matige pijn</b></p><p>De pijn leidt me af, ik merk het tijdens de dingen die ik doe.</p>",
  "plato.scale.5":
    "<p><b>5. Matige pijn</b></p><p>De pijn leidt mij erg af, waardoor ik enkele dingen niet meer kan doen.</p>",
  "plato.scale.6":
    "<p><b>6. Matige pijn</b></p><p>De pijn leidt mij erg af, waardoor ik meerdere dingen niet meer kan doen.</p>",
  "plato.scale.7": "<p><b>7. Hevige pijn</b></p><p>Ik kan bijna niks meer doen wat ik normaal doe.</p>",
  "plato.scale.8":
    "<p><b>8. Hevige pijn</b></p><p>Ik kan niks meer doen wat ik normaal doe of het gaat heel moeizaam.</p>",
  "plato.scale.9": "<p><b>9. Hevige pijn</b></p><p>Ik kan niks meer doen wat ik normaal doe.</p>",
  "plato.scale.10":
    "<p><b>10. Ergste pijn ooit</b></p><p>Ik kan niks meer doen wat ik normaal doe. De pijn overheerst alles.</p>",

  "registrationRequests.title": "Inschrijvingen",
  "registrationRequests.sameAddress.title": "Zelfde adres",
  "registrationRequests.bulkDelete.count":
    "{count, plural, =1 {# inschrijving geselecteerd} other {# inschrijvingen geselecteerd}}",
  "registrationRequests.bulkDelete.deselect": "Selectie wissen",
  "registrationRequests.bulkDelete.modal.title": "Inschrijvingen verwijderen",
  "registrationRequests.bulkDelete.modal.body":
    "{count, plural, =1 {# inschrijving wordt definitief verwijderd.} other {# inschrijvingen worden definitief verwijderd.}} Persoonsgegevens van afgewezen en onbehandelde inschrijvingen worden geanonimiseerd. Deze actie kan niet ongedaan worden gemaakt.",
  "registrationRequests.bulkDelete.modal.hisCheckbox":
    "Ik bevestig dat alle relevante patiëntgegevens zijn overgedragen naar het HIS.",
  "registrationRequest.edit": "Bewerken",
  "registrationRequest.person.title": "Persoonlijke informatie",
  "registrationRequest.person.age": "Leeftijd",
  "registrationRequest.person.years": "jaar",

  // The grey sub-line under every value in the per-field history above a
  // "Persoonlijke informatie" input: the moment, a comma, then where the value
  // came from. Both external sources read as the ID document — the card does
  // not distinguish the provider's automatic pass from its reviewed one. The
  // `user` line never names a role: the user record holds a name only.
  "registrationRequest.person.changelog.source.external": "uitgelezen uit ID document",
  "registrationRequest.person.changelog.source.patient": "ingevuld door patiënt",
  "registrationRequest.person.changelog.source.user": "aangepast door {actor}",
  "registrationRequest.person.changelog.source.system": "automatisch bijgewerkt",
  // A value nobody recorded: shown without a date, since when it was entered is unknown too.
  "registrationRequest.person.changelog.firstKnownValue": "eerste bekende waarde, bron en datum niet vastgelegd",
  "registrationRequest.checklist.title": "Controlelijst",
  "registrationRequest.process.title": "Inschrijving",
  "registrationRequest.process.placeOfBirth": "Geboorteplaats",
  "registrationRequest.previousGp.label": "Vorige huisarts",
  "registrationRequest.previousGp.filter.notKnown": "(Nog) niet bekend",
  "registrationRequest.previousGp.filter.known": "Bekend",
  "registrationRequest.previousGp.requestApproval": "Toestemming overdracht dossier",
  "registrationRequest.previousGp.requestApproval.passant": "Niet gevraagd (passant)",
  "registrationRequest.previousGp.patientCannotFind": "Patiënt kon vorige huisarts niet vinden",
  "registrationRequest.previousGp.patientHadNone": "Patiënt heeft geen Nederlandse huisarts gehad",
  "registrationRequest.previousGp.source.ion": "Automatisch opgehaald via stichting ION",
  "registrationRequest.previousGp.source.patient": "Ingevuld door patiënt",
  "registrationRequest.previousGp.ion": "Aangepast n.a.v. ION inschrijving",
  "registrationRequest.previousGp.ion.unknown": "Kan vorige huisarts niet bepalen",
  "registrationRequest.previousGp.ion.disabled":
    "De vorige huisarts is niet gevonden. Tijdens de inschrijving moet daarvoor ‘Inschrijving van de patiënt via ION’ aan staan.",
  "registrationRequest.previousGp.fetchedAfterAcceptance":
    "Wordt automatisch opgehaald nadat de patiënt is geaccepteerd",

  "registrationRequest.previousGp.covAlert.disabled.title":
    "Pas je instellingen aan om de vorige huisarts van Stichting ION te ontvangen",
  "registrationRequest.previousGp.covAlert.disabled": `Nadat de inschrijving in MijnPraktijk geaccepteerd is, kan je van Stichting ION de naam van de vorige huisartsenpraktijk ontvangen.

    Ga hiervoor naar: instellingen > Inschrijvingen > inschrijving van de patiënt via ION, en vink deze aan.`,

  "registrationRequest.previousGp.covAlert.alreadyPatient.title":
    "ION geeft aan dat deze persoon al patiënt is bij uw praktijk",
  "registrationRequest.previousGp.covAlert.alreadyPatient": `Dat kan zijn omdat:

De patiënt heeft zich een tweede keer ingeschreven, of...
U heeft deze persoon eerst bij ION aangemeld (bijvoorbeeld via uw HIS) en toen pas in MijnPraktijk geaccepteerd.

Zorg dat u de inschrijving eerst accepteert in MijnPraktijk, en dáárna pas in het HIS en ION zet.

Zo krijgt de juiste vorige huisarts automatisch een uitschrijfverzoek en een verzoek tot dossieroverdracht`,

  "registrationRequest.previousGp.covAlert.unauthorized.title":
    "Geef MijnPraktijk toestemming in Vecozo om de vorige huisarts van Stichting ION te ontvangen",
  "registrationRequest.previousGp.covAlert.unauthorized": `Heeft u dit al eens eerder gedaan? Misschien is de toestemming inmiddels verlopen.

{permissionLink} op 'Toestemmingsverklaring aan derden' en volg de link om in te loggen.

{videoLink} laat zien hoe je vanuit hier verder kunt met instellen.`,

  "registrationRequest.previousGp.covAlert.unauthorized.vecozoLink.permissions": "Klik hier",
  "registrationRequest.previousGp.covAlert.unauthorized.vecozoLink.video": "Dit filmpje",
  "registrationRequest.previousGp.covAlert.notFoundCov.title": "Geen vorige huisarts bekend bij Stichting ION",
  "registrationRequest.previousGp.covAlert.notFoundCov":
    "Dat gebeurt onder andere wanneer een patiënt niet in Nederland verzekerd is.",

  "registrationRequest.previousGpMessage.label": "Ondertekende brief verstuurd naar vorige huisarts",

  "registrationRequest.previousGpMessageLetter.null": "Uitgeschakeld",
  "registrationRequest.previousGpMessageLetter.disabled": "Uitgeschakeld",
  "registrationRequest.previousGpMessageLetter.ionDisabled":
    "Kan brief niet versturen: ION is vereist om de vorige huisarts te vinden",
  "registrationRequest.previousGpMessageLetter.ok": "Brief verzonden",
  "registrationRequest.previousGpMessageLetter.differentIonGpWaitingForPatient":
    "ION geeft een andere vorige huisarts aan dan door de patiënt opgegeven",
  "registrationRequest.previousGpMessageLetter.noPreviousGp":
    "Brief niet verzonden: Geen vorige huisarts gevonden via ION",
  "registrationRequest.previousGpMessageLetter.notSigned": "Brief niet verzonden",
  "registrationRequest.previousGpMessageLetter.noZorgMailAccount":
    "Kan brief niet versturen: De vorige huisarts heeft geen ZorgMail",
  "registrationRequest.previousGpMessageLetter.zorgMailBounce":
    "Afleveren brief mislukt {retrying, select, true {(Opnieuw proberen...)} other {(Bounced)}}",
  "registrationRequest.previousGpMessageLetter.error": "Brief niet verzonden: Onbekende fout",
  "registrationRequest.previousGpMessageLetter.error.expired":
    "Vorige huisarts heeft het verzoek niet op tijd goedgekeurd",
  "registrationRequest.previousGpMessageLetter.error.sendFailed": "Verzenden mislukt",
  "registrationRequest.previousGpMessageLetter.pending": "Wacht op akkoord",
  "registrationRequest.previousGpMessageLetter.pending.expired": "Verzoek verlopen",
  "registrationRequest.previousGpMessageLetter.pending.sendFailed": "Verzenden mislukt",
  "registrationRequest.previousGpMessageLetter.notApproved": "Brief niet verzonden: De patiënt geeft geen toestemming",

  "registrationRequest.previousGpMessageResult.null": "Uitgeschakeld",
  "registrationRequest.previousGpMessageResult.disabled": "Uitgeschakeld",
  "registrationRequest.previousGpMessageResult.ionDisabled":
    "De vorige huisarts kon niet worden opgezocht, omdat ION is uitgeschakeld",
  "registrationRequest.previousGpMessageResult.ok": "Verstuurd",
  "registrationRequest.previousGpMessageResult.differentIonGpWaitingForPatient":
    "ION gaf andere huisarts terug dan patiënt opgaf",
  "registrationRequest.previousGpMessageResult.noPreviousGp": "Geen vorige huisarts bekend bij stichting ION",
  "registrationRequest.previousGpMessageResult.notSigned": "Brief niet verzonden",
  "registrationRequest.previousGpMessageResult.noZorgMailAccount": "Vorige huisarts heeft geen ZorgMail account",
  "registrationRequest.previousGpMessageResult.zorgMailBounce": "ZorgMail kon niet worden afgeleverd (Bounced)",
  "registrationRequest.previousGpMessageResult.error":
    "Er ging iets mis bij het ophalen van de vorige huisarts bij stichting ION (onbekende foutmelding)",
  "registrationRequest.previousGpMessageResult.error.expired":
    "Vorige huisarts heeft het verzoek niet op tijd goedgekeurd",
  "registrationRequest.previousGpMessageResult.error.sendFailed": "Verzenden mislukt",
  "registrationRequest.previousGpMessageResult.pending": "Wacht op akkoord",
  "registrationRequest.previousGpMessageResult.pending.expired": "Verzoek verlopen",
  "registrationRequest.previousGpMessageResult.pending.sendFailed": "Verzenden mislukt",
  "registrationRequest.previousGpMessageResult.notApproved": "Patiënt geeft geen toestemming",

  "registrationRequest.insurance.insurer": "Zorgverzekeraar",
  "registrationRequest.insurance.notAsked": "Niet gevraagd (geen BSN)",
  "registrationRequest.pharmacy.notAsked": "Niet gevraagd",
  "registrationRequest.insurance.name": "Naam zorgverzekeraar",
  "registrationRequest.insurance.number": "Polisnummer",
  "registrationRequest.rejectionReason": "Reden afwijzing",
  "registrationRequest.patientType.label": "Soort patiënt",
  "registrationRequest.patientType.regular": "Reguliere patiënt",
  "registrationRequest.patientType.passant": "Passant",
  "registrationRequest.passant.alert":
    "Passant: deze persoon blijft ingeschreven bij de eigen huisarts. Accepteren meldt niet aan bij ION; de inschrijving gaat wel naar het HIS, markeer de patiënt daar als passant.",
  "registrationRequest.passant.accept.title": "Passant accepteren",
  "registrationRequest.passant.accept.description":
    "Deze persoon is een passant en blijft ingeschreven bij de eigen huisarts. MijnPraktijk meldt de patiënt niet aan bij ION. De inschrijving wordt wel naar het HIS verzonden: markeer de patiënt daar zelf als passant, anders stuurt het HIS alsnog een ION-aanmeldbericht.",
  "registrationRequest.passant.accept.confirm": "Accepteren",
  "registrationRequest.passant.accept.hisInstruction.default":
    "Markeer deze patiënt in het HIS als passant, zodat er geen ION-aanmelding plaatsvindt.",
  "registrationRequest.passant.accept.hisInstruction.medicom": "In Medicom vink je bij de patiënt 'incidenteel' aan.",
  "registrationRequest.passant.accept.hisInstruction.promedico":
    "Wijzig in Promedico de status van 'Vaste patiënt' naar Passant (of Waarneming / Tijdelijk, afhankelijk van de situatie).",
  "registrationRequest.rejectionReason.title": "Reden afwijzing",
  "registrationRequest.rejectionReason.reason": "Reden",
  "registrationRequest.rejectionReason.prompt": "Voer een afwijzingsreden in",
  "registrationRequest.rejectionReason.reason.info":
    "Houd er rekening mee dat de reden van afwijzing per e-mail naar de patiënt gestuurd wordt. Zet er dus geen medische informatie in.",
  "registrationRequest.rejectionReason.placeholder": "Optionele reden voor afwijzing",
  "registrationRequest.rejectionReason.reject": "Afwijzen",
  "registrationRequest.agbCode.title": "AGB-code voor inschrijving",
  "registrationRequest.agbCode.description1": "Om deze patiënt te accepteren moet er een AGB-code geselecteerd worden.",
  "registrationRequest.agbCode.description2": "Voor welke praktijk wordt deze patiënt ingeschreven?",
  "registrationRequest.agbCode.placeholder": "Selecteer praktijk",
  "registrationRequest.agbCode.confirm": "Selecteren",
  "registrationRequest.hisKnown.title": "Patiënt al bekend in HIS",
  "registrationRequest.hisKnown.description":
    "Deze patiënt is al bekend in het HIS. Bij accepteren heeft het HIS misschien een dubbele patiënt.",
  "registrationRequest.hisKnown.areYouSure": "Weet je zeker dat je deze patiënt wilt accepteren?",
  "registrationRequest.hisKnown.confirm": "Accepteren",
  "registrationRequest.vecozoCov.label": "COV verzekering controle",
  "registrationRequest.pharmacyAgb": "AGB-code: {agbCode}",
  "registrationRequest.vecozoCovResult.disabled": "Niet uitgevoerd",
  "registrationRequest.vecozoCovResult.noBsn": "Niet uitgevoerd: geen BSN",
  "registrationRequest.vecozoCovResult.ok": "COV check goedgekeurd",
  "registrationRequest.vecozoCovResult.ok.subText": "Patiënt is verzekerd in Nederland.",
  "registrationRequest.vecozoCovResult.inactiveInsurance": "Patiënt heeft geen actieve verzekering in Nederland",
  "registrationRequest.vecozoCovResult.bsnUnknown": "Er gaat iets mis — controleer handmatig",
  "registrationRequest.vecozoCovResult.bsnUnknown.subText": "De BSN van de patiënt is bij Vecozo onbekend.",
  "registrationRequest.vecozoCovResult.bsnIncorrect": "Er gaat iets mis — controleer handmatig",
  "registrationRequest.vecozoCovResult.bsnIncorrect.subText": "De BSN van de patiënt is geen correct BSN nummer.",
  "registrationRequest.vecozoCovResult.combinationBsnDateOfBirthUnknown": "Combinatie BSN en geboortedatum onbekend",
  "registrationRequest.vecozoCovResult.multiplePersonsFound": "Meerdere personen gevonden",
  "registrationRequest.vecozoCovResult.notFound": "Persoon niet gevonden",
  "registrationRequest.vecozoCovResult.error": "Algemene fout",
  "registrationRequest.vecozoCov.checkedAt": "Gecheckt via Vecozo {date}",
  "registrationRequest.vecozoCov.disabledAlert.title":
    "Pas je instellingen aan om de COV verzekeringscheck van Vecozo te ontvangen.",
  "registrationRequest.vecozoCov.disabledAlert":
    "Ga hiervoor naar: instellingen > Inschrijvingen > Acties nadat de patiënt is geaccepteerd",
  "registrationRequest.vecozoCov.retrySuccess": "COV controle opnieuw uitgevoerd",
  "registrationRequest.sendToHis": "Sturen naar het HIS",
  "registrationRequest.sendToHis.success": "Inschrijving is naar het HIS verstuurd",
  "registrationRequest.sendToAutoMedic": "Sturen naar AutoMedic",
  "registrationRequest.sendToAutoMedic.success": "Inschrijving is naar AutoMedic verstuurd",
  "registrationRequest.resendToHis": "Opnieuw sturen naar het HIS",
  "registrationRequest.resendToHis.success": "Inschrijving is opnieuw naar het HIS verstuurd",
  "registrationRequest.resendToAutoMedic": "Opnieuw sturen naar AutoMedic",
  "registrationRequest.resendToAutoMedic.success": "Inschrijving is opnieuw naar AutoMedic verstuurd",
  "registrationRequest.vecozoIon.label": "ION inschrijving",
  "registrationRequest.vecozoIon.previousGp": "Vorige huisarts",
  "registrationRequest.vecozoIon.performedAfterAcceptance": "Wordt uitgevoerd nadat de patiënt is geaccepteerd",
  "registrationRequest.vecozoIon.notPerformed.passant": "Wordt niet uitgevoerd (passant)",
  "registrationRequest.vecozoIon.notPerformed.passant.subText":
    "Bij accepteren wordt de ION-aanmelding bewust overgeslagen omdat dit een passant is: de persoon blijft ingeschreven bij de eigen huisarts. De rest van de inschrijving verloopt zoals bij een reguliere patiënt.",
  "registrationRequest.vecozoIon.ok": "De patiënt is aangemeld via ION. Vorige huisarts: {previousGp}.",
  "registrationRequest.vecozoIon.error": "De patiënt is niet aangemeld via ION: {errorMessage}.",
  "registrationRequest.vecozoIon.passant": "ION-aanmelding overgeslagen: passant.",
  "registrationRequest.vecozoIonResult.disabled": "ION uitgeschakeld",
  "registrationRequest.vecozoIonResult.ok": "ION uitgevoerd",
  "registrationRequest.vecozoIonResult.unauthorized": "Geen toestemming voor ION",
  "registrationRequest.vecozoIonResult.notFoundCov": "Geen COV gevonden",
  "registrationRequest.vecozoIonResult.died": "Patiënt overleden",
  "registrationRequest.vecozoIonResult.alreadyPatient": "Al geregistreerd als patiënt",
  "registrationRequest.vecozoIonResult.invalidBsn": "Ongeldige BSN",
  "registrationRequest.vecozoIonResult.error": "Algemene fout",
  "registrationRequest.vecozoIonResult.passant": "Overgeslagen (passant)",
  "registrationRequest.vecozoIonResult.passant.subText":
    "De ION-aanmelding is bewust overgeslagen omdat dit een passant is: de persoon blijft ingeschreven bij de eigen huisarts. De rest van de inschrijving verloopt zoals bij een reguliere patiënt.",
  "registrationRequest.error.bsnAlreadyExists":
    "Patiënt bestaat al in het HIS. Zoek in het HIS (ook in inactieve patiënten), en zet de patiënt weer op actief.",
  "registrationRequest.error.bsnInvalid": "Niet gelukt om naar het HIS te sturen. Controleer of het BSN geldig is.",
  "registrationRequest.error.hisFailed":
    "Het is niet gelukt om de patiënt in het HIS te registreren. Probeer het opnieuw of registreer de patiënt handmatig.",
  "registrationRequest.idCheck.label": "ID check",
  "registrationRequest.idCheck.document": "Document",
  "registrationRequest.idCheck.disabledAlert.title": "Pas je instellingen aan om de ID check van iDenfy te ontvangen.",
  "registrationRequest.idCheck.disabledAlert":
    "Ga hiervoor naar: instellingen > Inschrijvingen > Voorwaarden voor inschrijving > Digitale ID controle",

  // Status line shown when a registration has no ID check timeline: practices
  // with the ID check switched off, and registrations from before the timeline
  // shipped. Each status names the outcome and what the assistant should do
  // with it, with the `.description` sub-line explaining how it came about.
  "registrationRequest.idCheckResult.pending": "ID controle loopt nog — nog niet accepteren",
  "registrationRequest.idCheckResult.pending.description":
    "De patiënt heeft online zijn ID gescand. De automatische controle van het ID is nog niet afgerond. Dit kan tot 30 minuten duren.",
  "registrationRequest.idCheckResult.disabled":
    "De praktijk heeft de Digitale ID controle uit staan — controleer handmatig",
  "registrationRequest.idCheckResult.ok": "ID Goedgekeurd",
  "registrationRequest.idCheckResult.ok.description":
    "De patiënt heeft online zijn ID gescand. Deze is automatisch gecontroleerd, en goedgekeurd.",
  "registrationRequest.idCheckResult.patientSkipped": "ID check overgeslagen — controleer handmatig",
  "registrationRequest.idCheckResult.patientSkipped.description": "De patiënt heeft zelf de ID check overgeslagen.",
  "registrationRequest.idCheckResult.idInvalid": "ID check mislukt — controleer handmatig",
  "registrationRequest.idCheckResult.idInvalid.description":
    "De patiënt heeft online zijn ID gescand. Deze is automatisch gecontroleerd, maar hier ging iets mis.",
  "registrationRequest.idCheckResult.verificationInconsistency": "Gezichtsherkenning onjuist",
  "registrationRequest.idCheckResult.error": "ID check mislukt — controleer handmatig",
  "registrationRequest.idCheckResult.error.description":
    "De patiënt is begonnen aan de online ID check, maar heeft deze niet afgemaakt.",

  // Edited by GP/Assistant. `user.edited` covers a plain edit to the patient's
  // details and `system.updated` an event written by the system (which has no
  // actor): neither carries a check outcome, so both deliberately have no
  // `.description` sub-line.
  "registrationRequest.idCheckTimeline.user.edited": "Door {actor}",
  "registrationRequest.idCheckTimeline.system.updated": "Automatisch bijgewerkt",
  "registrationRequest.idCheckTimeline.manualVerification.action": "Aanpassen",
  "registrationRequest.idCheckTimeline.manualVerification.placeholder": "Opmerking",
  "registrationRequest.idCheckTimeline.manualVerification.submit": "Bevestigen",

  // Every timeline event title reuses the same five outcome texts as the
  // `idCheckResult` fallback copy (IT-5028), so the assistant reads the same
  // wording whichever render path a registration takes. The `.description`
  // sub-line below each title explains how that outcome came about; the UI
  // derives it by appending `.description` to the title key, so a title without
  // one simply shows no sub-line.

  // A status a colleague set by hand at the desk. A rejection here does not say
  // "controleer handmatig" — a person has just checked it by hand.
  "registrationRequest.idCheckTimeline.manualVerification.ok": "ID goedgekeurd",
  "registrationRequest.idCheckTimeline.manualVerification.ok.description": "Handmatig gecontroleerd door {actor}.",
  "registrationRequest.idCheckTimeline.manualVerification.pending": "ID controle loopt nog — nog niet accepteren",
  "registrationRequest.idCheckTimeline.manualVerification.pending.description": "Op wachten gezet door {actor}.",
  "registrationRequest.idCheckTimeline.manualVerification.idInvalid": "ID afgekeurd — niet accepteren",
  "registrationRequest.idCheckTimeline.manualVerification.idInvalid.description": "Handmatig afgekeurd door {actor}.",

  // Translations for `providerAutomatic` (initial ID check, automated with AI/OCR).
  "registrationRequest.idCheckTimeline.providerAutomatic.pending": "ID controle loopt nog — nog niet accepteren",
  "registrationRequest.idCheckTimeline.providerAutomatic.pending.description":
    "De patiënt heeft online zijn ID gescand. De automatische controle van het ID is nog niet afgerond. Dit kan tot 30 minuten duren.",
  "registrationRequest.idCheckTimeline.providerAutomatic.ok": "ID goedgekeurd",
  "registrationRequest.idCheckTimeline.providerAutomatic.ok.description":
    "De patiënt heeft online zijn ID gescand. Deze is automatisch gecontroleerd, en goedgekeurd.",
  "registrationRequest.idCheckTimeline.providerAutomatic.idInvalid": "ID check mislukt — controleer handmatig",
  "registrationRequest.idCheckTimeline.providerAutomatic.idInvalid.description":
    "De patiënt heeft online zijn ID gescand. Deze is automatisch gecontroleerd, maar hier ging iets mis.",
  "registrationRequest.idCheckTimeline.providerAutomatic.notDone": "ID check mislukt — controleer handmatig",
  "registrationRequest.idCheckTimeline.providerAutomatic.notDone.description":
    "De patiënt is begonnen aan de online ID check, maar heeft deze niet afgemaakt.",
  "registrationRequest.idCheckTimeline.providerAutomatic.verificationInconsistency":
    "ID check mislukt — controleer handmatig",
  "registrationRequest.idCheckTimeline.providerAutomatic.verificationInconsistency.description":
    "De patiënt heeft online zijn ID gescand. De controle gaf een tegenstrijdige uitkomst.",
  "registrationRequest.idCheckTimeline.providerAutomatic.unknownError": "ID check mislukt — controleer handmatig",
  "registrationRequest.idCheckTimeline.providerAutomatic.unknownError.description":
    "Er ging iets mis tijdens de controle van het ID.",
  "registrationRequest.idCheckTimeline.providerAutomatic.failed": "ID check mislukt — controleer handmatig",
  "registrationRequest.idCheckTimeline.providerAutomatic.failed.description":
    "De patiënt heeft online zijn ID gescand. Deze is automatisch gecontroleerd, maar hier ging iets mis.",

  // Translations for `providerManual` (human-in-the-loop verification)
  "registrationRequest.idCheckTimeline.providerManual.ok": "ID goedgekeurd",
  "registrationRequest.idCheckTimeline.providerManual.ok.description":
    "De patiënt heeft online zijn ID gescand. Deze is handmatig gecontroleerd, en goedgekeurd.",
  "registrationRequest.idCheckTimeline.providerManual.idInvalid": "ID check mislukt — controleer handmatig",
  "registrationRequest.idCheckTimeline.providerManual.idInvalid.description":
    "De patiënt heeft online zijn ID gescand. Deze is handmatig gecontroleerd, maar hier ging iets mis.",
  "registrationRequest.idCheckTimeline.providerManual.notDone": "ID check mislukt — controleer handmatig",
  "registrationRequest.idCheckTimeline.providerManual.notDone.description":
    "De patiënt is begonnen aan de online ID check, maar heeft deze niet afgemaakt.",
  "registrationRequest.idCheckTimeline.providerManual.verificationInconsistency":
    "ID check mislukt — controleer handmatig",
  "registrationRequest.idCheckTimeline.providerManual.verificationInconsistency.description":
    "De patiënt heeft online zijn ID gescand. De controle gaf een tegenstrijdige uitkomst.",
  "registrationRequest.idCheckTimeline.providerManual.unknownError": "ID check mislukt — controleer handmatig",
  "registrationRequest.idCheckTimeline.providerManual.unknownError.description":
    "Er ging iets mis tijdens de controle van het ID.",
  "registrationRequest.idCheckTimeline.providerManual.failed": "ID check mislukt — controleer handmatig",
  "registrationRequest.idCheckTimeline.providerManual.failed.description":
    "De patiënt heeft online zijn ID gescand. Deze is handmatig gecontroleerd, maar hier ging iets mis.",

  // iDenfy rejection reason codes (shown under a rejected verdict). Codes not
  // listed here fall back to the raw provider string in the UI.
  "registrationRequest.idCheckTimeline.reason.DOC_INFO_MISMATCH": "Documentgegevens komen niet overeen",
  "registrationRequest.idCheckTimeline.reason.DOC_NOT_FOUND": "Geen document gevonden",
  "registrationRequest.idCheckTimeline.reason.DOC_NOT_FULLY_VISIBLE": "Document niet volledig zichtbaar",
  "registrationRequest.idCheckTimeline.reason.DOC_FACE_NOT_FOUND": "Geen gezicht gevonden op document",
  "registrationRequest.idCheckTimeline.reason.DOC_TOO_BLURRY": "Document te wazig",
  "registrationRequest.idCheckTimeline.reason.DOC_GLARED": "Te veel weerkaatsing op document",
  "registrationRequest.idCheckTimeline.reason.DOC_FACE_GLARED": "Te veel weerkaatsing op gezicht in document",
  "registrationRequest.idCheckTimeline.reason.MRZ_NOT_FOUND": "MRZ-code niet gevonden",
  "registrationRequest.idCheckTimeline.reason.MRZ_OCR_READING_ERROR": "MRZ-code onleesbaar",
  "registrationRequest.idCheckTimeline.reason.BARCODE_NOT_FOUND": "Barcode niet gevonden",
  "registrationRequest.idCheckTimeline.reason.DOC_EXPIRED": "Document verlopen",
  "registrationRequest.idCheckTimeline.reason.DOC_NOT_SUPPORTED": "Documenttype niet ondersteund",
  "registrationRequest.idCheckTimeline.reason.COUNTRY_NOT_SUPPORTED": "Land niet ondersteund",
  "registrationRequest.idCheckTimeline.reason.COUNTRY_MISMATCH": "Land komt niet overeen",
  "registrationRequest.idCheckTimeline.reason.DOC_TYPE_MISMATCH": "Documenttype komt niet overeen",
  "registrationRequest.idCheckTimeline.reason.DOC_SUBTYPE_MISMATCH": "Documentsubtype komt niet overeen",
  "registrationRequest.idCheckTimeline.reason.DOC_SIDE_MISMATCH": "Verkeerde zijde van document",
  "registrationRequest.idCheckTimeline.reason.DOC_DAMAGED": "Document beschadigd",
  "registrationRequest.idCheckTimeline.reason.DOC_FAKE": "Document mogelijk vervalst",
  "registrationRequest.idCheckTimeline.reason.DOC_PERSONAL_CODE_INVALID": "Persoonlijk nummer ongeldig",
  "registrationRequest.idCheckTimeline.reason.DOC_NOT_ALLOWED": "Document niet toegestaan",
  "registrationRequest.idCheckTimeline.reason.DOC_NAME_ERROR": "Fout in voornaam op document",
  "registrationRequest.idCheckTimeline.reason.DOC_SURNAME_ERROR": "Fout in achternaam op document",
  "registrationRequest.idCheckTimeline.reason.DOC_EXPIRY_ERROR": "Fout in vervaldatum op document",
  "registrationRequest.idCheckTimeline.reason.DOC_DOB_ERROR": "Fout in geboortedatum op document",
  "registrationRequest.idCheckTimeline.reason.DOC_PERSONAL_NUMBER_ERROR": "Fout in persoonlijk nummer op document",
  "registrationRequest.idCheckTimeline.reason.DOC_NUMBER_ERROR": "Fout in documentnummer",
  "registrationRequest.idCheckTimeline.reason.DOC_DATE_OF_ISSUE_ERROR": "Fout in afgiftedatum op document",
  "registrationRequest.idCheckTimeline.reason.DOC_SEX_ERROR": "Fout in geslacht op document",
  "registrationRequest.idCheckTimeline.reason.DOC_NATIONALITY_ERROR": "Fout in nationaliteit op document",
  "registrationRequest.idCheckTimeline.reason.DOC_ERROR": "Fout bij documentcontrole",
  "registrationRequest.idCheckTimeline.reason.AUTO_UNVERIFIABLE": "Automatisch niet te verifiëren",
  "registrationRequest.idCheckTimeline.reason.DOC_SPOOF_DETECTED": "Mogelijke vervalsing van document gedetecteerd",
  "registrationRequest.idCheckTimeline.reason.MRZ_INVALID": "MRZ-code ongeldig",
  "registrationRequest.idCheckTimeline.reason.NFC_INIT_FAILED": "NFC-uitlezen kon niet starten",
  "registrationRequest.idCheckTimeline.reason.NFC_FAILED": "NFC-uitlezen mislukt",
  "registrationRequest.idCheckTimeline.reason.NFC_TIMEOUT": "NFC-uitlezen verlopen",
  "registrationRequest.idCheckTimeline.reason.FACE_MISMATCH": "Gezicht komt niet overeen",
  "registrationRequest.idCheckTimeline.reason.NO_FACE_FOUND": "Geen gezicht gevonden",
  "registrationRequest.idCheckTimeline.reason.TOO_MANY_FACES": "Te veel gezichten gedetecteerd",
  "registrationRequest.idCheckTimeline.reason.FACE_TOO_BLURRY": "Gezicht te wazig",
  "registrationRequest.idCheckTimeline.reason.FACE_GLARED": "Te veel weerkaatsing op gezicht",
  "registrationRequest.idCheckTimeline.reason.FACE_UNCERTAIN": "Gezicht onzeker",
  "registrationRequest.idCheckTimeline.reason.FACE_ERROR": "Fout bij gezichtscontrole",
  "registrationRequest.idCheckTimeline.reason.FAKE_FACE": "Mogelijk nepgezicht gedetecteerd",
  "registrationRequest.idCheckTimeline.reason.FACE_SUSPECTED": "Gezicht verdacht",
  "registrationRequest.idCheckTimeline.reason.FACE_BLACKLISTED": "Gezicht op blokkeerlijst",
  "registrationRequest.idCheckTimeline.reason.DOC_FACE_BLACKLISTED": "Gezicht op document op blokkeerlijst",
  "registrationRequest.idCheckTimeline.reason.DOC_MOBILE_PHOTO": "Foto van een scherm gedetecteerd",
  "registrationRequest.idCheckTimeline.reason.DEV_TOOLS_OPENED": "Ontwikkelaarshulpmiddelen geopend",
  "registrationRequest.idCheckTimeline.reason.DOC_PRINT_SPOOFED": "Afgedrukt document gedetecteerd",
  "registrationRequest.idCheckTimeline.reason.FAKE_PHOTO": "Mogelijk nepfoto",
  "registrationRequest.idCheckTimeline.reason.AML_SUSPECTION": "AML-controle verdacht",
  "registrationRequest.idCheckTimeline.reason.AML_FAILED": "AML-controle mislukt",
  "registrationRequest.idCheckTimeline.reason.LID_SUSPECTION": "Controle verloren/gestolen document verdacht",
  "registrationRequest.idCheckTimeline.reason.LID_FAILED": "Controle verloren/gestolen document mislukt",
  "registrationRequest.idCheckTimeline.reason.SANCTIONS_SUSPECTION": "Sanctiecontrole verdacht",
  "registrationRequest.idCheckTimeline.reason.SANCTIONS_FAILED": "Sanctiecontrole mislukt",
  "registrationRequest.idCheckTimeline.reason.RC_FAILED": "Controle mislukt",

  // Translations for patient actions
  "registrationRequest.idCheckTimeline.patient.submitted": "Patiënt heeft inschrijving voltooid",
  "registrationRequest.idCheckTimeline.patient.skipped": "ID check overgeslagen — controleer handmatig",
  "registrationRequest.idCheckTimeline.patient.skipped.description": "De patiënt heeft zelf de ID check overgeslagen.",

  "registrationRequest.bsn.label": "BSN & adres check",
  "registrationRequest.bsn.ok": "BSN automatisch uit document gehaald",
  "registrationRequest.bsn.ok.tooltip": "BSN automatisch opgehaald uit het ID-document, via online ID check",
  "registrationRequest.bsn.mismatch": "BSN niet ingevuld",
  "registrationRequest.bsn.mismatch.tooltip": "BSN in het ID-document verschilt van het ingevulde BSN",
  "registrationRequest.bsn.nocheck": "BSN niet gecontroleerd: handmatig ingevuld door patiënt",
  "registrationRequest.bsn.nocheck.tooltip": "Geen automatische BSN controle: patiënt heeft BSN zelf ingevuld",

  "registrationRequest.bsnTimeline.fieldEdit": "BSN bijgewerkt",
  "registrationRequest.bsnTimeline.changedFrom": "Was: {value}",
  "registrationRequest.bsnTimeline.editedBy": "Door {actor}",
  "registrationRequest.bsnTimeline.tooltip.fieldEdit": "BSN handmatig bijgewerkt",
  "registrationRequest.bsnTimeline.tooltip.bsnCheck": "Handmatig bevestigd",
  "registrationRequest.bsnTimeline.recheck": "Opnieuw controleren",
  "registrationRequest.bsnTimeline.recheck.noCertificate": "Upload eerst een geldig UZI-certificaat in de instellingen",
  "registrationRequest.bsnTimeline.sbvz.title.match.valid": "Persoonsgegevens kloppen en document geldig",
  "registrationRequest.bsnTimeline.sbvz.title.match.invalid":
    "Persoonsgegevens kloppen, maar document niet meer geldig",
  "registrationRequest.bsnTimeline.sbvz.title.match.unchecked": "Persoonsgegevens kloppen, document niet gecontroleerd",
  "registrationRequest.bsnTimeline.sbvz.title.match.error": "Persoonsgegevens kloppen, documentcontrole mislukt",
  "registrationRequest.bsnTimeline.sbvz.title.deviating.valid": "Adres wijkt af, document geldig",
  "registrationRequest.bsnTimeline.sbvz.title.deviating.invalid": "Adres wijkt af én document niet meer geldig",
  "registrationRequest.bsnTimeline.sbvz.title.deviating.unchecked": "Adres wijkt af, document niet gecontroleerd",
  "registrationRequest.bsnTimeline.sbvz.title.deviating.error": "Adres wijkt af, documentcontrole mislukt",
  "registrationRequest.bsnTimeline.sbvz.title.notFound.valid": "BSN niet gevonden, document wel geldig",
  "registrationRequest.bsnTimeline.sbvz.title.notFound.invalid": "BSN niet gevonden én document niet meer geldig",
  "registrationRequest.bsnTimeline.sbvz.title.notFound.unchecked": "BSN niet gevonden, document niet gecontroleerd",
  "registrationRequest.bsnTimeline.sbvz.title.notFound.error": "BSN niet gevonden, documentcontrole mislukt",
  "registrationRequest.bsnTimeline.sbvz.title.confidential.valid":
    "Persoonsgegevens kloppen (adres afgeschermd), document geldig",
  "registrationRequest.bsnTimeline.sbvz.title.confidential.invalid":
    "Persoonsgegevens kloppen (adres afgeschermd), maar document niet meer geldig",
  "registrationRequest.bsnTimeline.sbvz.title.confidential.unchecked":
    "Persoonsgegevens kloppen (adres afgeschermd), document niet gecontroleerd",
  "registrationRequest.bsnTimeline.sbvz.title.confidential.error":
    "Persoonsgegevens kloppen (adres afgeschermd), documentcontrole mislukt",
  "registrationRequest.bsnTimeline.sbvz.title.underInvestigation.valid":
    "Persoonsgegevens kloppen (in onderzoek), document geldig",
  "registrationRequest.bsnTimeline.sbvz.title.underInvestigation.invalid":
    "Persoonsgegevens kloppen (in onderzoek), maar document niet meer geldig",
  "registrationRequest.bsnTimeline.sbvz.title.underInvestigation.unchecked":
    "Persoonsgegevens kloppen (in onderzoek), document niet gecontroleerd",
  "registrationRequest.bsnTimeline.sbvz.title.underInvestigation.error":
    "Persoonsgegevens kloppen (in onderzoek), documentcontrole mislukt",
  "registrationRequest.bsnTimeline.sbvz.title.suspended.valid":
    "BSN niet bruikbaar voor inschrijving, document wel geldig",
  "registrationRequest.bsnTimeline.sbvz.title.suspended.invalid":
    "BSN niet bruikbaar voor inschrijving én document niet meer geldig",
  "registrationRequest.bsnTimeline.sbvz.title.suspended.unchecked":
    "BSN niet bruikbaar voor inschrijving, document niet gecontroleerd",
  "registrationRequest.bsnTimeline.sbvz.title.suspended.error":
    "BSN niet bruikbaar voor inschrijving, documentcontrole mislukt",
  "registrationRequest.bsnTimeline.sbvz.title.error.valid": "BSN-controle mislukt, document geldig",
  "registrationRequest.bsnTimeline.sbvz.title.error.invalid": "BSN-controle mislukt, document niet meer geldig",
  "registrationRequest.bsnTimeline.sbvz.title.failed": "Controle mislukt",
  "registrationRequest.bsnTimeline.sbvz.title.unknown": "SBV-Z-controle",
  "registrationRequest.bsnTimeline.sbvz.person.match": "Persoonsgegevens kloppen",
  "registrationRequest.bsnTimeline.sbvz.person.deviating": "Adres wijkt af",
  "registrationRequest.bsnTimeline.sbvz.person.notFound": "BSN niet gevonden met deze gegevens",
  "registrationRequest.bsnTimeline.sbvz.person.confidential": "Persoonsgegevens kloppen (adres afgeschermd)",
  "registrationRequest.bsnTimeline.sbvz.person.underInvestigation": "Persoonsgegevens kloppen (in onderzoek)",
  "registrationRequest.bsnTimeline.sbvz.person.suspended": "BSN niet bruikbaar voor inschrijving",
  "registrationRequest.bsnTimeline.sbvz.person.error": "BSN-controle mislukt",
  "registrationRequest.bsnTimeline.sbvz.document.valid": "Identiteitsdocument is geldig",
  "registrationRequest.bsnTimeline.sbvz.document.invalid": "Document niet meer geldig",
  "registrationRequest.bsnTimeline.sbvz.document.unchecked": "Document niet gecontroleerd",
  "registrationRequest.bsnTimeline.sbvz.document.error": "Documentcontrole mislukt",
  "registrationRequest.bsnTimeline.sbvz.hint.deviating": "Postcode en/of huisnummer wijken af van de gemeente",
  "registrationRequest.bsnTimeline.sbvz.hint.notFound":
    "Mogelijk een tweeling op hetzelfde adres, een onjuist BSN, of niet op dit adres ingeschreven",
  "registrationRequest.bsnTimeline.sbvz.hint.personIncomplete": "Geen of onvolledige persoonsgegevens",
  "registrationRequest.bsnTimeline.sbvz.hint.confidential":
    "Deze persoon heeft een geheim adres. Postcode en huisnummer konden daarom niet worden gecontroleerd",
  "registrationRequest.bsnTimeline.sbvz.hint.underInvestigation":
    "De gemeente onderzoekt deze gegevens sinds {date}. Voorlopig bruikbaar, controleer later opnieuw",
  "registrationRequest.bsnTimeline.sbvz.hint.underInvestigation.noDate":
    "De gemeente onderzoekt deze gegevens. Voorlopig bruikbaar, controleer later opnieuw",
  "registrationRequest.bsnTimeline.sbvz.hint.suspended.deceased":
    "Volgens de overheid is deze persoon overleden. Controleer of de juiste persoon zich inschrijft en de gegevens kloppen",
  "registrationRequest.bsnTimeline.sbvz.hint.suspended.emigrated":
    "Volgens de overheid staat deze persoon als geëmigreerd geregistreerd. Vraag na of de persoon weer in Nederland woont en de gegevens kloppen",
  "registrationRequest.bsnTimeline.sbvz.hint.suspended.ministerialDecree":
    "Deze inschrijving is opgeschort door een ministerieel besluit. Neem contact op met de gemeente om te kijken wat er nodig is",
  "registrationRequest.bsnTimeline.sbvz.hint.suspended.nonResident":
    "Deze persoon staat geregistreerd als niet-ingezetene (RNI). Er is geen Nederlands woonadres bekend. Controleer of inschrijving mogelijk is",
  "registrationRequest.bsnTimeline.sbvz.hint.documentInvalid":
    "Mogelijk verlopen, ingetrokken of gestolen. Vraag een geldig identiteitsbewijs op",
  "registrationRequest.bsnTimeline.sbvz.hint.documentUnchecked": "Geen of onvolledige documentgegevens",
  "registrationRequest.bsnTimeline.sbvz.hint.technicalError": "Er ging iets mis bij SBV-Z. Probeer het later opnieuw",
  "registrationRequest.bsnTimeline.sbvz.hint.certificateRejected":
    "SBV-Z accepteerde het UZI-certificaat niet. Controleer het certificaat in de instellingen",
  "registrationRequest.bsnTimeline.sbvz.checked.address":
    "Gecontroleerd op geboortedatum {dateOfBirth}, postcode {postalCode}, huisnummer {houseNumber} en geslacht {gender}",
  "registrationRequest.bsnTimeline.sbvz.checked.lastName":
    "Gecontroleerd op naam {lastName}, geboortedatum {dateOfBirth} en geslacht {gender}",
  "registrationRequest.bsnTimeline.sbvz.checked.both":
    "Gecontroleerd op naam {lastName}, geboortedatum {dateOfBirth}, postcode {postalCode}, huisnummer {houseNumber} en geslacht {gender}",
  "registrationRequest.bsnTimeline.sbvz.document": "Document: {type} {number}",
  "registrationRequest.bsnTimeline.sbvz.documentType.passport": "paspoort",
  "registrationRequest.bsnTimeline.sbvz.documentType.idCard": "identiteitskaart",
  "registrationRequest.bsnTimeline.sbvz.documentType.driverLicense": "rijbewijs",
  "registrationRequest.bsnTimeline.sbvz.documentType.residencePermit": "vreemdelingendocument",
  "registrationRequest.bsnTimeline.sbvz.trigger.registrationCompleted": "Na voltooien inschrijving door patiënt",
  "registrationRequest.bsnTimeline.sbvz.trigger.dataChanged": "Na wijziging van gegevens door {actor}",
  "registrationRequest.bsnTimeline.sbvz.trigger.dataChanged.system": "Na wijziging van gegevens",
  "registrationRequest.bsnTimeline.sbvz.trigger.manualRecheck": "Handmatig opnieuw gecontroleerd door {actor}",
  "registrationRequest.bsnTimeline.sbvz.trigger.manualRecheck.noActor": "Handmatig opnieuw gecontroleerd",
  "registrationRequest.bsnTimeline.legend.ok": "Gecontroleerd",
  "registrationRequest.bsnTimeline.legend.attention": "Aandacht nodig",
  "registrationRequest.bsnTimeline.legend.action": "Actie nodig",
  "registrationRequest.bsnTimeline.legend.change": "Wijziging (geen controle)",

  "registrationRequest.file.view": "Bekijken",
  "registrationRequest.pdfFile.label": "PDF-bestand inschrijving downloaden",
  "registrationRequest.pdfFile.fileName": "Inschrijving {name}.pdf",

  "registrationRequest.previousGpLetter.label": "Ondertekende brief vorige huisarts",
  "registrationRequest.previousGpLetter.label.v2": "Brief voor vorige huisarts",
  "registrationRequest.previousGpLetter.letter": "Ondertekende brief.pdf",
  "registrationRequest.previousGpLetter.letter.v2": "Brief vorige huisarts.pdf",
  "registrationRequest.previousGpLetter.letterOrIon.disabled":
    "Er is geen brief gemaakt. Tijdens de inschrijving moeten daarvoor zowel ‘Inschrijving van de patiënt via ION’ als ‘Stuur namens de patiënt een brief’ aan staan.",
  "registrationRequest.previousGpLetter.featureDisabled":
    "Het versturen van een brief naar de vorige huisarts staat uit voor deze praktijk.",
  "registrationRequest.previousGpLetter.passant": "Overgeslagen (passant)",
  "registrationRequest.previousGpLetter.passant.subText":
    "Een passant blijft ingeschreven bij de eigen huisarts: er is geen opzegbrief en er is niet naar een vorige huisarts of toestemming voor dossieroverdracht gevraagd.",
  "registrationRequest.previousGpLetter.proof": "Bewijsdocument.pdf",
  "registrationRequest.previousGpLetter.generatedAfterAcceptance":
    "De brief wordt pas gestuurd als je de patiënt accepteert. Je kunt de brief downloaden om die los te sturen als nodig.",
  "registrationRequest.previousGpLetter.pending": "Wachten op resultaat...",

  "registrationRequest.noPreviousGp": "Geen vorige huisarts",
  "registrationRequest.notYet": "Nog niet gebeurd",
  "registrationRequest.failed": "Niet gelukt",
  "registrationRequest.lspApproval.label": "Toestemming LSP",
  "registrationRequest.lspApproval.yes": "Ja",
  "registrationRequest.lspApproval.no": "Geen toestemming van patiënt",
  "registrationRequest.lspApproval.notAsked": "Niet gevraagd (praktijk gebruikt Mitz)",
  "registrationRequest.guardianConsent.label": "Toestemming gezaghebbenden",
  "registrationRequest.guardianConsent.yes": "Bevestigd door degene die inschreef",
  "registrationRequest.guardianConsent.no": "Niet aangevinkt",
  "registrationRequest.childConsent.label": "Kind stemt in met inschrijving",
  "registrationRequest.childConsent.yes": "Bevestigd door degene die inschreef",
  "registrationRequest.childConsent.no": "Niet aangevinkt",
  "registrationRequest.mijnGezondheidNetApproval": "MGN-toestemming",
  "registrationRequest.autoMedic.label": "Verstuurd naar AutoMedic (RPA)",
  "registrationRequest.autoMedic.notYet": "Nog niet verzonden naar AutoMedic",
  "registrationRequest.autoMedic.created": "Nog niet uitgevoerd in AutoMedic",
  "registrationRequest.autoMedic.failed": "Fout",
  "registrationRequest.autoMedic.sendFailed": "Verzenden naar AutoMedic is mislukt",
  "registrationRequest.autoMedic.success": "Uitgevoerd in AutoMedic",
  "registrationRequest.autoMedic.failed.title": "Fout bij uitvoeren in AutoMedic (RPA)",
  "registrationRequest.autoMedic.failed.info1": "Foutmelding: {errorMessage}",
  "registrationRequest.autoMedic.failed.info2": "Klik in AutoMedic op de knop 'Uitvoeren' om het nogmaals te proberen.",
  "registrationRequest.autoMedic.created.title":
    "Data staat in de verzendlijst van Automedic (RPA), maar is nog niet uitgevoerd",
  "registrationRequest.autoMedic.created.info": "Om de data in het HIS te zetten, klik je in AutoMedic op 'Uitvoeren'.",
  "registrationRequest.customQuestions.title": "Aangepaste vragen",
  "registrationRequest.customQuestions.noAnswer": "Geen antwoord ingevuld",
  "registrationRequest.update.success": "De patiëntgegevens zijn succesvol bijgewerkt",
  "registrationRequest.sentToHisStatus.notSent": "Nog niet verstuurd",
  "registrationRequest.sentToHisStatus.sent": "Verstuurd",
  "registrationRequest.sentToHisStatus.processed": "Verstuurd & aangekomen",
  "registrationRequest.sentToHisStatus.error": "Fout",

  // RPA (AutoMedic) practices get their own vocabulary: for them the status
  // tracks the robot's queue and run, not a HIS API call.
  "registrationRequest.rpaSentToHisStatus.notSent": "Nog niet verstuurd",
  "registrationRequest.rpaSentToHisStatus.sent": "In RPA-verzendlijst",
  "registrationRequest.rpaSentToHisStatus.processed": "Door RPA in HIS gezet",
  "registrationRequest.rpaSentToHisStatus.error": "Fout",

  "about.title": "Over MijnPraktijk.nl",
  "about.text":
    '<p>MijnPraktijk.nl is onderdeel van Buurtdokters. Op <a href="https://www.buurtdokters.net/contact">https://www.buurtdokters.net/contact</a> vindt u onze contactgegevens.</p><h3>Klachten</h3><p>Als u klachten heeft over het MijnPraktijk portaal of Buurtdokters dan kunt u contact met ons opnemen via de help knop of door een e-mail te sturen naar support@mijnpraktijk.nl</p><p>Wat wij beloven:</p><ul><li>Wij reageren binnen 3 werkdagen op uw bericht.</li><li>Wij behandelen uw klacht vertrouwelijk en zullen uw persoonlijke gegevens niet zonder uw toestemming met derden delen tenzij dat noodzakelijk is om een wettelijke verplichting na te komen.</li><li>Wij houden u op de hoogte van de voortgang van het behandelen van uw klacht.</li></ul><p>Wij nemen alleen klachten in behandeling die gaan over het MijnPraktijk portaal of Buurtdokters. Heeft u klachten over uw huisarts of huisartsen praktijk, neem dan contact op met huisarts of de Stichting Klachten en Geschillen Eerstelijnszorg (SKGE) via <a href="https://www.skge.nl">https://www.skge.nl</a></p><h3>Coordinated Vulnerability Disclosure (CVD)</h3><p>Wij vinden de veiligheid van onze systemen erg belangrijk. Ondanks onze zorg voor de beveiliging van onze systemen kan het voorkomen dat er toch een zwakke plek is.</p><p>Als u een zwakke plek in één van onze systemen heeft gevonden horen wij dit graag zodat we zo snel mogelijk maatregelen kunnen treffen. Wij willen graag met u samenwerken om onze klanten en onze systemen beter te kunnen beschermen.</p><p>Wij vragen u:</p><ul><li>Uw bevindingen te mailen naar security@mijnpraktijk.nl. Bij voorkeur kunt u uw bevindingen versleutelen met onze <a href="https://portal.mijnpraktijk.nl/files/pgp-security-mijnpraktijk.asc">PGP key</a> om te voorkomen dat de informatie in verkeerde handen valt;</li><li>Het probleem niet te misbruiken door bijvoorbeeld meer data te downloaden dan nodig is om het lek aan te tonen of gegevens van gebruikers in te kijken, verwijderen of aanpassen;</li><li>Het probleem niet met anderen te delen totdat het is opgelost en alle vertrouwelijke gegevens die zijn verkregen via het lek direct na het dichten van het lek te wissen;</li><li>Geen gebruik te maken van aanvallen op fysieke beveiliging, social engineering, distributed denial of service, spam of applicaties van derden; en</li><li>Voldoende informatie te geven om het probleem te reproduceren zodat wij het zo snel mogelijk kunnen oplossen. Meestal is het IP-adres of de URL van het getroffen systeem en een omschrijving van de kwetsbaarheid voldoende, maar bij complexere kwetsbaarheden kan meer nodig zijn.</li></ul><p>Wat wij beloven:</p><ul><li>Wij reageren binnen 3 dagen op uw melding met onze beoordeling van de melding en een verwachte datum voor een oplossing;</li><li>Als u zich aan bovenstaande voorwaarden heeft gehouden zullen wij geen juridische stappen tegen u ondernemen betreffende de melding;</li><li>Wij behandelen uw melding vertrouwelijk en zullen uw persoonlijke gegevens niet zonder uw toestemming met derden delen tenzij dat noodzakelijk is om een wettelijke verplichting na te komen. Melden onder een pseudoniem is mogelijk;</li><li>Wij houden u op de hoogte van de voortgang van het oplossen van het probleem;</li><li>In berichtgeving over het gemelde probleem zullen wij, indien u dit wenst, uw naam vermelden als de ontdekker; en</li><li>Als dank voor uw hulp bieden wij een beloning aan voor elke melding van een ons nog onbekend beveiligingsprobleem. De grootte van de beloning bepalen wij aan de hand van de ernst van het lek en de kwaliteit van de melding met een minimum van een waardebon van &euro;50.</li></ul><p>Wij streven er naar om alle problemen zo snel mogelijk op te lossen en wij worden graag betrokken bij een eventuele publicatie over het probleem nadat het is opgelost.</p><h3>Subverwerkers</h3><table class="sub-processors"><thead><tr><th>Soort Persoonsgegevens</th><th>Doeleinden van de verwerking</th><th>Subverwerkers</th></tr></thead><tbody><tr><td>Gegevens van gebruikers van MijnPraktijk. Ook welke gebruikershandelingen zijn uitgevoerd (inzien dossier e.d.)</td><td>Identificatie en authenticatie van gebruikers van MijnPraktijk<br><br>Logging van handelingen</td><td>AWS (Duitsland / EU)</td></tr><tr><td>Gegevens van patiënten, waaronder data over gezondheid</td><td>Medische dossiervorming</td><td>AWS (Duitsland / EU)</td></tr><tr><td>Identiteit</td><td>Verificatie van de identiteit van de patiënt bij inschrijving</td><td>iDenfy (Amazon AWS Europe (Dublin, Ireland))</td></tr><tr><td>O.a. SOEP-regels, patiënt- en gebruikersidentificatie en andere digitale post</td><td>Communicatie tussen MijnPraktijk en HIS</td><td>Enovation (NL)</td></tr><tr><td>Gegevens van gebruikers van MijnPraktijk<br><br>Wijzigingsverzoeken en gemelde incidenten of helpdesk vragen kunnen persoonsgegevens bevatten van gebruikers en/of patiënten</td><td>Leveren van support aan gebruikers</td><td>Atlassian (EU)<br><br>Office 365 / Outlook (EU)</td></tr><tr><td>NAW-gegevens patiënt en inhoud van brief</td><td>Versturen van brieven naar patiënten</td><td>Postbode.nu (EU)</td></tr><tr><td>Contactgegevens van personen die zich inschrijven op een digitale nieuwsbrief en/of op zogenaamde \'statusupdates\'</td><td>Nieuwsbrieven e-mail<br><br>Updates geven aan gebruikers in geval er storing is van (onderdelen van) MijnPraktijk</td><td>Mailchimp (USA)</td></tr><tr><td>Gebruikershandelingen in het portaal</td><td>Verbeteren van de kwaliteit en functionaliteit van MijnPraktijk</td><td>AWS (Duitsland / EU)</td></tr></tbody></table><h3>Certificering</h3><p>Onze organisatie is ISO 27001 en NEN 7510 gecertificeerd. Druk op de afbeelding voor het certificaat.</p><p class="certificationWrapper"><a href="/certification/iso27001.pdf"><img alt="ISO 27001" class="certificationImage" src="/certification/iso27001.png"></a><a href="/certification/nen7510.pdf"><img alt="NEN 7510" class="certificationImage" src="/certification/nen7510.png"></a></p>',

  "hisUnknown.title": "Patiënt onbekend in HIS",
  "hisUnknown.description":
    "Deze patiënt is onbekend in het HIS. Bij goedkeuring krijgt de patiënt een e-mail waarin staat dat het vanaf nu mogelijk is om de website te gebruiken. Omdat de patiënt onbekend is in het HIS, zal dat niet werken.",
  "hisUnknown.areYouSure": "Weet je zeker dat je deze patiënt wilt goedkeuren?",
  "hisUnknown.confirm": "Goedkeuren",

  "public.steps.welcome": "Welkom",
  "public.steps.welcome.placeholder": "Welkom. Druk op volgende om te beginnen.",
  "public.steps.general": "Algemene informatie",
  "public.steps.personal": "Persoonlijke informatie",
  "public.steps.previousGpLetter": "Vorige huisarts",
  "public.steps.dateAndTime": "Datum en tijd",
  "public.steps.type": "Type",
  "public.steps.econsult": "Bericht sturen",
  "public.steps.appointments": "Afspraak maken",
  "public.steps.appointmentList": "Afspraken overzicht",
  "public.steps.medication": "Herhaalmedicatie",
  "public.steps.treatmentAreas": "Intro",
  "public.steps.questionnaire": "Vragen",
  "public.steps.questionnaire.withCount": "Nog maximaal {remaining}",
  "public.steps.advice": "Afspraak type bepalen",
  "public.steps.myMedicalFile": "Medisch dossier",
  "public.steps.done": "Klaar",

  "public.registration.preparation": "Voordat we beginnen...",
  "public.registration.preparation.tip1": "Houd uw identiteitsbewijs bij de hand",
  "public.registration.preparation.tip1.example": "Bijvoorbeeld uw paspoort of rijbewijs",
  "public.registration.preparation.tip2": "De inschrijving duurt ongeveer 10 minuten",

  "public.registration.start": "Welkom",
  "public.registration.start.language": "Taalvoorkeur",
  "public.registration.start.language.info":
    "In welke taal wilt u met ons communiceren? Deze instelling geldt voor dit formulier en voor mails die we u sturen.",
  "public.registration.start.birthDate": "Wanneer bent u geboren?",
  "public.registration.start.address": "Woont u in ons postcodegebied?",
  "public.registration.start.address.passant":
    "Heeft u geen Nederlands adres? Vul dan postcode {postalCode} en huisnummer {houseNumber} in. Bij straat en plaats vult u uw adres in het buitenland in.",
  "public.registration.start.invalid.age.title": "Online inschrijven kan vanaf {age} jaar",
  "public.registration.start.invalid.age.description":
    "Bent u jonger dan {age} jaar? Dan vragen we u om zich te identificeren aan de balie, samen met een ouder.",
  "public.registration.start.idCheckAge.title": "De Online ID-check werkt soms niet voor jonge kinderen",
  "public.registration.start.idCheckAge.description": `Voor kinderen jonger dan 5 jaar werkt de online ID-check soms niet, omdat hun gezicht nog snel verandert.

    Als het online identificeren na een aantal keren niet lukt, kunt u de inschrijving wel gewoon afronden.

    { contactLink } om af te spreken hoe u de identificatie alsnog kunt regelen.`,
  "public.registration.start.idCheckAge.contactLink": "Neem dan contact op met de praktijk",
  "public.registration.start.invalid.postalCode.title":
    "Postcode {postalCode} valt buiten het gebied waar wij huisarts zijn",
  "public.registration.start.invalid.postalCode.title.unknown":
    "Uw postcode valt buiten het gebied waar wij huisarts zijn",
  "public.registration.start.invalid.postalCode.homeVisits":
    "Als u te ziek bent om naar de praktijk te komen, wil de huisarts bij u thuis kunnen komen. Daarom schrijven we alleen mensen in die dicht bij de praktijk wonen.",
  "public.registration.start.invalid.postalCode.findGp":
    "Een huisarts bij u in de buurt vindt u op nederland.iedereenhuisarts.nl. Daar ziet u welke praktijken nog nieuwe patiënten aannemen.",
  "public.registration.start.invalid.postalCode.search": "Zoek een huisarts in uw buurt",
  "public.registration.start.invalid.postalCode.contact":
    "Verhuist u binnenkort naar onze buurt, of staat uw gezin al bij ons ingeschreven? {contactLink}. Dan kijken we samen wat er kan.",
  "public.registration.start.invalid.postalCode.contactLink": "Neem dan contact op met de praktijk",

  "public.registration.email": "E-mail bevestigen",
  "public.registration.email.description":
    "Als u eenmaal patiënt bij ons bent gebruiken we uw email adres voor bijvoorbeeld afspraakbevestigingen en inloggen.",
  "public.registration.email.info": "We sturen een e-mail om het e-mailadres te verifiëren.",
  "public.registration.email.verified":
    "Er is een e-mail gestuurd naar {email} om het e-mailadres te verifiëren.\nDruk op de link in deze e-mail om door te gaan met de inschrijving.",

  "public.registration.emailExpired": "Deze link werkt niet",
  "public.registration.emailExpired.alert": "Deze inschrijflink is niet meer actief of wordt niet herkend.",
  "public.registration.emailExpired.description":
    "Dit kan gebeuren als de link is verlopen (links zijn 24 uur geldig) of niet goed is overgenomen. Start een nieuwe inschrijving om een nieuwe link te ontvangen.",
  "public.registration.emailExpired.tryAgain": "Opnieuw inschrijven",

  "public.registration.emailPending": "Maak eerst uw andere inschrijving af",
  "public.registration.emailPending.alert": "Er is al een inschrijving gestart met dit e-mailadres.",
  "public.registration.emailPending.description":
    "Gebruik eerst de link die u per e-mail heeft ontvangen om uw inschrijving af te ronden. Daarna kunt u eventueel een nieuwe inschrijving starten met hetzelfde e-mailadres.",
  "public.registration.emailPending.resend": "E-mail opnieuw sturen",
  "public.registration.emailPending.startOver": "Terug naar start",

  "public.registration.step.existingPatient": "Al ingeschreven",
  "public.registration.step.existingPatient.alert": "U staat al ingeschreven bij deze praktijk",
  "public.registration.step.existingPatient.description":
    "Uw gegevens zijn al bekend in ons systeem. Heeft u al een account? Log dan in via MijnPraktijk.\nHeeft u hulp nodig? Neem contact op met de praktijk.",
  "public.registration.step.existingPatient.back": "Terug naar praktijkoverzicht",

  "public.registration.idCheck": "Identificatie",
  "public.registration.idCheck.preparation.why1":
    "Wij moeten uw identiteit controleren van de wet. Dit kan nu hier online, door uw identiteitsbewijs te scannen",
  "public.registration.idCheck.preparation.why1.example":
    "Een identiteitsbewijs is bijvoorbeeld uw paspoort of rijbewijs.",
  "public.registration.idCheck.preparation.why2": "U hoeft dan minder gegevens in te vullen",
  "public.registration.idCheck.preparation.why2.example":
    "Door uw identiteitsbewijs te scannen kunnen we gegevens automatisch uitlezen. Dan hoeft u die niet handmatig in te vullen.",
  "public.registration.idCheck.preparation.personalData": "Wat doen wij met uw identiteitsgegevens?",
  "public.registration.idCheck.preparation.privacy": "Als u verder gaat, gaat u akkoord met de {link}. ",
  "public.registration.idCheck.preparation.privacy.link": "privacy voorwaarden van onze leverancier iDenfy",
  "public.registration.idCheck.preparation.more":
    "Lees meer over waarom wij uw identiteit controleren op de website van de {link}.",
  "public.registration.idCheck.preparation.more.link": "Rijksoverheid",
  "public.registration.idCheck.preparation.skip": "Controle identiteit overslaan",
  "public.registration.idCheck.preparation.continue": "Verder",

  "public.registration.idCheck.awaitingManualReview":
    "Uw identiteitsbewijs wordt handmatig geverifieerd. Dit kan enkele minuten duren.",
  "public.registration.idCheck.maxRetriesReached": "De verificatie duurt langer dan verwacht.",
  "public.registration.idCheck.refreshToContinue": "Ververs de pagina om door te gaan.",

  "public.registration.idCheck.startFailed.alert": "Het starten van de identiteitscontrole is niet gelukt.",
  "public.registration.idCheck.startFailed.description":
    "Dit is waarschijnlijk een tijdelijk probleem. Probeer het opnieuw.",
  "public.registration.idCheck.startFailed.retry": "Opnieuw proberen",

  "public.registration.submitFailed.alert": "Het versturen van uw gegevens is niet gelukt.",
  "public.registration.submitFailed.description":
    "Dit is waarschijnlijk een tijdelijk verbindingsprobleem. Probeer het opnieuw.",
  "public.registration.submitFailed.retry": "Opnieuw proberen",

  "public.registration.personalInfo": "Persoonlijke informatie",
  "public.registration.personalInfo.bsn.optional": "Geen Nederlands BSN? Laat dit veld dan leeg.",
  "public.registration.personalInfo.readonlyFromIdCheck":
    "Deze gegevens zijn afkomstig van de identiteitscontrole. Ze worden handmatig gecontroleerd, dus u hoeft alleen contact op te nemen met de praktijk als uw naam duidelijk onjuist is",
  "public.registration.insurance": "Verzekering & Apotheek",
  "public.registration.insurance.found":
    "Onderstaande zorgverzekering en polisnummer hebben we automatisch gevonden. Klopt dit niet? Neem dan zelf contact op met uw zorgverzekering.",
  "public.registration.insurance.notFound":
    "Uw zorgverzekering kon niet automatisch worden gevonden. Ofwel u bent niet verzekerd in Nederland, of er gaat iets mis. Indien het laatste, controleer dan zelf bij uw zorgverzekering waar het mis gaat.",

  "public.registration.pharmacy": "Naar welke apotheek mag de huisarts uw recepten sturen?",
  "public.registration.pharmacy.instructions":
    "U mag zelf een apotheek kiezen. Als in het veld hieronder een aantal apotheken staan, dan zijn dat de apotheken waarmee uw huisartsenpraktijk samenwerkt.",
  "public.registration.pharmacy.description":
    "De eerste keer dat u medicijnen ophaalt, vraagt de apotheek misschien om uw identificatie. Kijk op {link} om te zien welke apotheken dicht bij u zijn.",
  "public.registration.pharmacy.custom": "Andere apotheek",
  "public.registration.pharmacy.custom.label": "Naam andere apotheek",

  "public.registration.previousGP": "Vorige huisarts",
  "public.registration.custom": "Extra vragen",
  "public.registration.permissions": "Als laatste",
  "public.registration.permissions.title": "Als laatste...",

  "public.registration.permissions.checkbox.1.title":
    "Ik wil een MijnGezondheid.net account voor contact met de huisarts",
  "public.registration.permissions.checkbox.1.href": "https://home.mijngezondheid.net/nl/terms-and-conditions",
  "public.registration.permissions.checkbox.1.description": "Zie de {link} voor meer informatie.", // The {link} refers to the 'href' above
  "public.registration.permissions.checkbox.1.description.link": "voorwaarden van MijnGezondheid.net",
  "public.registration.permissions.checkbox.2.title": "Ik heb dit formulier naar waarheid ingevuld",
  "public.registration.permissions.guardianConsent":
    "Iedereen met ouderlijk gezag of voogdij geeft toestemming voor de inschrijving van dit kind",
  "public.registration.permissions.guardianConsent.info":
    "Voor een kind tot 16 jaar moet iedereen met ouderlijk gezag of voogdij toestemming geven voor de inschrijving bij een nieuwe huisarts",
  "public.registration.permissions.childConsent": "Het kind zelf geeft toestemming voor deze inschrijving",
  "public.registration.permissions.childConsent.info":
    "Vanaf 12 jaar mag een kind zelf meebeslissen met een inschrijving bij een nieuwe huisarts",

  "public.registration.end": "Toestemmingen",
  "public.registration.end.title": "Gelukt! We hebben uw verzoek tot inschrijving ontvangen.",
  "public.registration.end.description":
    "U ontvangt een e-mail wanneer uw inschrijving is afgerond. Dit kan enkele dagen tot enkele weken duren.",
  "public.registration.end.callPractice": "Heeft u al eerder zorg nodig? Bel dan naar de praktijk: {phoneNumber}",
  "public.registration.end.goToPractice": "Naar de website van de praktijk",
  "public.registration.end.failed.alert": "Er is iets misgegaan bij het verwerken van uw inschrijving.",
  "public.registration.end.failed.description":
    "Uw gegevens zijn niet verloren gegaan. Probeer het opnieuw. Als het probleem aanhoudt, neem dan contact op met de praktijk.",
  "public.registration.end.failed.retry": "Opnieuw proberen",

  "public.registration.sessionTimeout.warning.title": "Uw sessie verloopt binnenkort",
  "public.registration.sessionTimeout.warning.description":
    "Uw sessie verloopt over {minutes} {minutes, plural, one {minuut} other {minuten}} om uw gegevens te beschermen. Ga door met uw inschrijving om de sessie te verlengen.",
  "public.registration.sessionTimeout.continue": "Doorgaan met inschrijven",
  "public.registration.sessionTimeout.timeRemaining": "Resterende tijd",

  "public.prep.approvalStep.title": "Toestemming voor de vragenlijst",
  "public.prep.approvalStep.description":
    "Om om uw klachten beter te kunnen beoordelen, zouden we een aantal vragen willen stellen. Hiervoor hebben we uw toestemming nodig. Toestemming is niet verplicht.",
  "public.prep.approvalStep.approved": "Ik ga akkoord met bovenstaande voorwaarden",

  "public.prep.questionnaire.required": "Deze vraag is verplicht en moet ingevuld worden.",

  "public.prep.completeStep.title": "Einde vragenlijst",
  "public.prep.completeStep.description.econsultDigitalPossibleOrWalkInConsult":
    "Gezien de klachten is het mogelijk om een bericht naar de huisarts te sturen. Het is ook mogelijk om direct geholpen te worden in het digitale inloopspreekuur.",
  "public.prep.completeStep.description.econsultDigitalPossible":
    "Gezien de klachten is het mogelijk om een bericht naar de huisarts te sturen.",
  "public.prep.completeStep.description.appointmentDigitalPossibleConsiderEconsultOrWalkInConsult":
    "U kunt kiezen voor het maken van een afspraak, maar het is ook mogelijk om een bericht te sturen naar de praktijk of direct geholpen worden in het digitale inloopspreekuur.",
  "public.prep.completeStep.description.appointmentDigitalPossibleConsiderEconsult":
    "U kunt kiezen voor het maken van een afspraak, maar het is ook mogelijk om een bericht te sturen naar de praktijk.",
  "public.prep.completeStep.description.econsultDigitalNotPossible":
    "Gezien de klachten is het alleen mogelijk om een consult op de praktijk te plannen.",
  "public.prep.completeStep.description.econsultDigitalNotRecommendedNorWalkInConsult":
    "Gezien de klachten wordt geadviseerd om een afspraak te maken of gebruik te maken van het digitale inloopspreekuur.",
  "public.prep.completeStep.description.econsultDigitalNotRecommended":
    "Gezien de klachten wordt geadviseerd om een afspraak te maken.",
  "public.prep.completeStep.description.appointmentDigitalNotPossible":
    "U kunt nu verder gaan met het maken van een afspraak. Gezien de klachten is het alleen mogelijk om een consult op de praktijk te plannen.",
  "public.prep.completeStep.description.appointmentDigitalNotRecommendedNorWalkInConsult":
    "U kunt nu verder gaan met het maken van een afspraak. Gezien de klachten wordt geadviseerd om geen bericht te sturen. Gebruik maken van het digitale inloopspreekuur kan wel.",
  "public.prep.completeStep.description.appointmentDigitalNotRecommended":
    "U kunt nu verder gaan met het maken van een afspraak. Gezien de klachten wordt geadviseerd om geen bericht te sturen.",
  "public.prep.completeStep.econsultOption.title": "Bericht",
  "public.prep.completeStep.econsultOption.description":
    "Stuur een bericht naar de praktijk. Meestal binnen 1 werkdag een reactie.",
  "public.prep.completeStep.appointmentOption.title": "Afspraak",
  "public.prep.completeStep.appointmentOption.description":
    "Maak een afspraak op de praktijk, of een video/telefonisch consult.",
  "public.prep.completeStep.walkInConsultOption.title": "Digitaal inloopspreekuur",
  "public.prep.completeStep.walkInConsultOption.description":
    "Digitaal inloopspreekuur, word direct geholpen. {queueLength, plural, =0 {Er zijn geen wachtenden} one {Er is één patiënt} other {Er zijn # patiënten}} voor u.",

  "public.prep.httpErrorRedirect":
    "Er is een probleem met de voorbereiding vragenlijst. Je wordt nu doorverwezen naar een alternatieve mogelijkheid.",

  "public.appointment.main.header": "Afspraak maken",
  "public.appointment.noSlots.callPractice":
    "Er zijn helaas geen tijdstippen beschikbaar waarop u via de website een afspraak kunt maken. Bel de praktijk via {phoneNumber} om een afspraak te maken.",
  "public.appointment.noSlots.contactPractice":
    "Er zijn helaas geen tijdstippen beschikbaar waarop u via de website een afspraak kunt maken. <contactLink>Neem contact op</contactLink> met de praktijk om een afspraak te maken.",
  "public.appointment.showMore": "+ {count, plural, one {# meer} other {# meer}}",
  "public.appointment.week.thisWeek": "Deze week",
  "public.appointment.week.future": "Vanaf volgende week",
  "public.appointment.thisWeek.empty": "Deze week is er helaas geen plek meer.",
  "public.appointment.thisWeek.urgent": "Is het dringend? <contactLink>Neem contact op</contactLink> met de praktijk.",
  "public.appointment.filter.caregiver.all": "Alle zorgverleners",
  "public.appointment.filter.caregiver.other":
    "{count, plural, =0 {Geen zorgverleners} one {Eén zorgverlener} other {# zorgverleners}}",
  "public.appointment.filter.appointmentTypes.all": "Alle afspraaktypes",
  "public.appointment.filter.appointmentTypes.other":
    "{count, plural, =0 {Geen afspraaktypes} one {Eén afspraaktype} other {# afspraaktypes}}",
  "public.appointment.filter.days.all": "Alle dagen",
  "public.appointment.filter.days.other": "{count, plural, =0 {Geen dagen} one {Eén dag} other {# dagen}}",
  "public.appointment.success": "Afspraak bevestigd",
  "public.appointment.success.agenda": "U heeft een afspraak met",
  "public.appointment.success.type": "Afspraaktype",
  "public.appointment.success.time": "Wanneer",

  "public.appointment.urgency.warning.FOLLOW_UP_SAME_DAY": "Kunt u vandaag geen afspraak maken?",
  "public.appointment.urgency.warning.FOLLOW_UP_WITHIN_24H": "Kunt u niet binnen 24 uur een afspraak maken?",
  "public.appointment.urgency.warning.FOLLOW_UP_WITHIN_3D": "Kunt u niet binnen 3 dagen een afspraak maken?",
  "public.appointment.urgency.warning.FOLLOW_UP_WITHIN_5D": "Kunt u niet binnen 5 dagen een afspraak maken?",
  "public.appointment.urgency.warning.FOLLOW_UP_WITHIN_2W": "Kunt u niet binnen 2 weken een afspraak maken?",
  "public.appointment.urgency.warning.callPractice":
    "Bel dan de praktijk {phoneNumber}. Denkt u dat het kan wachten? Maak hieronder uw afspraak.",
  "public.appointment.urgency.warning.contactPractice":
    "<contactLink>Neem dan contact op</contactLink> met de praktijk. Denkt u dat het kan wachten? Maak hieronder uw afspraak.",

  "public.appointmentList.main.header": "Gemaakte afspraken",
  "public.appointmentList.noAppointments":
    "Er zijn geen afspraken om weer te geven. Het kan zijn dat sommige afspraken niet kunnen worden getoond.",
  "public.appointmentList.possibleMissingAppointments":
    "Deze lijst is mogelijk niet volledig; sommige afspraken kunnen verborgen zijn.",
  "public.appointmentList.agenda": "Met {agenda}",
  "public.appointmentList.cancel": "Afspraak annuleren",
  "public.appointmentList.cancel.title": "Wil je je afspraak annuleren?",
  "public.appointmentList.cancel.info": "Weet je zeker dat je de afspraak op {date} om {time} wilt annuleren?",
  "public.appointmentList.add": "Afspraak",
  "public.appointmentList.period": "{from} tot {to}",
  "public.appointmentList.calendar.add": "Toevoegen aan agenda",
  "public.appointmentList.calendar.event.title": "Afspraak bij {practiceName}",
  "public.appointmentList.calendar.event.with": "Afspraak met {agenda}",
  "public.appointmentList.calendar.event.description": "Afspraak met {agenda} bij {practiceName}",
  "public.appointmentList.calendar.other": "Andere",

  "public.login.token.header": "Bevestig dat u het bent",
  "public.login.token.requestDescription":
    "Klik op de knop om een verificatiecode per SMS te ontvangen op uw telefoon.",
  "public.login.token.requestButton": "Stuur de code",
  "public.login.token.smsVerification":
    "Er is een code per SMS gestuurd naar uw telefoon {maskedPhoneNumber}. Vul hieronder deze code in.",
  "public.login.token.retry.header": "Geen SMS ontvangen?",
  "public.login.token.retry": "We kunnen u ook bellen met de code:",
  "public.login.token.incorrect": "Neem contact op met de praktijk als het telefoonnummer onjuist is.",
  "public.login.token.error.invalid": "De ingevoerde code klopt niet. Probeer het opnieuw.",
  "public.login.token.error.expired": "De code is verlopen. Vraag een nieuwe code aan.",
  "public.login.token.error.maxAttempts": "Te veel pogingen. Vraag een nieuwe code aan.",
  "public.login.token.error.generic": "Er ging iets mis bij het verifiëren van de code. Probeer het opnieuw.",
  "public.login.token.error.noPhoneNumber": "Er is geen telefoonnummer van u bekend. Neem contact op met uw praktijk.",
  "public.login.callVerification.nonDutchNumber":
    "Uw telefoonnummer valt buiten Nederland, dus u ontvangt mogelijk onze SMS niet. Probeer in plaats daarvan het telefoongesprek.",
  "public.login.callVerification.successful": "We hebben u gebeld met de code.",

  "public.econsult": "Online gesprek met de dokter",
  "public.econsult.desc":
    "<ul><li>Stuur veilig uw bericht en eventuele foto's of bestanden naar de dokter</li><li>De antwoorden die u heeft gegeven worden ook naar de dokter gestuurd</li><li>U ontvangt een e-mail wanneer de dokter heeft geantwoord, meestal binnen 3 dagen</li></ul>",
  "public.econsult.submit.subject": "Voer een onderwerp in voor uw bericht",
  "public.econsult.submit.files": "Upload eventuele foto's of bestanden voor de dokter",
  "public.econsult.submit.success": "We hebben uw bericht ontvangen",
  "public.econsult.submit.success.desc":
    "Uw symptomen en eventuele andere informatie die u heeft doorgegeven is naar de dokter gestuurd. U ontvangt een e-mail wanneer de dokter heeft geantwoord, meestal binnen 3 dagen.",
  "public.econsult.video.ended": "De videobijeenkomst is beëindigd. Als dit een fout was, {link}.",
  "public.econsult.video.ended.link": "klik dan hier om te herstarten",
  "public.econsult.video.practiceNotAvailable":
    "Er is nog niemand van de huisartsenpraktijk aanwezig, maar dat zal vast niet lang meer duren. Even geduld a.u.b.",
  "public.econsult.simple.practiceNotAvailable":
    "U kunt hier tekstberichten uitwisselen. Als de arts (of assistent) tegelijkertijd online is, kan die een videoverbinding starten.",
  "public.econsult.send": "We hebben je bericht ontvangen. Zodra er een reactie is, ontvang je een e-mail.",
  "public.econsult.send.phoneConsult":
    "We hebben uw bericht ontvangen. De assistent bekijkt het zo snel mogelijk. Zodra er een reactie is, sturen we u een sms.",
  "public.econsult.attach.prominent": "Foto of bestand toevoegen",
  "public.econsult.queue.index":
    "{queueIndex, plural, =0 {Uw consult kan elk moment beginnen.} one {U bent de eerstvolgende. Op dit moment is nog maar één ander consult bezig, waarna uw consult start.} other {Er zijn # patiënten voor u. Dit duurt ongeveer {waitingMinutes} minuten.}} U kunt alvast aanvullende informatie over uw vraag of klacht als bericht sturen. Dit helpt om het consult beter te laten verlopen.",
  "public.econsult.queue.sms": "We zullen een SMS sturen als het consult elk moment kan beginnen.",
  "public.econsult.messages": "E-consult berichten",
  "public.econsult.phoneConsult.title": "Details telefonisch consult",
  "public.econsult.messages.closed": "Dit e-consult is gesloten, er kan niet meer op worden gereageerd",
  "public.econsult.messages.placeholder": "Schrijf hier je bericht",

  "public.walkInConsult.continue": "U kunt nu doorgaan naar het {link}.",
  "public.walkInConsult.link": "digitaal inloopspreekuur",

  "public.medication.main.header": "Aanvragen herhaalrecept",
  "public.medication.prescribed.noMedication":
    "Er is geen chronische medicatie voor u bekend. Het is alleen mogelijk chronische medicatie te herhalen die op dit moment heeft. Neem contact op met de praktijk indien dit niet correct is.",
  "public.medication.prescribed.headsup":
    "Hieronder ziet u chronische medicatie waarvan bij ons bekend is dat die herhaald kan worden. Neem contact op met de praktijk indien dit niet volledig is.",
  "public.medication.prescribed.drug": "Naam medicijn",
  "public.medication.prescribed.strength": "Sterkte",
  "public.medication.prescribed.dosage": "Dosering",
  "public.medication.prescribed.amount": "Aantal",
  "public.medication.prescribed.comment": "Opmerkingen",
  "public.medication.prescribed.noSelectionMade": "Selecteer eerst welke medicatie u wilt herhalen",
  "public.medication.selfDefined.headsup":
    "Let op! U kunt alleen chronische medicatie aanvragen die u al eerder heeft gehad.",
  "public.medication.selfDefined.addMore": "Meer medicatie",
  "public.medication.selfDefined.add": "Toevoegen",
  "public.medication.selfDefined.addCancel": "Annuleren",
  "public.medication.selfDefined.validation.drug": "Medicijn is verplicht",
  "public.medication.selfDefined.validation.strength": "Sterkte is verplicht",
  "public.medication.selfDefined.validation.dosage": "Dosering is verplicht",
  "public.medication.selfDefined.validation.amount": "Aantal is verplicht",
  "public.medication.selfDefined.placeholder.strength": "bijv. 5mg",
  "public.medication.selfDefined.placeholder.dosage": "bijv. 2 per dag",
  "public.medication.selfDefined.placeholder.amount": "bijv. 30 tabletten",
  "public.medication.success": "De aanvraag is ontvangen",
  "public.medication.success.info":
    "We zullen het herhaalrecept voor u regelen en naar uw apotheek sturen. Als er nog vragen zijn van onze kant, nemen we contact met u op.",

  "public.registration.previousGpLetter.title": "Uitschrijven bij uw vorige huisarts",
  "public.registration.previousGpLetter":
    "Als u straks bij ons geaccepteerd wordt om patiënt te worden, kunnen we uw inschrijving pas afronden wanneer u bij uw vorige huisartsenpraktijk bent uitgeschreven. Daarom sturen wij namens u een brief.",
  "public.registration.previousGpLetter.question": "Mogen wij ook gelijk uw medisch dossier opvragen?",
  "public.registration.previousGpLetter.yes": "Ja",
  "public.registration.previousGpLetter.no":
    "Nee, ik stuur zelf een bericht aan mijn vorige huisarts voor de overdracht van mijn medisch dossier",
  "public.registration.previousGpLetter.previewButton": "Brief bekijken",
  "public.registration.previousGpApprovalTerms":
    "Ik ga ermee akkoord dat mijn vorige huisarts een bericht krijgt over mijn uitschrijving",
  "public.registration.previousGpApprovalTerms.info":
    "U kunt maar bij één huisarts ingeschreven staan. Om door te gaan met de inschrijving moet u dus akkoord gaan met de uitschrijving.",
  "public.registration.previousGpLetter.noApprovalWarning.title":
    "Let op: u heeft ons geen toestemming gegeven om uw medisch dossier op te vragen",
  "public.registration.previousGpLetter.noApprovalWarning.listItem1":
    "Als u ons geen toestemming geeft, moet u dus zelf zorgen dat uw vorige huisarts uw medisch dossier aan ons geeft.",
  "public.registration.previousGpLetter.noApprovalWarning.listItem2":
    "Om u betere zorg te kunnen geven, moeten we op de hoogte zijn van uw medische voorgeschiedenis.",

  "public.registration.previousGpSelection.title": "Vorige huisarts",
  "public.registration.previousGpSelection.description":
    "Om uw medisch dossier op te vragen bij uw vorige huisartsenpraktijk, moeten we weten welke dat is.",
  "public.registration.previousGpSelection.searchLabel": "Zoek uw vorige huisartsenpraktijk",
  "public.registration.previousGpSelection.searchPlaceholder": "Zoek op naam of adres van de praktijk",
  "public.registration.previousGpSelection.cannotFind": "Ik kan mijn vorige huisarts niet vinden",
  "public.registration.previousGpSelection.noPreviousGp": "Ik heb nooit een huisarts in Nederland gehad",

  "public.registration.process.accepted":
    "Uw inschrijving bij de praktijk is geaccepteerd. U heeft per e-mail meer informatie ontvangen.",
  "public.registration.process.rejected":
    "Uw inschrijving bij de praktijk is afgewezen. U heeft per e-mail meer informatie hierover ontvangen. Mocht u nog vragen over de afwijzing hebben, neem dan contact op met de praktijk.",
  "public.registration.process.completed":
    "Uw inschrijving bij de praktijk is afgerond. Het inschrijfproces is nu voltooid.",
  "public.registration.main.header": "Inschrijven in onze praktijk",
  "public.registration.existingPatient":
    "U bent al ingeschreven bij onze praktijk. Het is niet mogelijk om opnieuw in te schrijven.",

  // ID check V1 bullets
  "public.registration.idCheck.introduction":
    "Wij moeten uw identiteit controleren volgens de wet. Identificatie kan online (bijv. met een paspoort of rijbewijs). U hoeft dan minder gegevens in te vullen.",
  "public.registration.idCheck.introduction.short": "In het kort:",
  "public.registration.idCheck.introduction.text1":
    "MijnPraktijk en de huisartsenpraktijk bewaren het documentnummer en het type document.",
  "public.registration.idCheck.introduction.text2":
    "{provider} bewaart een kopie van uw identiteitsdocument en die wordt na {days} verwijderd.",
  "public.registration.idCheck.days": "1 dag",
  "public.registration.idCheck.introduction.text3":
    "Medewerkers van de praktijk zien alleen of uw document succesvol is gecontroleerd en hebben {noAccess} tot de kopie van uw identiteitsdocument.",
  "public.registration.idCheck.noAccess": "geen toegang",

  "public.registration.idCheck.introduction.final":
    "Als u verder gaat, gaat u akkoord met de {link1}. Lees meer over waarom wij uw identiteit controleren op de website van de {link2}.",
  "public.registration.idCheck.privacy.link": "privacy voorwaarden van onze leverancier iDenfy",
  "public.registration.idCheck.government.link": "Rijksoverheid",
  "public.registration.idCheck.agree": "Ik ga akkoord",
  "public.registration.idCheck.notAgree": "Controle identiteit overslaan",
  "public.registration.idCheck.notAgreeConfirm": "Ja, overslaan",
  "public.registration.idCheck.cancel": "Annuleer identiteit controle",
  "public.registration.idCheck.cancelConfirm": "Ja, annuleren",
  "public.registration.idCheck.areYouSure": "Weet u het zeker?",
  "public.registration.idCheck.areYouSureDescription":
    "De huisartsenpraktijk moet uw identiteit controleren.{newLine}Als u zich niet online identificeert moet u langs komen bij de praktijk om daar uw identificatiebewijs te laten zien. De praktijk kan uw inschrijving daarna pas accepteren.{newLine}Neem contact op met de praktijk ({phoneNumber}) om te horen hoe u het beste verder kunt gaan met de inschrijving.",
  "public.registration.idCheck.mandatory": "Ik kan niet online identificeren",
  "public.registration.idCheck.mandatoryTitle": "Overslaan is helaas niet mogelijk",
  "public.registration.idCheck.mandatoryDescription":
    "De huisartsenpraktijk moet uw identiteit controleren.{newLine}Wilt u online inschrijven? Dan kunt u de identificatie bij deze praktijk helaas niet overslaan.{newLine}Kunt u zich niet online identificeren, of wilt u dit niet? Dan moet u langskomen bij de praktijk. Daar kunt u zich inschrijven en uw identificatiebewijs laten zien.{newLine}Neem contact op met de praktijk via ({phoneNumber}) om te horen hoe u het beste verder kunt gaan met de inschrijving.",
  "public.registration.idCheck.accept": "Toch online identificeren",
  "public.registration.idCheck.loading": "Laden...",
  "public.registration.idCheck.processing1": "Bezig met verwerken van de informatie...",
  "public.registration.idCheck.processing2":
    "Dit kan enige tijd in beslag nemen. Even geduld a.u.b. en sluit het scherm niet.",
  "public.registration.idCheck.verificationInconsistency":
    "De gezichtsherkenning komt niet overeen met het ID. Probeer het opnieuw.",
  "public.registration.lspApproval":
    "Ik geef toestemming om mijn dossier te delen met andere zorgverleners als zij deze nodig hebben",
  "public.registration.lspApproval.explanation":
    "Bijvoorbeeld wanneer u bij de spoedeisende hulp terecht komt. Zie {link} voor meer informatie over het Landelijk Schakelpunt.",
  "public.registration.lspApproval.href": "https://www.volgjezorg.nl/het-lsp",
  "public.registration.mitzInfo.title": "Toestemming voor het delen van uw medische gegevens",
  "public.registration.mitzInfo.link.href": "https://www.mijnmitz.nl",
  "public.registration.mitzInfo.link.title": "mijnmitz.nl",
  "public.registration.mitzInfo.body":
    "Wilt u dat zorgverleners zoals de huisartsenpost, apotheek of specialist uw medische gegevens kunnen inzien? Dit regelt u zelf via Mitz. Ga naar {link} om uw toestemmingen te beheren.",
  "public.registration.mijnGezondheidNetApproval": "Ik wil een MijnGezondheid.net account voor contact met de huisarts",
  "public.registration.mijnGezondheidNetApproval.explanation": "Zie de {link} voor meer informatie.",
  "public.registration.mijnGezondheidNetApproval.link": "voorwaarden van MijnGezondheid.net",
  "public.registration.terms": "Ik heb dit formulier naar waarheid ingevuld",
  "public.registration.terms.validation.required":
    "Zonder accepteren van deze voorwaarde is het niet mogelijk om door te gaan",
  "public.registration.pharmacy.label": "Apotheek",
  "public.registration.pharmacy.info1":
    "U mag zelf een apotheek kiezen. Indien het veld hieronder een beperkte keuze aanbiedt, dan zijn dat de apotheken waarmee uw huisartsenpraktijk samenwerkt.",
  "public.registration.pharmacy.info2":
    "U mag zelf kiezen. De eerste keer dat u medicijnen ophaalt, vraagt de apotheek misschien om uw identificatie. Kijk op {link} om te zien welke apotheken dicht bij u zijn.",
  "public.registration.pharmacy.required": "U moet een apotheek kiezen",
  "public.registration.customPharmacy.other": "Andere apotheek",
  "public.registration.customPharmacy.label": "Naam andere apotheek",
  "public.registration.error.create":
    "We kunnen op het moment geen controle starten. Probeer het nog een keer. Als het probleem zich blijft voordoen, neem dan contact op met support@mijnpraktijk.nl",
  "public.registration.disabled.title": "Wij zijn gesloten voor inschrijvingen",
  "public.registration.invitationInvalid.text":
    "De link is mogelijk al gebruikt of verlopen. Neem contact op met de praktijk voor een nieuwe uitnodiging.",
  "public.overview.title.welcome": "Welkom bij {practiceName}",
  "public.overview.pages.title": "Hoe kunnen we u helpen?",
  "public.notPatient.message":
    "We herkennen deze inloggegevens niet. U kunt ons bereiken op {practicePhoneNumber}{hasRegistration, select, true { of {link} indien u nog geen patiënt bent bij ons} other {}}.",
  "public.notPatient.link": "schrijf u in als een nieuwe patiënt",

  "public.medicalResults.main.header": "Medisch dossier",
  "public.medicalResults.noResults":
    "Er zijn geen medische uitslagen om weer te geven. Het kan zijn dat sommige uitslagen niet kunnen worden getoond.",
  "public.medicalResults.possibleMissingResults":
    "Uitslagen die uw huisarts nog niet heeft vrijgegeven, of die langer dan 14 maanden geleden zijn ontvangen, worden hier niet getoond.",
  "public.medicalResults.type.label": "Type",
  "public.medicalResults.remarks": "Opmerkingen van huisarts",
  "public.medicalResults.showMore": "Toon meer",
  "public.medicalResults.showLess": "Toon minder",
  "public.medicalResults.showDetails": "Toon details",
  "public.medicalResults.letter.title": "Brieven en verwijzingen",
  "public.medicalResults.letter.introduction": "Hieronder staan twee soorten berichten:",
  "public.medicalResults.letter.introduction.line1":
    "Brieven over uw medische situatie, verstuurd door uw huisarts of andere zorgverleners",
  "public.medicalResults.letter.introduction.line2": "Verwijzingen die uw huisarts naar een specialist heeft gestuurd",
  "public.medicalResults.letter.noText": "Geen tekst beschikbaar",
  "public.medicalResults.medications.title": "Medicijnen",
  "public.medicalResults.medications.introduction": "U kunt uw herhaalmedicatie {link}.",
  "public.medicalResults.medications.introduction.link": "hier aanvragen",
  "public.medicalResults.medications.date": "Start en eind",
  "public.medicalResults.medications.prescribed": "Voorgeschreven medicijn",
  "public.medicalResults.medications.amount": "Aantal",
  "public.medicalResults.medications.startDate": "Startdatum",
  "public.medicalResults.medications.endDate": "Einddatum",
  "public.medicalResults.medications.dosage": "Dosering",
  "public.medicalResults.medications.repeatable": "Herhaalbaar",
  "public.medicalResults.lab.title": "Metingen",
  "public.medicalResults.lab.introduction": "Metingen waarvoor u bij de huisarts bent geweest komen hier te staan.",
  "public.medicalResults.lab.type": "Type",
  "public.medicalResults.lab.date": "Datum meting",
  "public.medicalResults.lab.value": "Waarde",
  "public.medicalResults.lab.deviates": "Afwijkend",
  "public.medicalResults.lab.deviates.yes": "Ja",
  "public.medicalResults.lab.deviates.no": "Nee",
  "public.medicalResults.lab.deviates.unknown": "Onbekend",
  "public.medicalResults.lab.remark": "Notitie",

  "public.allergy.title": "Allergiëen",
  "public.allergy.introduction": "Allergieën of intoleranties voor medicijnen",
  "public.allergy.substance": "Stof",
  "public.allergy.medicationAdministration": "Toedieningsweg",
  "public.allergy.note": "Notitie",
  "public.allergy.details.author": "Allergie vastgesteld door",
  "public.allergy.details.created": "Allergie vastgesteld op",
  "public.allergy.details.updated": "Laatste contact met de stof",
  "public.allergy.details.medicationAdministration": "Toedieningsweg",
  "public.allergy.details.status": "Status",
  "public.allergy.details.severity": "Ernst",
  "public.allergy.details.comment": "Notitie",

  "public.episodes.title": "Klachten en ziektes",
  "public.episodes.complaint": "Klacht of ziekte",
  "public.episodes.date": "Start en eind",
  "public.episode.title.fallback": "Klacht of ziekte",
  "public.episode.start": "Datum eerste contact",
  "public.episode.end": "Datum laatste contact",

  "public.soep.subjective": "Subjectief",
  "public.soep.objective": "Objectief",
  "public.soep.evaluation": "Evaluatie",
  "public.soep.plan": "Plan",

  "public.letters.title": "Titel",
  "public.letters.date": "Datum",
  "public.letters.sender": "Afzender",
  "public.letters.receiver": "Ontvanger",

  "public.privacy.title": "Privacyverklaring",
  "public.privacy.title.named": "Privacyverklaring {name}",

  "public.login.info": "Log in om een afspraak te maken, medicatie te bestellen of contact op te nemen met de praktijk",
  "public.login.notAvailable":
    "Het patiëntenportaal is niet beschikbaar voor {practiceName}. Via deze knop kunt u terug naar het overzicht:",
  "public.login.signup.title": "Nieuw bij {practiceName}?",
  "public.login.alternatives": "of",
  "public.login.register.title": "Verzoek tot inschrijving",
  "public.login.register.description": "Als u nog geen patiënt bent bij {practiceName}",
  "public.login.createAccount.title": "Account aanmaken",
  "public.login.createAccount.description":
    "Als u al wel bent ingeschreven bij {practiceName}, maar nog geen account heeft",
  "public.login.createAccount.info1":
    "Maak een account aan bij {practiceName} om afspraken te maken, medicatie te bestellen of contact op te nemen met de praktijk.",
  "public.login.createAccount.info2": "Vul het formulier hieronder in om een account aan te maken bij {practiceName}.",
  "public.login.createAccount.email.info":
    "Zorg ervoor dat het e-mailadres dat u invoert overeenkomt met het e-mailadres dat bij de praktijk is geregistreerd.",
  "public.login.createAccount.email.alreadyInUse": "Dit e-mailadres is al in gebruik",
  "public.login.createAccount.verification": "Klik op de link in uw e-mail",
  "public.login.createAccount.verification.info":
    "We hebben u een e-mail gestuurd.\nKlik op de link om een account aan te maken.\n\nAls u de e-mail niet kunt vinden, controleer dan uw spamfolder. {link}",
  "public.login.createAccount.verification.info.link": "Klik hier om het opnieuw te proberen.",
  "public.login.createAccount.password": "Kies een sterk wachtwoord",
  "public.login.createAccount.password.placeholder": "Typ een uniek wachtwoord",
  "public.login.createAccount.submit": "Aanmelden",
  "public.login.createAccount.unsuccessful":
    "We konden geen account voor u aanmaken omdat we uw patiëntgegevens niet konden vinden. Neem contact op met de praktijk.",
  "public.login.createAccount.accepted": "Uw account is aangemaakt",
  "public.login.createAccount.accepted.link": "Klik hier om door te gaan.",
  "public.login.createAccount.pending": "Bedankt! We controleren uw gegevens",
  "public.login.createAccount.pending.info":
    "We hebben uw gegevens ontvangen. Uw account moet nog worden geactiveerd door de praktijk. Dit gebeurt tijdens kantooruren.\n\nU kunt inloggen zodra uw account is geactiveerd door uw praktijk.\n\nHeeft u in de tussentijd een afspraak nodig of heeft u hulp nodig? Neem dan rechtstreeks contact op met de praktijk.",
  "public.login.createAccount.duplicate":
    "Er bestaat al een account met deze gegevens. {link} Bent u uw wachtwoord vergeten? Klik dan op 'Wachtwoord vergeten?' bij het inloggen.",
  "public.login.createAccount.duplicate.link": "Klik hier om in te loggen.",
  "public.login.passwordReset": "Wachtwoord opnieuw instellen",
  "public.login.passwordReset.info":
    "Vul uw e-mailadres in. U ontvangt een link om een nieuw wachtwoord in te stellen.",
  "public.login.passwordReset.sent": "Klik op de link in uw e-mail",
  "public.login.passwordReset.sent.info":
    "Als er een account is met dit e-mailadres, hebben we u een link gestuurd om een nieuw wachtwoord in te stellen.\n\nAls u de e-mail niet kunt vinden, controleer dan uw spamfolder.",
  "public.login.passwordReset.newPassword": "Kies nieuw wachtwoord",
  "public.login.passwordReset.newPassword.info":
    "Uw wachtwoord moet langer zijn dan {characterLength} karakters, moet minstens een cijfer en een speciaal karakter bevatten.",
  "public.login.passwordReset.newPassword.submit": "Wachtwoord opslaan",
  "public.login.passwordReset.successful": "Uw wachtwoord is gewijzigd",
  "public.login.passwordReset.successful.info": "Uw nieuwe wachtwoord is nu actief.\nU kunt hiermee {link}.",
  "public.login.passwordReset.successful.info.link": "inloggen op uw account",
  "public.login.passwordReset.error.expired":
    "De link om uw wachtwoord te resetten is verlopen. U kunt tijdens het inloggen 'Wachtwoord vergeten?' kiezen om uw wachtwoord opnieuw in te stellen.",
  "public.login.passwordReset.error.incorrectCode": "De verificatie code is onjuist.",
  "public.login.passwordReset.error.tooManyAttempts":
    "U heeft te vaak een onjuiste verificatie code ingevuld. Probeer het over 5 minuten opnieuw. U zult dan een nieuwe code ontvangen.",
  "public.login.passwordReset.error.duplicate": "Je hebt dit wachtwoord al eerder gebruikt. Kies een ander wachtwoord.",
  "public.login.createAccountAtPractice":
    "Indien u nog geen account heeft, kunt u dat aanvragen bij de balie in de praktijk.",
  "public.login.accountLinkStatus.pending": "Je kunt nog niet inloggen",
  "public.login.accountLinkStatus.pending.info":
    "Je account is nog niet goedgekeurd door de praktijk. Dit zou niet langer dan een paar werkdagen moeten duren. Als het langer duurt, of als je hulp nodig hebt, neem dan contact op met de praktijk.",
  "public.login.accountLinkStatus.rejected": "Je account is niet goedgekeurd",
  "public.login.accountLinkStatus.rejected.info":
    "Je kunt niet inloggen omdat je account niet is goedgekeurd door de praktijk. Neem voor verdere hulp contact op met de praktijk",
  "public.login.accountLinkStatus.inactive": "Je account is niet actief",
  "public.login.accountLinkStatus.inactive.info":
    "Je kunt niet inloggen omdat je account niet actief is. Neem voor verdere hulp contact op met de praktijk",
  "public.login.accountLinkStatus.notFound": "Je account is niet gevonden",
  "public.login.accountLinkStatus.notFound.info": "We konden je account niet vinden. Maak een nieuw account aan.",
  "public.login.accountLinkStatus.duplicate": "Je hebt al een account",
  "public.login.accountLinkStatus.duplicate.info":
    "We kunnen je account niet aanmaken, omdat er al een account bestaat met dit e-mailadres",
  "public.login.mfa.sms": "Ter verificatie is een code gestuurd naar uw telefoon als SMS, Signal of Telegram bericht.",
  "public.login.mfa.email": "Ter verificatie is een code gestuurd naar uw e-mailadres.",
  "public.login.mfa.label": "Verificatie code",
  "public.login.additionalData.description":
    "We hebben nog wat aanvullende gegevens nodig om een account aan te kunnen maken.",
  "public.login.additionalData.bsnRequired.description": "Uw BSN is nog niet bij ons bekend. Vul uw BSN hieronder in.",
  "public.login.additionalData.error.bsnInvalid":
    "Het ingevulde BSN voldoet niet aan de 11-proef. Controleer het nummer en probeer het opnieuw.",
  "public.login.additionalData.error.bsnAlreadyExists":
    "Dit BSN is al bekend bij de praktijk. Neem contact op met de praktijk om in te loggen.",
  "public.login.alreadyLoggedIn.description": "U bent al ingelogd als {fullName}.",
  "public.login.alreadyLoggedIn.options1": "Wilt u ",
  "public.login.alreadyLoggedIn.options2": "uitloggen",
  "public.login.alreadyLoggedIn.options3": " of ",
  "public.login.alreadyLoggedIn.options4": "doorgaan als {fullName}",
  "public.login.loggedOut.manually": "U bent nu uitgelogd.",
  "public.login.loggedOut.automatically": "U bent automatisch uitgelogd.",
  "public.login.expiry.idle.minutes": "U wordt over {minutes} minuten automatisch uitgelogd vanwege inactiviteit.",
  "public.login.expiry.idle.seconds": "U wordt over {seconds} seconden automatisch uitgelogd vanwege inactiviteit.",
  "public.login.expiry.token.minutes": "U wordt over {minutes} minuten automatisch uitgelogd.",
  "public.login.expiry.token.seconds": "U wordt over {seconds} seconden automatisch uitgelogd.",
  "public.login.expiry.token.extendText": "Wilt u ingelogd blijven, om de site te blijven gebruiken?",
  "public.login.expiry.token.extendButton": "Sessie verlengen",
  "public.login.sensitiveDataNotification":
    "MijnPraktijk toont uw persoonlijke gezondheidsinformatie. Wij adviseren u om hier zorgvuldig mee om te gaan en uw informatie nooit zomaar met onbekenden te delen.",

  "public.common.practiceWebsite": "Onze website",
  "public.common.contactOrEmergency": "Contact of noodgeval",
  "public.common.contact": "Contact",
  "public.common.emergency": "Spoed telefoonnummer",
  "public.common.emergencyLabel": "(alleen voor spoed)",
  "public.common.home": "Home",
  "public.common.login": "Inloggen",
  "public.common.logout": "Uitloggen",
  "public.common.footer.text": "Mogelijk gemaakt door",
  "public.common.signup": "Inschrijven bij praktijk",
  "public.common.fontSize": "Lettertype grootte",
  "public.common.help": "Help",
  "public.common.appointments": "Mijn afspraken",
  "public.common.privacy": "Privacyverklaring",
  "public.common.step": "Stap",
  "public.common.of": "van",
  "public.common.backToDashboard": "Terug naar overzicht",
  "public.common.success": "Bericht is ontvangen",

  "healthProfessional.role.GeneralPractitioner": "Huisarts",
  "healthProfessional.role.MedicalDoctor": "Basisarts",
  "healthProfessional.role.PhysicianAssistant": "Physician assistant",
  "healthProfessional.role.NurseSpecialist": "Verpleegkundig specialist",
  "healthProfessional.role.DoctorsAssistant": "Doktersassistent",
  "healthProfessional.role.PracticeSupportMentally": "POH-GGZ",
  "healthProfessional.role.PracticeSupportSomatic": "POH-Somatiek",
  "healthProfessional.role.PracticeSupportElderly": "POH-Ouderenzorg",
  "healthProfessional.role.PracticeSupportYouth": "POH-Jeugdzorg",

  "validation.uuid.invalid": "Dit is geen valide UUID",
  "validation.email.invalid": "E-mailadres is onjuist",

  "documentPreview.dub": "Documentvoorbeeld",

  "emailpreview.from": "van",
  "emailpreview.to": "aan",
  "emailpreview.date": "datum",
  "emailpreview.subject": "onderwerp",

  "textEditor.menu.sitePageLink": "Link eigen website",
  "textEditor.bold": "Vet (Ctrl+B)",
  "textEditor.italic": "Cursief (Ctrl+I)",
  "textEditor.underline": "Onderstrepen (Ctrl+U)",
  "textEditor.bulletList": "Lijst met opsommingstekens",
  "textEditor.orderedList": "Genummerde lijst",
  "textEditor.addLink": "Link invoegen/bewerken",
  "textEditor.link.removeLink": "Ontkoppelen",
  "textEditor.link.removeLink.tooltip": "Verwijdert de URL",
  "textEditor.link.text.placeholder": "Label",
  "textEditor.link.url.placeholder": "URL (bijv. https://mijnwebsite.nl)",
  "textEditor.addImage": "Afbeelding invoegen",
  "textEditor.addFile": "Bestand invoegen",
  "textEditor.align.left": "Links uitlijnen",
  "textEditor.align.center": "Centreren",
  "textEditor.align.right": "Rechts uitlijnen",
  "textEditor.table.add": "Tabel invoegen",
  "textEditor.table.delete": "Tabel verwijderen",
  "textEditor.table.addRow": "Rij toevoegen",
  "textEditor.table.removeRow": "Rij verwijderen",
  "textEditor.table.addColumn": "Kolom toevoegen",
  "textEditor.table.removeColumn": "Kolom verwijderen",
  "textEditor.table.mergeCells": "Cellen samenvoegen",
  "textEditor.toolbar": "Opmaakwerkbalk",
  "textEditor.collapse": "Editor inklappen",
  "textEditor.resetToDefault": "Terug naar de standaardtekst",

  "multiSelectInput.moreSelected": "{count} meer geselecteerd",
  "multiSelectInput.removeTag": "{label} verwijderen",

  "general.uncategorizedError.message":
    "Het ligt niet aan jou. Probeer het later vandaag nog eens. Blijft het fout gaan? Geef dan deze error code aan ons door: {code}",

  "patients.swaplist.title": "Patiënten ruilen",
  "patients.swaplist.checklist.1": "Zijn nu bij u ingeschreven",
  "patients.swaplist.checklist.2": "Wonen niet (meer) in uw postcodegebied",
  "patients.swaplist.checklist.3": "Wonen in een postcodegebied waar een huisarts zit die patiënten aanneemt",
  "patients.swaplist.description.1": "Onderstaande patiënten",
  "patients.swaplist.description.2":
    "Selecteer de patiënten die u zou willen ruilen en schrijf ze in bij een open praktijk.",
  "patients.swaplist.patients": "Patiënten",
  "patients.swaplist.filter.messagesSent.label": "Berichten verzonden",
  "patients.swaplist.filter.messagesSent.0": "Geen berichten verzonden",
  "patients.swaplist.filter.messagesSent.1": "1 bericht verzonden",
  "patients.swaplist.filter.messagesSent.2": "2 berichten verzonden",
  "patients.swaplist.filter.messagesSent.3": "3 of meer berichten verzonden",
  "patients.swaplist.table.patient": "Patiënt",
  "patients.swaplist.table.address": "Huidige gegevens",
  "patients.swaplist.table.practices": "Mogelijke praktijken",
  "patients.swaplist.table.status": "Status",
  "patients.swaplist.table.status.pending":
    "{count, plural, =1 {E-mail bezig met verzenden} other {# E-mails bezig met verzenden}}",
  "patients.swaplist.table.status.success": "{count, plural, =1 {E-mail verzonden} other {# E-mails verzonden}}",
  "patients.swaplist.table.status.error":
    "{count, plural, =1 {E-mail verzenden is mislukt} other {# Het verzenden van e-mails is mislukt}}",
  "patients.swaplist.actions.count": "{count, plural, =1 {# patiënt geselecteerd} other {# patiënten geselecteerd}}:",
  "patients.swaplist.actions.delete": "Verwijderen",
  "patients.swaplist.actions.sendEmail": "Mail sturen",
  "patients.swaplist.actions.sendLetter": "Brief sturen",
  "patients.swaplist.email.preview.title": "Email voorbeeld ter illustratie",
  "patients.swaplist.email.description":
    "Stuur de geselecteerde patiënten een email om hen te verzoeken zich in te schrijven bij een andere praktijk. We hebben een opzetje gemaakt, die je kan aanpassen alvorens het te verzenden.",
  "patients.swaplist.email.form.recipients": "Ontvangers",
  "patients.swaplist.email.form.subject": "Onderwerp",
  "patients.swaplist.email.breadcrumbs.1": "Patiënten",
  "patients.swaplist.email.breadcrumbs.2": "Patiënten ruilen",
  "patients.swaplist.email.breadcrumbs.3": "Mail sturen",
  "patients.swaplist.email.bcc": "BCC",
  "patients.swaplist.email.removeRecipient": "Verwijder {recipient} uit ontvangers",
  "patients.swaplist.email.sendFailed": "De mail kon niet verstuurd worden. Probeer het opnieuw.",
  "patients.swaplist.email.recipientWithoutEmail": "Deze patiënt heeft geen e-mailadres en ontvangt dus geen mail.",
  "patients.swaplist.email.skippedRecipients":
    "{count, plural, =1 {# geselecteerde patiënt heeft} other {# geselecteerde patiënten hebben}} geen e-mailadres. Deze worden overgeslagen bij het versturen.",
  "patients.swaplist.email.noRecipientsWithEmail":
    "Geen van de geselecteerde patiënten heeft een e-mailadres, dus er kan geen mail verstuurd worden. Ga terug naar de lijst en selecteer patiënten met een e-mailadres.",
  "patients.swaplist.filter.creationTime.label": "Aangemaakt",
  "patients.swaplist.filter.creationTime.0": "Ouder dan een jaar",
  "patients.swaplist.filter.creationTime.7": "Afgelopen 7 dagen",
  "patients.swaplist.filter.creationTime.30": "Afgelopen 30 dagen",
  "patients.swaplist.filter.creationTime.365": "Afgelopen 365 dagen",
  "patients.swaplist.filter.targetPractices.label": "Andere praktijk",
  "patients.swaplist.filter.practiceAvailability.label": "Andere praktijk beschikbaar",
  "patients.swaplist.filter.practiceAvailability.available": "Praktijk beschikbaar",
  "patients.swaplist.filter.practiceAvailability.notAvailable": "Geen praktijk beschikbaar",
  "patients.swaplist.filter.postalCodeArea.label": "Postcodegebied",
  "patients.swaplist.filter.postalCodeArea.in": "Binnen postcodegebied praktijk",
  "patients.swaplist.filter.postalCodeArea.out": "Buiten postcodegebied praktijk",

  "patients.swaplist.removeconfirmation.title": "Deze patiënt(en) verwijderen?",
  "patients.swaplist.removeconfirmation.content.0":
    "Wanneer je een patiënt hier verwijdert, verdwijnt deze alleen uit deze lijst met te ruilen patiënten.",
  "patients.swaplist.removeconfirmation.content.1":
    "Staat de patiënt ook ergens anders in MijnPraktijk? Dan blijft de patiënt daar bestaan.",

  "stepbuttons.prev": "Vorige",
  "stepbuttons.next": "Volgende",

  "admin.maintenanceBanners.title": "Onderhoudsbanners",
  "admin.maintenanceBanners.create": "Banner",
  "admin.maintenanceBanners.create.title": "Nieuwe banner aanmaken",
  "admin.maintenanceBanners.edit.title": "Banner bewerken",
  "admin.maintenanceBanners.column.title": "Titel",
  "admin.maintenanceBanners.column.type": "Type",
  "admin.maintenanceBanners.column.status": "Status",
  "admin.maintenanceBanners.column.schedule": "Gepland",
  "admin.maintenanceBanners.column.targeting": "Locatie",
  "admin.maintenanceBanners.column.actions": "Acties",
  "admin.maintenanceBanners.form.intro":
    "Een onderhoudsbanner staat bovenaan het portaal van alle gebruikers van MijnPraktijk. Je kunt het gebruiken voor aankondigingen, onderhoud of een storing. Active banners worden automatisch getoond binnen een minuut.",
  "admin.maintenanceBanners.form.title": "Titel",
  "admin.maintenanceBanners.form.title.maxLength": "Titel moet korter zijn dan 300 karakters",
  "admin.maintenanceBanners.form.isEnabled": "Actief",
  "admin.maintenanceBanners.form.isEnabled.info":
    "Een banner wordt alleen getoond als deze actief is. Je kunt banners voorbereiden en ze later activeren.",
  "admin.maintenanceBanners.form.type": "Type",
  "admin.maintenanceBanners.form.from": "Van",
  "admin.maintenanceBanners.form.to": "Tot",
  "admin.maintenanceBanners.form.target": "Toon de banner...",
  "admin.maintenanceBanners.form.area": "... op deze delen van het portaal...",
  "admin.maintenanceBanners.form.his": "... als de praktijk deze HIS heeft...",
  "admin.maintenanceBanners.form.targetHis": "HIS",
  "admin.maintenanceBanners.form.targetHis.placeholder": "Laat leeg voor alle HIS systemen",
  "admin.maintenanceBanners.form.practices": "... alleen bij deze praktijken...",
  "admin.maintenanceBanners.form.practices.placeholder": "Laat leeg voor alle praktijken",
  "admin.maintenanceBanners.form.practices.info":
    "Laat leeg voor alle praktijken. Ingevulde voorwaarden gelden tegelijk: een banner verschijnt alleen bij praktijken die aan alle ingevulde voorwaarden voldoen.",
  "admin.maintenanceBanners.targeting.practices": "{count, plural, one {# praktijk} other {# praktijken}}",
  "admin.maintenanceBanners.targeting.caregivers": "Zorgverleners",
  "admin.maintenanceBanners.targeting.caregivers.short": "Zorgverleners",
  "admin.maintenanceBanners.targeting.patientRegistrations": "Patiënt: Online registratie",
  "admin.maintenanceBanners.targeting.patientRegistrations.short": "Registraties",
  "admin.maintenanceBanners.targeting.patientGeneral": "Patiënt: Alles behalve registratie",
  "admin.maintenanceBanners.targeting.patientGeneral.short": "Patiënten",
  "admin.maintenanceBanners.type.info": "Informatief",
  "admin.maintenanceBanners.type.success": "Succes",
  "admin.maintenanceBanners.type.warning": "Waarschuwing",
  "admin.maintenanceBanners.type.error": "Foutmelding",
  "admin.maintenanceBanners.status.visible": "Zichtbaar",
  "admin.maintenanceBanners.status.inactive": "Inactief",
  "admin.maintenanceBanners.status.scheduled": "Gepland",
  "admin.maintenanceBanners.status.expired": "Verlopen",
  "admin.maintenanceBanners.create.success": "Banner aangemaakt",
  "admin.maintenanceBanners.update.success": "Banner aangepast",
  "admin.maintenanceBanners.delete.title": "Banner verwijderen",
  "admin.maintenanceBanners.delete.confirmation": "Dit verwijdert de banner en kan niet ongedaan worden gemaakt.",
  "admin.maintenanceBanners.form.setToCurrentDay": "Zet op vandaag",
  "admin.maintenanceBanners.scheduled": "Zichtbaar",
  "admin.maintenanceBanners.scheduledEnd": "Niet meer zichtbaar",

  "admin.telephonyTenants.title": "Telefonie-accounts",
  "admin.telephonyTenants.intro":
    "Elk account is een Univerge Blue (Elevate) account waarop praktijken hun terugbelverzoeken plaatsen. Praktijken worden aan een account gekoppeld via Telefoon → Algemeen in de praktijkinstellingen.",
  "admin.telephonyTenants.create": "Account",
  "admin.telephonyTenants.create.title": "Nieuw telefonie-account",
  "admin.telephonyTenants.create.success": "Telefonie-account aangemaakt",
  "admin.telephonyTenants.edit.title": "Telefonie-account bewerken",
  "admin.telephonyTenants.update.success": "Telefonie-account aangepast",
  "admin.telephonyTenants.delete.title": "Telefonie-account verwijderen",
  "admin.telephonyTenants.delete.confirmation":
    "Dit verwijdert het account en zijn inloggegevens. Het standaardaccount en accounts met gekoppelde praktijken kunnen niet worden verwijderd.",
  "admin.telephonyTenants.delete.success": "Telefonie-account verwijderd",
  "admin.telephonyTenants.recreateSubscription": "Webhook opnieuw registreren",
  "admin.telephonyTenants.recreateSubscription.success": "Webhook opnieuw geregistreerd",
  "admin.telephonyTenants.column.name": "Naam",
  "admin.telephonyTenants.column.clientId": "OAuth client-id",
  "admin.telephonyTenants.column.practices": "Praktijken",
  "admin.telephonyTenants.column.webhook": "Webhook",
  "admin.telephonyTenants.column.actions": "Acties",
  "admin.telephonyTenants.default": "Standaard",
  "admin.telephonyTenants.practices.none": "Geen praktijken",
  "admin.telephonyTenants.webhook.up": "Actief",
  "admin.telephonyTenants.webhook.down": "Niet actief",
  "admin.telephonyTenants.webhook.expires": "Verloopt {date}",
  "admin.telephonyTenants.webhook.none": "Geen abonnement geregistreerd",
  "admin.telephonyTenants.form.name": "Naam",
  "admin.telephonyTenants.form.clientId": "OAuth client-id",
  "admin.telephonyTenants.form.clientId.info":
    "Van de OAuth-applicatie waarmee toestellen worden gekoppeld. Wordt bij het opslaan bij Univerge Blue gecontroleerd.",
  "admin.telephonyTenants.form.clientSecret": "OAuth client-secret",
  "admin.telephonyTenants.form.serviceId": "Service client-id",
  "admin.telephonyTenants.form.serviceId.info":
    "Van de service-applicatie (client credentials) voor de notificaties-API. Wordt bij het opslaan bij Univerge Blue gecontroleerd.",
  "admin.telephonyTenants.form.serviceSecret": "Service client-secret",
  "admin.telephonyTenants.form.secret.unchanged": "Laat leeg om ongewijzigd te laten",
  "admin.telephonyTenants.form.secrets.info":
    "Geheimen worden versleuteld opgeslagen en nooit meer getoond. De webhook-sleutel wordt automatisch gegenereerd.",

  "onboarding.welcome.title": "Welkom bij MijnPraktijk",
  "onboarding.welcome.intro":
    "Wij stroomlijnen het werk in de praktijk, zodat jij meer rust en ruimte krijgt voor het mensenwerk.",
  "onboarding.email.label": "E-mailadres",
  "onboarding.password.label": "Kies een wachtwoord",
  "onboarding.password.inputInfo": "Minimaal {characterLength} karakters. Ten minste 1 cijfer en 1 speciaal teken",
  "onboarding.password.action": "Wachtwoord instellen",
  "onboarding.mfa.title": "Super! Laatste stap:",
  "onboarding.error.info": "Er is iets misgegaan. Je kunt het opnieuw proberen of terug naar de login pagina",
  "onboarding.continue.info": "Welkom terug! Je hebt je wachtwoord al ingesteld. Log in om verder te gaan.",
  "onboarding.complete.title": "Gelukt!",
  "onboarding.complete.info":
    "Je hebt je account geactiveerd.\n\nJe blijft de authenticator app nodig hebben om in te loggen, dus verwijder deze niet.",

  "onboarding.item.moreInfo": "Meer informatie",
  "onboarding.todoCount": "{count, plural, one {# to-do} other {# to-do's}}",

  "test.icpcCode": "ICPC code **THIS IS ONLY USED IN TESTS**",
  "test.hintComponent": "Translated hint",
  "test.phoneNumber": "Telefoonnummer",
  "test.email": "E-mailadres",
  "test.firstName": "Voornaam",
  "test.lastName": "Achternaam",
  "test.countryOfBirth": "Geboorteland",
  "test.practiceAgb": "Praktijk AGB-code",
  "test.firstName.placeholder": "Type je voornaam",
  "test.lastName.placeholder": "Type je achternaam",
  "test.email.placeholder": "Type je e-mailadres",
  "test.phoneNumber.placeholder": "Type je telefoonnummer",
  "test.bsn.placeholder": "Type je burgerservicenummer (BSN)",

  "test.managedForm.dropdown": "Dit is een dropdown",
  "test.managedForm.checkbox": "Checkboxes (kies meerdere)",
  "test.managedForm.radio": "Radio opties (kies één)",

  "reminder.snooze.title": "Pauzeren of uitschrijven?",
  "reminder.snooze.description":
    "Op dit moment ontvang je elke maand een e-mail van ons, met de vraag: is er inmiddels plek voor nieuwe patiënten?",
  "reminder.snooze.question": "Wil je deze e-mail:",
  "reminder.snooze.pause": "Pauzeren",
  "reminder.snooze.pauseDuration": "voor de komende 6 maanden",
  "reminder.snooze.unsubscribe": "Niet meer ontvangen",
  "reminder.snooze.success.title": "Gelukt!",
  "reminder.snooze.success.description.6months": "De herinneringsmail wordt de komende 6 maanden gepauzeerd.",
  "reminder.snooze.success.description.forever": "Je bent uitgeschreven voor deze herinneringsmail.",

  // ErrorCode API errors (ErrorCodeException)
  "error.AppointmentCreationClosed": "Het maken van afspraken is gesloten",
  "error.AppointmentSlotUnavailable":
    "Dit tijdstip is helaas net geboekt en niet meer beschikbaar. Kies een ander tijdstip.",
  "error.PatientNotLinkedToHis":
    "Deze patiënt is niet gekoppeld aan een patiënt in het HIS, dus de afspraak kan niet in het HIS worden gemaakt.",
  "error.CivilRegistryRecheckCooldown":
    "Deze inschrijving is net bij SBV-Z gecontroleerd. Probeer het over een halve minuut opnieuw.",
  "error.CommunicationLogAccessDenied": "Geen toegang tot de logs",
  "error.DashboardDatabaseBuildRunning":
    "Er wordt al een dashboard opgebouwd. Probeer het over een paar minuten opnieuw.",
  "error.DashboardDatabaseNotBuilt": "De gegevens voor deze zorggroep zijn nog niet klaar. Kijk later nog eens.",
  "error.DuplicatePassword": "Dit wachtwoord is al eerder gebruikt",
  "error.DuplicateUserInvitation": "Er bestaat al een actieve uitnodiging voor deze naam en dit e-mailadres.",
  "error.EconsultLinkCallerNumberInvalid": "Het nummer van de beller is anoniem of ongeldig",
  "error.EconsultLinkCallerNumberNotMobile": "Het nummer van de beller is geen mobiel nummer",
  "error.EconsultLinkTemplateDisabled": "Het SMS-sjabloon voor de e-consult link is uitgeschakeld voor deze praktijk",
  "error.EconsultLinkSmsFailed": "De SMS kon niet worden verstuurd. Probeer het opnieuw.",
  "error.EconsultPatientMissingPhoneNumber": "Er is geen telefoonnummer van u bekend",
  "error.EmailDomainBlocked":
    "Dit e-mailadres gebruikt een domein dat niet is toegestaan. Neem contact op met de afzender van de uitnodiging.",
  "error.EmailNotDeliverable":
    "Dit e-mailadres bevat speciale tekens (zoals accenten) die wij niet kunnen versturen. Gebruik een adres zonder accenten.",
  "error.InvitationAccountAlreadyExists":
    "Je hebt met deze link al een account aangemaakt — log in om het te koppelen.",
  "error.HISLogout": "U bent uitgelogd uit het HIS",
  "error.IdentificationCheckError": "De identiteitscontrole kon niet worden gestart",
  "error.InvitationNotRedeemable": "Deze uitnodigingslink is niet meer geldig",
  "error.InvitationRecipientMismatch": "Deze uitnodigingslink is naar een ander e-mailadres verstuurd",
  "error.LoginInactiveUser": "Dit account is niet actief",
  "error.FileContentTypeNotAllowed": "Dit bestandstype is niet toegestaan.",
  "error.FileTooLarge": "Dit bestand is te groot. De maximale grootte is {maxMb}MB.",
  "error.ImageDimensionsTooLarge": "De afmetingen van deze afbeelding zijn te groot.",
  "error.ImageProcessingFailed":
    "Deze afbeelding kon niet worden verwerkt. Mogelijk is het bestand beschadigd of te groot.",
  "error.MaintenanceBannerPracticeUnknown":
    "Een of meer van de geselecteerde praktijken bestaan niet meer. Herlaad de pagina en kies de praktijken opnieuw",
  "error.NoAgendaConfigured": "Er zijn geen agenda's geconfigureerd",
  "error.NOT_CURRENT_QUESTION":
    "De vragenlijst is niet meer synchroon. We proberen u naar de juiste vraag te navigeren.",
  "error.PatientAccountDuplicateEmail": "Dit e-mailadres is al in gebruik",
  "error.PatientAccountEmailAlreadyInUse": "Dit e-mailadres is al in gebruik",
  "error.PatientAccountInvalidCredentials": "De inloggegevens zijn onjuist",
  "error.PatientAccountInvalidCredentialsMfa": "De inloggegevens of verificatiecode zijn onjuist",
  "error.PatientAccountLoginAttemptsExceeded": "Te veel inlogpogingen",
  "error.PatientAccountLoginExpired": "Uw sessie is verlopen",
  "error.PatientAccountMfaSmsFailed":
    "De verificatiecode kon niet naar uw telefoon worden verstuurd. Probeer het opnieuw. Lukt dat niet, neem dan contact op met de praktijk.",
  "error.PatientAccountPasswordResetExpired": "De link om uw wachtwoord te resetten is verlopen",
  "error.PatientAccountSmsAttemptsExceeded": "Te veel sms-pogingen",
  "error.PatientAccountSmsIncorrectCode": "De ingevoerde sms-code is onjuist",
  "error.PatientBSNAlreadyExists": "Er is al een patiënt met dit BSN-nummer bekend",
  "error.PatientBSNInvalid": "Het BSN-nummer voldoet niet aan de 11-proef",
  "error.PatientFileLinkAlreadyLinked": "Dit dossier is al gekoppeld aan dit hoofddossier",
  "error.PatientFileLinkMainIsDuplicate":
    "Dit dossier is zelf een dubbel dossier. Kies het hoofddossier waaraan het gekoppeld is.",
  "error.PatientFileLinkMainNotActive": "Het hoofddossier is niet meer ingeschreven bij deze praktijk",
  "error.PatientFileLinkNotLinked": "Dit dossier is niet gekoppeld aan een hoofddossier",
  "error.PatientFileLinkOtherPractice": "Je kunt alleen dossiers binnen dezelfde praktijk aan elkaar koppelen",
  "error.PatientFileLinkSelf": "Een dossier kan geen dubbel dossier van zichzelf zijn",
  "error.PhonePracticeHasNoTenant":
    "Deze praktijk heeft nog geen telefonie-account. Wijs er eerst een toe bij de algemene telefooninstellingen.",
  "error.PhoneTenantCredentialsUnverifiable":
    "De gegevens konden niet bij Elevate gecontroleerd worden. Probeer het later opnieuw.",
  "error.PhoneTenantHasPractices":
    "Deze tenant is nog gekoppeld aan {practiceCount} praktijk(en). Koppel die eerst aan een andere tenant.",
  "error.PhoneTenantIsDefault":
    "De standaardtenant kan niet verwijderd worden zolang er andere tenants zijn: telefoniemeldingen zonder tenant komen bij de standaardtenant binnen",
  "error.PhoneTenantNameTaken": "Er bestaat al een telefonietenant met de naam {name}",
  "error.PhoneTenantOauthCredentialsRejected": "Elevate heeft de OAuth-gegevens afgekeurd: {detail}",
  "error.PhoneTenantServiceCredentialsRejected": "Elevate heeft de servicegegevens afgekeurd: {detail}",
  "error.PhoneTenantStoredSecretUnreadable":
    "Een opgeslagen geheim van dit paar is niet meer leesbaar. Voer zowel het id als het geheim opnieuw in om het paar te vervangen.",
  "error.PhoneTenantWebhookRegistrationFailed": "Het registreren van de webhook bij Elevate is mislukt: {detail}",
  "error.PostalCodeP4DoesNotExist": "Deze postcode bestaat niet",
  "error.PracticeConfigurationAccessDenied": "Geen beheerrechten (meer) voor deze praktijk",
  "error.PracticeRegistrationAgbUnknown":
    "AGB-code {agbCode} is geen bekende praktijk-AGB-code. Kies een praktijk uit de lijst — een persoonlijke AGB-code van een huisarts werkt niet",
  "error.RegistrationAlreadyCreated": "Er is al een registratieverzoek ingediend",
  "error.RegistrationClosed": "De registratie is gesloten",
  "error.RegistrationHisCannotReceive":
    "Het HIS van deze praktijk kan geen inschrijvingen ontvangen, er is dus niets te verzenden. Schrijf deze persoon handmatig in het HIS in.",
  "error.RegistrationHisFailed": "Registratie in het HIS is mislukt",
  "error.RegistrationRequestAcceptedHisKnown": "U bent al bekend in het systeem",
  "error.RegistrationRequestCompletedHisUnknown": "U bent niet bekend in het systeem",
  "error.RegistrationRequestDuplicateActive":
    "Deze persoon heeft al een openstaande inschrijving of is al patiënt in deze praktijk",
  "error.RegistrationRequestExistingPatient": "U bent al geregistreerd als patiënt",
  "error.ReregistrationHisUnknown": "U bent niet bekend in het systeem",
  "error.PatientSwapFileImportedElsewhere":
    "Dit bestand is al geïmporteerd bij een andere praktijk. Upload het bestand opnieuw om het bij deze praktijk te importeren.",
  "error.SwapListNoRecipientsWithEmail":
    "Geen van de geselecteerde patiënten heeft een e-mailadres, dus er kan geen mail verstuurd worden.",
  "error.UnsupportedImportFile": "Alleen CSV- en Excel-bestanden (.xlsx) worden ondersteund",
  "error.UsernameAlreadyInUse": "Deze gebruikersnaam is al in gebruik",
  "error.UziCertificatePublicUnreadable": "Het publieke bestand kon niet gelezen worden",
  "error.UziCertificateIssuerNotAccepted": "Dit is geen UZI- of PKIoverheid-certificaat",
  "error.UziCertificatePrivateUnreadable": "Het geheime bestand kon niet gelezen worden",
  "error.UziCertificateKeyPairMismatch": "Het publieke en geheime bestand horen niet bij elkaar",
  "error.CivilRegistryCheckDisabled":
    "SBV-Z-controles staan uit voor deze praktijk. Zet ze eerst aan in de instellingen.",
  "error.CivilRegistryCheckNoUsableUziCertificate":
    "Deze praktijk heeft geen geldig UZI-servercertificaat, dus SBV-Z kan niet worden geraadpleegd. Upload er eerst een in de instellingen.",
  "error.VecozoCovPermissionDenied": "Vecozo-toestemming voor COV is niet verleend",
  "error.VecozoIonPermissionDenied": "Vecozo-toestemming voor ION is niet verleend voor AGB-code {agbCode}",
  "error.VecozoUnavailable": "Vecozo is niet bereikbaar, probeer het later opnieuw",
  "error.WalkInConsultCreationClosed": "Het inloopspreekuur is gesloten",
  "error.WalkInConsultCreationQueueFull": "De wachtrij voor het inloopspreekuur is vol",
  "error.loginInvalidCredentials": "De inloggegevens zijn onjuist",
  "error.loginInvalidCredentialsTotp": "De inloggegevens of verificatiecode zijn onjuist",
  "error.mfaCallNotAllowed": "MFA-oproep niet toegestaan",
  "error.mfaContextMismatch": "MFA-sessie komt niet overeen",
  "error.mfaDeliveryCooldown": "Wacht even voordat u een nieuwe verificatiecode aanvraagt",
  "error.mfaDeliveryFailed": "Het versturen van de verificatiecode is mislukt. Probeer het later opnieuw",
  "error.mfaInvalidToken": "Ongeldige verificatiecode",
  "error.mfaMaxAttemptsReached": "Te veel verificatiepogingen",
  "error.mfaSessionExpired": "MFA-sessie verlopen",
  "error.mfaSessionNotFound": "MFA-sessie niet gevonden",

  // Zod validation errors
  "error.email": "Dit is geen geldig e-mailadres",
  "error.stringLength": "Er moet een waarde ingevuld zijn",
  "error.dateTime.future": "Moet een datum in de toekomst zijn",

  "error.generic.name.min": `Naam/ID moet minimaal ${NAME_MIN_LENGTH} tekens zijn`,
  "error.generic.name.max": `Naam/ID mag maximaal ${NAME_MAX_LENGTH} tekens zijn`,
  // Generic Zod issue translations, keyed by ZodIssueCode.
  // Available variables per code come from the Zod issue metadata.
  "error.zod.required": "{field} is verplicht",
  "error.zod.too_small": "{field} moet minimaal {minimum, plural, one {# teken} other {# tekens}} bevatten",
  "error.zod.too_big": "{field} mag maximaal {maximum, plural, one {# teken} other {# tekens}} bevatten",
  "error.zod.invalid_type": "{field} is ongeldig",
  "error.zod.invalid_format": "{field} heeft een ongeldig formaat",
  "error.zod.invalid_value": "{field} heeft een ongeldige waarde",
  "error.zod.not_multiple_of": "{field} moet een veelvoud zijn van {divisor}",
  "error.zod.unrecognized_keys": "Onbekende velden ontvangen",
  "error.zod.invalid_union": "{field} is ongeldig",
  "error.zod.invalid_key": "{field} bevat een ongeldige sleutel",
  "error.zod.invalid_element": "{field} bevat een ongeldig element",
  "error.zod.custom": "{field} is ongeldig",
  "error.zod.field.default": "Veld",

  // Domain type validation errors
  "login.username.info": "Minimaal 5 tekens, zonder '@' of andere speciale symbolen.",
  "error.usernameMinLength": "Gebruikersnaam moet minimaal 5 tekens zijn",
  "error.usernameMaxLength": "Gebruikersnaam mag maximaal 64 tekens zijn",
  "error.usernameInvalidChars": "Gebruikersnaam bevat ongeldige tekens",
  "error.usernameReserved": "Deze gebruikersnaam is gereserveerd",
  "error.usernameAlreadyInUse": "Deze gebruikersnaam is al in gebruik",
  "error.emailOrUsernameRequired": "E-mailadres of gebruikersnaam is verplicht",
  "error.customQuestion.required": "Dit veld is verplicht",
  "error.customQuestion.selectOption": "Selecteer een optie",
  "error.customQuestion.checkboxRequired": "Selecteer minimaal een optie",
  "error.phoneNumber.invalid": "Ongeldig telefoonnummer",
  "error.phoneNumber.invalidRegion": "Telefoonnummer moet uit regio {region} komen",
  "error.phoneNumber.landlineNotAllowed": "Vaste telefoonnummers zijn niet toegestaan",
  "error.bsn.invalid": "Ongeldig BSN",
  "error.agbCode.invalid": "Ongeldige AGB-code",
  "error.country.invalid": "Ongeldig land",
  "error.fullName.invalid": "Ongeldige naam",
  "error.gender.invalid": "Ongeldig geslacht",
  "error.postalCode.invalid": "Ongeldige postcode",
  "error.postalCode.p6Format": "Postcode moet in het P6-formaat zijn (bijv. 1234AB)",
  "error.dayDate.invalid": "Ongeldige datum",
  "error.dayDate.minimumAge": "Je moet minimaal {minimumAge, plural, one {# jaar} other {# jaar}} oud zijn",
  "error.dayDate.afterDate": "Geboortedatum moet na 01-01-1900 zijn",
  "error.token.onlyDigits": "De code mag alleen cijfers bevatten",
  "error.token.length": "De code moet uit {length, plural, one {# cijfer} other {# cijfers}} bestaan",
  "error.slug.minLength": `Het webadres moet minimaal ${MIN_SLUG_LENGTH} teken zijn`,
  "error.slug.maxLength": `Het webadres mag maximaal ${MAX_SLUG_LENGTH} tekens zijn`,
  "error.slug.reserved": "Het webadres is niet toegestaan",

  "error.login.totp.validation": "De code moet 6 cijfers bevatten",

  "error.page.minLimit": `Minimale limiet is ${MIN_LIMIT}`,
  "error.page.maxLimit": `Maximale limiet is ${MAX_LIMIT}`,
  "error.patientSwap.page.maxLimit": `Maximale limiet is ${SWAP_LIST_MAX_LIMIT}`,
  "error.page.offset": `Offset moet minimaal 0 zijn`,
  "error.page.search": `Zoekterm mag niet langer zijn dan ${MAX_QUERY_LENGTH}`,

  "error.plato.openAnswer": "Er moet een vrij antwoord meegestuurd worden",
}
